export default {
    "de": {
        "pagedefinitions": {
            "about": {
                "metaTags": {
                    "description": "Hier finden Sie Informationen zu jobs2share",
                    "keywords": "jobs2share, Saisonstellen"
                },
                "path": "Über jobs2share",
                "title": "Über jobs2share"
            },
            "agb": {
                "metaTags": {
                    "description": "Hier finden Sie die Datenschutzbestimmungen und die Allgemeinen Geschäftsbedingungen von jobs2share.",
                    "keywords": "agb, datenschutz"
                },
                "path": "agb",
                "title": "Datenschutzbestimmungen und AGBs"
            },
            "careerday": {
                "metaTags": {
                    "description": "Komm vorbei, lerne spannende Betriebe kennen und sichere Dir vielleicht schon Deine nächste Saisonstelle.",
                    "keywords": "careerday, Karriere"
                },
                "path": "careerday",
                "title": "Mitarbeiter-Sharing Career Day"
            },
            "employee": {
                "path": "arbeitnehmende"
            },
            "employer": {
                "path": "arbeitgeber"
            },
            "findAJob": {
                "metaTags": {
                    "description": "Arbeiten mit viel Abwechslung und Abenteuer: Kombinieren Sie zwei spannende Saisonstellen zu einer Ganzjahresperspektive, die zu Ihnen passt.",
                    "keywords": "Saisonjob, Job, Sommerjobs"
                },
                "path": "job-finden",
                "title": "Sommer- und Winterjobs kombinieren und profitieren"
            },
            "furtherEducation": {
                "metaTags": {
                    "description": "Nutzen Sie ihre Zwischensaisons für persönliche Weiterbildungen bei unseren Partnern. Finden Sie hier etwas Passendes.",
                    "keywords": "Weiterbildungsmöglichkeiten, Sprachkurse, Zwischensaison Weiterbildung"
                },
                "path": "weiterbildung",
                "title": "Weiterbildungen in den Zwischensaisons"
            },
            "home": {
                "metaTags": {
                    "description": "Jobs2share bündelt Sommer- und Winter-Saisonstellen zu spannenden Ganzjahresperspektiven und bringt Fachkräfte und Arbeitgeber unkompliziert zusammen.",
                    "keywords": "Stellenangebote, Job, Jobs"
                },
                "title": "Ganzjahresperspektive dank Mitarbeiter-Sharing"
            },
            "howItWorks": {
                "path": "so-funktionierts"
            },
            "impress": {
                "metaTags": {
                    "description": "Hier finden Sie das Impressum von jobs2share",
                    "keywords": "Impressum"
                },
                "path": "impressum",
                "title": "Impressum"
            },
            "jobAdvertisement": {
                "metaTags": {
                    "description": "Rekrutieren Sie auf neuem Level: Hier gewinnen und binden Sie Saisonpersonal mit modernsten HR-Tools. Bieten Sie mehr als nur einen Saisonjob.",
                    "keywords": "Inserate gratis, gratis Inserate, Jobs"
                },
                "path": "personal-finden",
                "title": "Saisonpersonal mit jobs2share finden und binden"
            },
            "jobs": {
                "metaTags": {
                    "description": "Arbeiten mit viel Abwechslung und Abenteuer: Kombinieren Sie zwei spannende Saisonstellen zu einer Ganzjahresperspektive, die zu Ihnen passt.",
                    "keywords": "Saisonstelle, Stelle finden"
                },
                "title": "Sommer- und Winterjobs kombinieren und profitieren"
            },
            "rulesOfTheGame": {
                "metaTags": {
                    "description": "User der Plattform jobs2share bekennen sich zu einem fairen Umgang untereinander im Sinne einer nutzenstiftenden Kooperation.",
                    "keywords": "Spielregeln, Fair Play, Verpflichtung, Abwerben, Kooperation"
                },
                "path": "spielregeln",
                "title": "Spielregeln „Fair Play“"
            },
            "secoPilotEmployee": {
                "metaTags": {
                    "description": "Auf jobs2share gibt’s nicht nur top Sommer- und Winterjobs, sondern auch Lösungen zur Überbrückung der Zwischensaison – dank einem SECO-Pilotprojekt.",
                    "keywords": "SECO-Pilot, Arbeitslosengeld Zwischensaison, Lösung Zwischensaison"
                },
                "path": "seco-pilot",
                "title": "Zwischensaison überbrücken – so geht’s"
            },
            "secoPilotEmployer": {
                "metaTags": {
                    "description": "Auf jobs2share gibt’s nicht nur top Sommer- und Winterjobs, sondern auch Lösungen zur Überbrückung der Zwischensaison – dank einem SECO-Pilotprojekt.",
                    "keywords": "SECO-Pilot, Arbeitslosengeld Zwischensaison, Lösung Zwischensaison"
                },
                "path": "seco-pilot",
                "title": "Zwischensaison überbrücken – so geht’s"
            }
        },
        "content": {
            "advantagesEmployee": {
                "label": "Vorteile",
                "text1": "Das Leben ist zu kurz für einen langweiligen Job. Auf jobs2share finden Sie Sommer- und Winter-Jobs, die zu Ihnen passen. Ganz nebenbei können Sie die schönsten Regionen der Schweiz kennenlernen, Ihre Karriere boosten, neue Freunde gewinnen und Ihre Sprachkompetenzen verbessern. Mitarbeitende mit einem Sommer-Winter-Jobpaket profitieren von {0} und von einem erleichterten Zugang zu {1} Das einfache Bewerbungstool ermöglicht es Ihnen, mit wenigen Klicks eine professionelle Bewerbung zu versenden.",
                "text1Additional": "* Profitieren können Personen mit Wohnsitz in den Kantonen Graubünden und Tessin im Rahmen eines Seco-Pilotprojekts. Weitere Infos finden Sie {0}",
                "text1Additionallink": "hier.",
                "text1link1": "Weiterbildungsmöglichkeiten",
                "text1link2": "Arbeitslosengeldern in den Zwischensaisons*.",
                "unemploymentBenefits": "ALV-Leistungen"
            },
            "advantagesEmployer": {
                "forYouremployees": {
                    "label": "Die Vorteile für Ihre Mitarbeitenden",
                    "text1": "Spannende Arbeitswelt nach dem Motto «im Sommer am See, im Winter im Schnee»",
                    "text2": "Ganzjahresperspektive und Karriereplanung",
                    "text3": "Weiterbildungsangebote während der Zwischensaison. {action}",
                    "text3link": "Mehr Infos hier.",
                    "text4": "Mitarbeitende aus den Kantonen Graubünden und Tessin profitieren im Rahmen eines Seco-Pilotprojekts von vereinfachten Zugang zu Leistungen der Arbeitslosenkasse in der Zwischensaison, ohne den Nachweis von Arbeitsbemühungen oder weitere bürokratischen Auflagen erbringen zu müssen. {action}",
                    "text4link": "Mehr Infos hier."
                },
                "label": "Vorteile",
                "yours": {
                    "label": "Ihre Vorteile",
                    "text1": "Sie werten Ihre Saisonstellen-Angebote auf und bieten Mitarbeitenden mehr als «nur» eine Saisonstelle.",
                    "text2": "Sie rekrutieren und kooperieren im Verbund mit renommierten Betrieben, behalten aber in allen Belangen die absolute Autonomie.",
                    "text3": "Sie können Ihre Mitarbeiterzufriedenheit und die Mitarbeiterbindung steigern."
                }
            },
            "archived": "Archiviert",
            "careerday": {
                "additional": "Keine Anmeldung nötig<br>\nBitte Lebenslauf (CV) mitbringen!",
                "duration": {
                    "label": "Dauer",
                    "value": "Voraussichtlich 9&colon;30 - 11&colon;30 und 14&colon;00 - 16&colon;00 Uhr"
                },
                "intro": "Am <strong>Dienstag, 17. August 2021</strong> findet der Mitarbeiter-Sharing <strong>Career Day</strong> in Losone statt! Komm vorbei, lerne spannende Betriebe kennen und sichere dir eine Stelle für die nächste Wintersaison 2021/22 - ganz nach dem Motto: \"Im Sommer am See, im Winter im Schnee\".",
                "label": "Career Day",
                "place": {
                    "label": "Ort",
                    "value": "<a href=\"https://goo.gl/maps/xXNjPRxAoK3SFrNRA\" target=\"_blank\">Albergo Losone</a>"
                },
                "price": {
                    "label": "Teilnahmekosten",
                    "value": "kostenlos!"
                },
                "title": "Mitarbeiter-Sharing Career Day 2021"
            },
            "contact": {
                "cantSolveProblem": "Sie konnten Ihr Problem noch nicht lösen? Gerne helfen wir Ihnen dabei! Bitte nehmen Sie Kontakt mit uns auf.",
                "employees": "Mitarbeiter/in",
                "employers": "Arbeitgeber/in",
                "importantQuestions": "Die wichtigsten Fragen und Antworten finden Sie hier",
                "label": "Kontakt"
            },
            "employeesSays": {
                "1": {
                    "person": "Marika Somaini, Hotelfachfrau",
                    "text": "Dank der Plattform jobs2share entdeckt man die kulturelle, klimatische und landschaftliche Vielfalt der Schweiz. Wir haben das Privileg, an Orten zu arbeiten, wo andere in die Ferien gehen. Durch die Arbeitskontinuität und eine ständige berufliche Weiterentwicklung bleibt man aktiv und heiter."
                },
                "10": {
                    "person": "Rodella Massimo",
                    "text": "Dank Jobs2share haben wir die Möglichkeit, zwischen mehreren Jobangeboten zu wählen, um auch ohne Jahresvertrag eine kontinuierliche Arbeitssituation zu erreichen."
                },
                "11": {
                    "person": "Patti Clara",
                    "text": "Schon seit Jahren bin ich eine Mitarbeiterin der Tschuggen Group. Zurzeit arbeite ich im Hotel Castello del Sole in Ascona, um mein Fachwissen zu erweitern. Ich freue mich, für die Wintersaison wieder in das Hotel Valsana nach Arosa zurückzukehren."
                },
                "2": {
                    "person": "Alessia Tagli, Restaurationsfachfrau",
                    "text": "«Jobs2share ist für mich eine fantastische Chance, mich persönlich und beruflich weiterzuentwickeln. Im Winter arbeite ich im Schweizerhof Lenzerheide, im Sommer im Delfino Lugano - zwei spannende und sehr unterschiedliche Betriebe, bei denen ich viel lernen kann.»"
                },
                "3": {
                    "person": "Fabio Dell’Ava, 2. Concierge",
                    "text": "Dank der Plattform Jobs2share habe ich die Chance, meine berufliche Situation abwechslungsreicher, dynamischer und verlockender zu gestalten. So kann ich an zwei fantastischen Orten leben und zwei unterschiedliche Arbeitsrealitäten kennenlernen."
                },
                "4": {
                    "person": "Corrado Taglioni, II. Maitre d’hôtel",
                    "text": "Jobs2share gibt mir die Möglichkeit, in zwei angesehenen Hotels zu arbeiten. Eines liegt direkt am See und das andere in den Bergen, wo ich zusätzlich zur Arbeit auch Skifahren kann."
                },
                "5": {
                    "person": "Nina della Vedova, Demi Chef de Rang",
                    "text": "Ich bin sehr dankbar, die Plattform Jobs2share nutzen zu können, weil ich so in grossen luxuriösen Hotels arbeiten kann. In diesen Hotels kann ich meine Grundkenntnisse täglich erweitern. Dank dieser Plattform erreiche ich eine Arbeitskontinuität von 10 Monaten pro Jahr."
                },
                "6": {
                    "person": "Paula Da Silva Rego, Zimmerfrau & Nuno Ferreira da Fonseca, Officemitarbeiter",
                    "text": "Dank der Plattform Jobs2share haben wir die Chance, in zwei Luxushotels in zwei unterschiedlichen Kantonen zu arbeiten. Wir können so unsere Kenntnisse besser erweitern. Die Hotels bieten auch die Möglichkeit an, ein Studio oder eine Wohnung zu mieten, so dass sich die Mitarbeiter ein bisschen wie zu Hause fühlen."
                },
                "7": {
                    "person": "Leopold Ott, Sous-Chef",
                    "text": "Jobs2share bietet die Chance, durch geringen Aufwand einen reibungslosen Übertritt in eine neue Arbeitsstelle zu tätigen, um sich danach auf seine Arbeit konzentrieren zu können. Der eigene Horizont wird durch diesen Vorgang, sowohl arbeitstechnisch als auch privat, weiterentwickelt. Ich kann es nur weiterempfehlen und würde wieder darauf zurückgreifen."
                },
                "8": {
                    "person": "Robert Fiedler, Sous-Chef",
                    "text": "Durch Jobs2share wurde mir die Möglichkeit gegeben, in zwei renommierten Swiss Deluxe Hotels zu arbeiten. Eine tolle Chance, sich fachlich und persönlich weiterzuentwickeln. Durch das Angebot von Mitarbeiterwohnungen kann man sich hundertprozentig auf seine neue Tätigkeit konzentrieren, die Wohnungssuche entfällt. Arbeiten, wo andere ihren Urlaub verbringen."
                },
                "9": {
                    "person": "Torri Davide",
                    "text": "Dank der Plattform Jobs2share haben wir die Möglichkeit in grossen traditionsreichen Häusern zu arbeiten, die uns ständige Weiterbildungsmöglichkeiten offerieren, Sicherheit für die Zukunft bieten und bewusst der Arbeitslosigkeit entgegenwirken."
                },
                "label": "Das sagen Arbeitnehmer"
            },
            "employersSays": {
                "1": {
                    "person": "Corinne Denzler, General Manager<br>Tschuggen Hotel Group",
                    "text": "«Jobs2share ist für uns eine gute Möglichkeit, unseren Mitarbeitenden Ganzjahresperspektiven zu bieten.»"
                },
                "10": {
                    "person": "Ralph Treuthardt, Direktor<br>Hotel Guarda Val Sporz AG",
                    "text": "«Gut ausgebildete Mitarbeitende zu finden, die authentische Herzlichkeit leben, ist heute sehr schwer geworden. Da ist jobs2share für uns, als auch für das Personal, ein echter Gewinn. Es gibt uns die Möglichkeit, den Mitarbeitenden anderer Betriebe saisonale Lücken zu ersparen und sie durch das Arbeiten in unterschiedlichen Betriebsstrukturen und -philosophien weiter zu qualifizieren.»"
                },
                "11": {
                    "person": "Fabian Mauerhofer, Food & Beverage Manager<br>Vitznauerhof",
                    "text": "«Es ist essenziell, die Sharing Plattform nicht nur als Hilfsmittel zur Mitarbeitersuche zu verwenden, sondern auch unsere Berufsgattung mit diversen praktischen Trainings und sprachlicher Hilfestellungen zu unterstützen.»"
                },
                "2": {
                    "person": "Marcel Krähenmann, Direktor<br>Boutique Hotel La Rocca",
                    "text": "«Die Hotellerie und Gastronomie spüren den Fachkräftemangel je länger je mehr. Unsere Antwort darauf heisst Mitarbeiter-Sharing. Wir nutzen jobs2share, um mit anderen Saisonbetrieben zu kooperieren und Mitarbeitenden eine attraktive Ganzjahresperspektive zu bieten - ein Erfolgsrezept, um konkurrenzfähig zu bleiben! »"
                },
                "3": {
                    "person": "Andreas und Claudia Züllig-Landolt, Geschäftsführende und Gastgeber<br>Hotel Schweizerhof Lenzerheide",
                    "text": "«Jobs2share begeistert uns! Wir im Bündnerland profitieren in der mitarbeiterintensiven Winterzeit von Mitarbeitenden aus dem Tessin und anderen Regionen, welche im Sommer wieder zu ihrem Stammbetrieb zurückkehren und so für beide Betriebe zu einem «wertvollen Kapital» für die Unternehmer und die Gäste werden.»"
                },
                "4": {
                    "person": "Franzisca Rechsteiner, HR-Managerin<br>Hotel Castello del Sole Ascona",
                    "text": "«Mitarbeiter-Sharing und die Plattform jobs2share sind für uns zukunftsweisende Wege, um Mitarbeitende von unserem Betrieb zu begeistern, zu rekrutieren und zu binden.»"
                },
                "5": {
                    "person": "Regula Peter, Director of Human Resources<br>Badrutt’s Palace Hotel St. Moritz",
                    "text": "«Das Badrutt’s Palace Hotel investiert viel in die Förderung der Mitarbeitenden. Dazu zählt auch das Angebot attraktiver Arbeitsperspektiven. Durch Mitarbeiter-Sharing und jobs2share bieten wir unseren Leuten bevorzugte Möglichkeiten, sich für Sommeranstellungen in Netzwerkbetrieben zu bewerben. Aus dem Projekt sind heute bereits tolle Kooperationen entstanden, durch welche wir für die teilnehmenden Mitarbeitenden längere Anstellungen, den Einblick in andere Betriebe und dadurch auch Entwicklungsmöglichkeiten schaffen.»"
                },
                "6": {
                    "person": "Federico Haas, Gastgeber und Inhaber<br>Hotel Delfino Lugano",
                    "text": "«Abwechslung macht das Leben schön. Mit diesem Motto motivieren wir vor allem junge Mitarbeitende, auf das Mitarbeiter-Sharing-Boot zu steigen.»"
                },
                "7": {
                    "person": "Esther Oubina, HR Manager<br>Villa Orselina",
                    "text": "«Mit jobs2share können wir unsere Mitarbeitenden mit Langzeitperspektiven und Förderprogrammen motivieren und binden. Ein Gewinn für alle.»"
                },
                "8": {
                    "person": "Thomas Gruber, Human Resources Manager<br>Grand Hotel Villa Castagnola, Lugano",
                    "text": "<p>«Ich blicke in strahlende Augen unserer Mitarbeiter, wenn sie über den positiven Austausch innerhalb der Kooperationen sprechen. Ihnen bietet jobs2share eine beruhigende Sicherheit, wenn bereits ein Vertrag für die kommende Saison in einem unserer renommierten Partnerbetriebe unterschrieben werden konnte.»</p><p>Für uns Arbeitgeber und vor allem für unsere Stammgäste gibt es nichts Schöneres, als auf bekannte Mitarbeitergesichter zu treffen, welche zudem die Dienstleistungen sowie die Philosophie des Betriebes bereits gut kennen.<br>Mitarbeiter-Sharing und die dazugehörige Plattform jobs2share ist ein Win-Win-Angebot, von welchem beide Seiten gleichermassen profitieren.»</p>"
                },
                "9": {
                    "person": "Sandy Stöckenius, HR Managerin<br>BELVEDERE HOTELS SCUOL",
                    "text": "«Gute Chancen für Mitarbeitende auf eine Ganzjahresstelle und die Möglichkeit, in zwei gegensätzlichen Destinationen mitwirken zu können - was gibt es Spannenderes?»"
                },
                "label": "Das sagen Arbeitgeber"
            },
            "faqsEmployees": {
                "cooperations": {
                    "1a": "Wenn Sie über jobs2share eine Sommer- und Winterstelle kombinieren, wird dies in einem sogenannten Kooperationsvertrag festgehalten. Dieses Dokument können Sie in Ihrem Kundenkonto als PDF herunterladen. Sie brauchen dazu eine aktuelle Saisonstelle und eine Anschlussstelle bei Unternehmen, die beim Programm Mitarbeiter-Sharing mitmachen und auf der Plattform jobs2share registriert sind.{linebreak}{linebreak} Der Kooperationsvertrag bildet die Brücke zwischen den beiden Arbeitgebern und dem Mitarbeitenden und schafft Transparenz.{linebreak}{linebreak} Dies ermöglicht den Arbeitgebern, über die Saison hinaus Mehrwert für ihre gemeinsamen Mitarbeitenden zu schaffen. Die Arbeitgeber planen hierfür gemeinsam die nächsten Karriereschritte und persönliche Weiterentwicklung ihrer Angestellten. Zudem bieten sie Weiterbildungen für ihre Mitarbeitenden und verständigen sich über deren Ein- und Austrittsdatum.{linebreak}{linebreak} Mitarbeitende mit Wohnsitz in den Kantonen Graubünden und Tessin können zudem ab 1.1.2019 im Rahmen eines {action} gegen Vorweisen des Kooperationsvertrags von erleichtertem Zugang zur Arbeitslosenkasse in den Zwischensaisons profitieren, ohne gegenüber dem zuständigen RAV Arbeitsbemühungen erbringen zu müssen.",
                    "1alink": "Pilotversuchs des SECO",
                    "1q": "Was ist ein Kooperationsvertrag?",
                    "2a": "<p>Ein Kooperationsvertrag entsteht dann, wenn zwei Saisonstellen (Jobpaket Sommer/Winter) zu einer Ganzjahresperspektive gebündelt werden. Dies passiert, wenn in dem Profil eines Mitarbeitenden auf jobs2share eine aktuelle Saisonstelle und eine künftige Saisonstelle, eben ein Jobpaket Sommer/Winter, bei zwei registrierten Arbeitgebern erfasst und von diesen bestätigt worden ist.</p><p>Das Jobpaket Sommer/Winter kann auf zwei Arten auf der Plattform zu einem Kooperationsvertrag führen:</p><ol><li>Sie verfügen bereits jetzt über eine aktuelle Saisonstelle oder haben bereits eine zukünftige Saisonstelle bestätigt bekommen.<ul><li>Tragen Sie diese Saisonstelle in Ihrem Profil ein. Der Arbeitgeber dieser jetzigen oder baldigen Saisonstelle muss diese ebenfalls auf jobs2share bestätigen.</li><li>Bewerben Sie sich zusätzlich auf der jobs2share Plattform für eine zweite Saisonstelle in der direkt nachfolgenden Saison. Sobald Sie auch von diesem auf jobs2share registrierten Arbeitgeber eine Zusage und Bestätigung bekommen, ist ihr Jobpaket Sommer/Winter gebündelt und in Ihrem Profil ersichtlich. Nun wird automatisch ein Kooperationsvertrag generiert und steht für Sie zum Download bereit.</li></ul></li><li>Sie verfügen momentan über keine aktuelle oder zukünftige Saisonstelle.<ul><li>Bewerben Sie sich auf jobs2share für passende Saisonstellen. Sobald Sie eine passende Arbeitsstelle für die laufende, sowie auch für die darauffolgende, Saison gefunden haben und beide dieser Arbeitsstellen die entsprechenden Arbeitgeber auf jobs2share bestätigt worden sind, ist ihr Jobpaket Sommer/Winter gebündelt und in Ihrem Profil ersichtlich. Nun wird automatisch ein Kooperationsvertrag generiert und steht für Sie zum Download bereit.</li></ul></li></ol>",
                    "2q": "Wie entsteht ein Kooperationsvertrag?",
                    "3a": "Sie erfassen auf jobs2share kostenfrei Ihr Profil inkl. Bewerbungsunterlagen und schaffen damit eine gute Grundvoraussetzung für Ihre Bewerbungen. Die von Ihnen in Ihrem Profil erfassten Informationen bilden dabei die Basis für Ihre Bewerbungen. Wenn Sie sich auf jobs2share für eine Stelle bewerben, erhält dieses Unternehmen Zugriff auf diese von Ihnen hinterlegten Informationen (in Form von Ihrer Bewerbung). Falls ein Jobpaket Sommer/Winter zustande kommt, erhalten Sie und beide Arbeitgeber den Kooperationsvertrag, in welchem die wichtigsten Angaben zu Start- und Enddatum ihrer Arbeitsstellen, der Position sowie die Kontaktdaten von den Arbeitgebern festgehalten sind.",
                    "3q": "Welche Informationen werden meinen Arbeitgebern weitergegeben?",
                    "4a": "In Ihrem Profil können Sie Einträge in Ihrem Lebenslauf einsehen. Wenn Fehler enthalten sind, z.B. weil ein aktueller oder ehemaliger Betrieb etwas falsches bestätigt hat, dann können Sie dort eine Korrektur bei diesem Arbeitgeber beantragen. Fehler melden Sie bitte {action}",
                    "4alink": "hier.",
                    "4q": "Fehler im Kooperationsvertrag: Wie kann ich Fehler korrigieren oder melden",
                    "5a": "Jobpakete Sommer/Winter führen dann zu Kooperationsverträgen, wenn beide Arbeitgeber beim Programm Mitarbeiter-Sharing mitmachen und auf jobs2share registriert sind. Ein Kooperationsvertrag kommt also nur zustande, wenn ihr Jobpaket Sommer/Winter aus Arbeitsstellen bei Arbeitgebern besteht, die auf jobs2share registriert sind und zudem Ihre Saisonstellen auf jobs2share bestätigt haben.",
                    "5q": "In meinem Profil ist kein Kooperationsvertrag gespeichert, obwohl ich einen Sommer- und Winterjob habe. Weshalb?",
                    "label": "Kooperationsvertrag: Zusammenarbeit mit zwei Arbeitgebern"
                },
                "label": "FAQs",
                "notifications": {
                    "1a": "Die wichtigsten Nachrichten erhalten Sie per Email. Nach dem Einloggen auf der Plattform können Sie zudem alles Aktuelle jederzeit übersichtlich auf Ihrer Übersichtsseite (Dashboard) finden.",
                    "1q": "Wie werde ich bei einer Neuigkeit auf der Plattform benachrichtigt?",
                    "label": "Benachrichtigung"
                },
                "offSeason": {
                    "1a": "Im Rahmen eines SECO-Pilotversuchs können Mitarbeitende mit Wohnsitz in Graubünden und Tessin ab dem 1.1.2019 während max. 6 Wochen pro Jahr Arbeitslosengeld in der Zwischensaison beziehen, ohne Arbeitsbemühungen gegenüber dem RAV erbringen zu müssen. Sie müssen über ein Jobpaket Sommer/Winter verfügen, das auf jobs2share registriert ist und die Periode abdeckt, in der Sie Arbeitslosenleistungen beziehen möchten. Der Kooperationsvertrag dazu ist in Ihrem Kundenkonto als PDF abgelegt und muss dem zuständigen RAV frühzeitig vorgelegt werden. Weitere Informationen finden Sie {action}",
                    "1alink": "hier.",
                    "1q": "Wie kann ich in der Zwischensaison Arbeitslosengeld beziehen, ohne Arbeitsbemühungen gegenüber dem RAV nachweisen zu müssen?",
                    "2a": "Bewerben Sie sich auf die spannenden Stellenangebote auf jobs2share. Falls Sie bereits über einen aktuellen oder künftigen Saisonjob verfügen, können Sie diesen ganz einfach in Ihrem Lebenslauf in Ihrem jobs2share-Profil eintragen. Sobald eine Sommer- und Wintersaisonstellen in Ihrem Profil eingetragen und bestätigt sind, entsteht ein Jobpaket. Einzige Bedingung: Beide Arbeitgeber müssen auf jobs2share registriert sein.",
                    "2q": "Wie komme ich zu einem Sommer/Winter-Jobpaket?",
                    "3a": "Das ist ganz einfach: registrieren, einloggen, unter «Stellensuche» nach spannenden Stellen suchen und direkt via jobs2share bewerben. Dank dem eingebauten Bewerbungstool können Sie die in Ihrem Profil abgespeicherten Zertifikate und Informationen immer wieder nutzen und sparen viel Zeit. Zudem können Sie ein individuelles Motivationsschreiben verfassen. So sieht Ihre Bewerbung immer professionell aus und steigert Ihre Erfolgschancen!",
                    "3q": "Wie bewerbe ich mich?",
                    "4a": "Dies hängt von der Anzahl offener Stellen bei den Arbeitgebern ab.",
                    "4q": "Wie oft gibt es neue Stelleninserate?",
                    "5a": "Sie können in den Stellenangeboten stöbern, ohne sich registrieren zu müssen. Um die Plattform vollumfänglich nutzen zu können, ist jedoch eine einmalige Registrierung notwendig.",
                    "5q": "Ist eine Registrierung notwendig?",
                    "6a": "Nein. Sie alleine sehen, welche Stelleninserate sie als Favoriten markiert haben.",
                    "6q": "Sieht ein Arbeitgeber, wenn ich sein Stelleninserat als Favorit markiert habe?",
                    "7a": "Das ist abhängig von der Reaktionszeit des Arbeitgebers.",
                    "7q": "Wie schnell erhalte ich eine Rückmeldung auf meine Bewerbung?",
                    "8a": "Nein. Die Nutzung der Plattform ist für Arbeitnehmende vollständig kostenlos.",
                    "8q": "Entstehen für mich irgendwelche Kosten?",
                    "label": "Bewerbungen und Arbeitslosengelder in der Zwischensaison (SECO-Pilot Speziallösung)"
                }
            },
            "faqsEmployers": {
                "cooperations": {
                    "1a": "Sobald auf jobs2share für eine Mitarbeitende/einen Mitarbeitenden ein Jobpaket Sommer/Winter registriert wird, werden die Kontaktdaten der beiden involvierten Arbeitgeber bzw. der Ansprechpersonen zur Verfügung gestellt. Sie können sich nun mit dem Kooperationsbetrieb einfach und unkompliziert verständigen und beispielsweise gemeinsam die Entwicklungsmöglichkeiten eines Mitarbeitenden über die einzelne Saison hinaus planen.",
                    "1q": "Wie funktioniert die Kooperation mit anderen Arbeitgebern?",
                    "2a": "Dies ist notwendig, weil dadurch die Jobpakete von Ihren Mitarbeitenden auf der Plattform erfasst und automatisch Kooperationsverträge generiert werden können. Zudem wird somit eine gewisse Kontrolle (Vieraugenprinzip) sichergestellt, da nicht nur der Mitarbeitende angibt, wo er arbeitet, sondern auch der Arbeitgeber dies bestätigt.",
                    "2q": "Weshalb muss ich als Betrieb die Anstellung eines Mitarbeitenden bestätigen?",
                    "3a": "Ein Kooperationsvertrag entsteht dann, wenn zwei Saisonstellen zu einer Ganzjahresperspektive gebündelt werden. Der Kooperationsvertrag beinhaltet die Kontaktdaten beider Arbeitgeber sowie jene des Mitarbeiters, die Anstellungsdauer sowie die Funktion des Mitarbeitenden. <br>Der Kooperationsvertrag bildet die Brücke zwischen den beiden Arbeitgebern und dem Mitarbeitenden und schafft Transparenz.<br>Dies ermöglicht den Arbeitgebern, über die Saison hinaus Mehrwert für ihre gemeinsamen Mitarbeitenden zu schaffen. Die Arbeitgeber planen hierfür gemeinsam die nächsten Karriereschritte und persönliche Weiterentwicklung ihrer Angestellten. Zudem bieten sie Weiterbildungen für ihre Mitarbeitenden und verständigen sich über deren Ein- und Austrittsdatum. <br>Mitarbeitende mit Wohnsitz in den Kantonen Graubünden und Tessin können zudem ab 1.1.2019 im Rahmen eines Pilotversuchs des SECO gegen Vorweisen des Kooperationsvertrags von erleichtertem Zugang zur Arbeitslosenkasse in den Zwischensaisons profitieren, ohne gegenüber dem zuständigen RAV Arbeitsbemühungen erbringen zu müssen.",
                    "3q": "Was ist ein Kooperationsvertrag?",
                    "label": "Kooperationen"
                },
                "deleteAccount": {
                    "1a": "Die Löschung des Kundenkontos kann {0} beantragt werden.",
                    "1alink": "via Kontaktformular",
                    "1q": "Wie kann ich mein Kundenkonto dauerhaft löschen?",
                    "label": "Löschung des Kundenkontos"
                },
                "jobAdvertisements": {
                    "1a": "Nachdem Sie sich als Arbeitgeber eingeloggt haben, können Sie unter dem entsprechenden Unternehmen im Bereich «Stelleninserate» neue Inserate hinzufügen oder Inhalte/Datum bestehender oder deaktivierter Stelleninserate aktualisieren. Dank der Flatrate können Sie beliebig viele Stelleninserate hinzufügen. Ist eine Stelle besetzt, können Sie das Inserat löschen oder vorübergehend deaktivieren.",
                    "1q": "Wie erfasse ich ein Stelleninserat?",
                    "2a": "Das Erfassen von Stelleninseraten auf jobs2share ist in der Flatrate inbegriffen und verursacht keine zusätzlichen Kosten. Es können beliebig viele Stelleninserate erfasst werden.",
                    "2q": "Was kostet ein Stelleninserat auf jobs2share?",
                    "3a": "Die Bewerbungsdossiers können Sie während 1.5 Jahren nach Eingang der Bewerbung in Ihrem Kundenkonto abrufen. Wollen Sie die Dossiers länger aufbewahren, dann können Sie diese innerhalb dieser Laufzeit von 1.5 Jahren bequem als PDF exportieren und lokal abspeichern.",
                    "3q": "Wie lange bleiben die Bewerbungsdossiers auf der Plattform gespeichert?",
                    "4a": "Ja, das ist problemlos möglich. Unter «Bewerbungen» sind sämtliche Bewerbungsdossiers aufgeführt. Diese können als PDF exportiert werden.",
                    "4q": "Kann ich die Bewerberdossiers downloaden?",
                    "5a": "Melden Sie das Problem via {0}",
                    "5alink": "Button Kontaktformular.",
                    "5q": "Sie haben eine Bewerbung fälschlicherweise abgelehnt?",
                    "6a": "Melden Sie das Problem via {0}",
                    "6alink": "Button Kontaktformular.",
                    "6q": "Sie haben eine Bewerbung fälschlicherweise angenommen?",
                    "label": "Stellenausschreibungen und Bewerbungen"
                },
                "label": "FAQs",
                "notifications": {
                    "1a": "Die wichtigsten Nachrichten erhalten Sie per Email. Nach dem Einloggen auf der Plattform können Sie zudem alles Aktuelle jederzeit übersichtlich auf Ihrer Übersichtsseite (Dashboard) finden.",
                    "1q": "Wie werde ich bei einer Neuigkeit auf der Plattform benachrichtigt?",
                    "label": "Benachrichtigung"
                },
                "paymentTerms": {
                    "1a": "Die Jahresgebühr ist abhängig von der Grösse Ihres Betriebes. {action} Die Abrechnung erfolgt monatlich per Kreditkarte. Die Belege werden Ihnen in Ihrem Kundenkonto zur Verfügung gestellt.",
                    "1alink": "Die Preise finden Sie hier.",
                    "1q": "Was kostet das Nutzen von jobs2share respektive wie funktioniert die Flatrate?",
                    "2a": "Die monatliche Gebühr für die Nutzung der Plattform ist abhängig von der Grösse Ihres Unternehmens basierend auf der Anzahl angestellter Personen während Ihrer Hochsaison (unabhängig vom Pensum oder dem Anteil an Saisonangestellten). Wenn Sie die Abo-Kategorie «Gross» wählen, können Sie zusätzliche Unternehmen im gleichen Kundenkonto für einen reduzierten Preis von monatlichen 24.90 CHF pro Zusatzbetrieb (anstelle des regulären Preises ab 49.90 CHF) verwalten.<ul><li>Abo Mikro: bis 10 Mitarbeitende</li><li>Abo Klein: 11-30 Mitarbeitende</li><li>Abo Mittel: 31- 80 Mitarbeitende</li><li>Abo Gross: ab 81 Mitarbeitende</li></ul>",
                    "2q": "Welche Abo-Kategorie ist für meinen Betrieb massgebend?",
                    "3a": "Massgebend ist die Anzahl angestellter Personen während Ihrer Hauptsaison, unabhängig vom Pensum der Angestellten oder dem Anteil an Saisonpersonal.",
                    "3q": "Wie berechnet sich die Betriebsgrösse?",
                    "4a": "Nein, dies ist nicht möglich. Sie erhalten zu sehr attraktiven Konditionen eine Jahresflatrate und können damit nicht nur Saisonangestellte rekrutieren und beliebig viele Stelleninserate platzieren, sondern ihren Mitarbeitenden auch eine Perspektive über die Saison hinaus anbieten. Die Kooperation mit anderen Betrieben funktioniert nur dann, wenn Sie das ganze Jahr dabei sind.",
                    "4q": "Kann ich ein Monatsabo lösen?",
                    "5a": "Sie können das Abo sowie allfällige Zusatzabos auf das Ende der Laufzeit (1 Jahr) jeweils während dem letzten Monat der Laufzeit direkt in Ihrem Kundenkonto kündigen. Sie erhalten frühzeitig eine Erinnerung per Email. Das Jahresabo erneuert sich automatisch, sofern Sie nicht im Monat vor Ablauf Ihres Abos kündigen. Wenn Sie ihr Abo kündigen, bleibt ihr Kundenkonto auf der Plattform bestehen und kann durch den erneuten Kauf eines Abos wieder genutzt werden.",
                    "5q": "Wann und wie kann ich mein Abo kündigen?",
                    "6a": "Sie können Ihrem Kundenkonto weitere Unternehmen hinzufügen, um sie direkt in Ihrem Kundenkonto zu verwalten. So können Sie im Namen dieses zusätzlichen Unternehmens Saisonstellenangebote auf der Plattform platzieren und alle weiteren Funktionen in Anspruch nehmen. Um Ihrem Kundenkonto ein weiteres Abo hinzuzufügen, müssen Sie zuerst ein Profil des Unternehmens erstellen. Sobald dieses erstellt ist, können Sie anschliessend auch für diesen Zusatzbetrieb ein Abo lösen und Ihrem Konto hinzufügen. Falls Sie bereits über ein Abo der Kategorie «Gross» verfügen, kostet Sie ein hinzugefügtes Unternehmen im gleichen Kundenkonto zusätzlich noch monatliche 24.90 CHF pro Zusatzbetrieb anstelle des regulären {action} (ab 49.90 CHF).",
                    "6alink": "Abopreises",
                    "6q": "Wie kann ich mehrere Betriebe in einem Kundenkonto verwalten?",
                    "label": "Zahlungsmodalitäten und Abos"
                }
            },
            "findStaff": {
                "label": "Mitarbeitende finden"
            },
            "furtherEducation": {
                "gastronomyCoursesGrisons": {
                    "label": "Gastronomiekurse Graubünden",
                    "text": "Verschiedene ein- und mehrtägige Gastronomiekurse werden zur Verbesserung spezifischer Kenntnisse angeboten. Weitere Infos <a href=\"https://www.gastrograubuenden.ch/aus-weiterbildung/alle-kurse\" target=\"_blank\">hier.</a>"
                },
                "gastronomyCoursesTicino": {
                    "label": "Gastronomiekurse Tessin",
                    "text": "Verschiedene eintägige Gastronomiekurse werden zur Verbesserung spezifischer Kenntnisse angeboten. Weitere Infos <a href=\"http://www.gastroformazione.ch\" target=\"_blank\">hier.</a>"
                },
                "intro": "Mit einer Weiterbildung geben Sie Ihrer Karriere einen neuen Schub. Hierbei können Sie neue fachliche Qualitäten erlernen und Ihr persönliches Potenzial entfalten. Die Betriebe auf Jobs2share wollen ihre Mitarbeitenden wertschätzen und fördern. Folgende Weiterbildungsangebote stehen derzeit zur Verfügung:",
                "label": "Weiterbildung",
                "languageCourses": {
                    "label": "Sprachkurse",
                    "text1": "Hotel & Gastro formation Schweiz bietet einen fachspezifischen fide Deutsch-Sprachkurs Gastronomie/Hotellerie für Betriebe aus den Kantonen Tessin und Graubünden an. Die Kurse werden im Niveau A1, A2 und B1 angeboten und finden von Juni-Oktober 2021 und von November-Dezember 2021 in Lugano oder Losone statt. Der fide Sprachkurs ist durch den L-GAV subventioniert. Bis 31.12.2021 sind die Kurse komplett <a href=\"https://weiterbildung-inklusive.ch/\" target=\"_blank\">kostenlos</a>. Zusätzlich werden die Kosten für Lehrmittel, Verpflegung, allfällige Übernachtungen der Kursabsolventen sowie ein grosszügiger Anteil des Lohnersatzes übernommen. Genaue Daten und Informationen <a href=\"/static/documents/fide/Fide_Sprachkurs_Tessin_Jobs2share_2021_DE.pdf\" target=\"_blank\">hier</a>.<br>\nDiverse Jobs2share-Arbeitgeber bieten vor Ort oder online eigene Sprachkurse an. Fragen Sie direkt bei Ihrem Arbeitgeber nach."
                },
                "progressoCourses": {
                    "label": "Progresso-Kurse (Gastronomie/Hotellerie)",
                    "text": "Hotel & Gastro formation Schweiz bietet auch dieses Jahr während der Zwischensaison einen Progresso-Lehrgang in Chur und Losone in den Fachbereichen Service, Küche und Hauswirtschaft an. Die 5-wöchigen Lehrgänge finden im Frühling 2021 und im Herbst 2021 statt. Der Lehrgang ist durch den L-GAV subventioniert. Bis 31.12.2021 sind die Kurse komplett <a href=\"https://weiterbildung-inklusive.ch/\" target=\"_blank\">kostenlos</a>. Zusätzlich werden die Kosten für Lehrmittel, Verpflegung, allfällige Übernachtungen der Kursabsolventen sowie ein grosszügiger Anteil des Lohnersatzes übernommen. Genaue Daten und Informationen <a href=\"/static/documents/progresso/Progresso_Jobs2share_AN_2021_DE.pdf\" target=\"_blank\">hier</a>.<br>\nHotel & Gastro Formation bieten Progresso-Kurse für Berufs- oder Quereinsteiger in den Bereichen Küche, Service und Hauswirtschaft an. Die Kurse werden über den Gesamtarbeitsvertrag (L-GAV) finanziert und sind für Teilnehmende fast kostenlos. Daten und weitere Informationen für Kurse in Graubünden <a href=\"https://mein-progresso.ch/\" target=\"_blank\">hier</a>."
                }
            },
            "howItWorksEmployee": {
                "label": "So funktioniert's",
                "text1": "Saisonjobs nach Lust und Laune kombinieren, zum Beispiel nach dem Motto «im Sommer am See, im Winter im Schnee». Oder lieber im Sommer in der Stadt, im Winter auf dem Land? Im Winter Berghütte, im Sommer 5-Sterne-Palast? Im Sommer Barista, im Winter Skilehrerin?",
                "text2": "Mit jobs2share geht das ganz leicht. Eine Traumstelle zu finden ist nur der erste Schritt. Wir helfen Ihnen, spannende Sommer/Winter-Jobpakete, zugeschnitten auf Ihre Bedürfnisse, zu schnüren. Auf jobs2share haben Sie Zugriff auf einige der besten Arbeitgeber der Schweiz. Sie bieten Ihnen Perspektiven über die Saison hinaus."
            },
            "howItWorksEmployer": {
                "fillOpenJobs": {
                    "label": "Sie wollen offene Stellen besetzen?",
                    "text1": "Stelleninserate<br>Schreiben Sie beliebig viele Saisonstellen aus – dank unserer Flatrate kostet Sie das einzelne Inserat nichts.",
                    "text2": "Bewerbungen managen<br>Erhalten und managen Sie Bewerbungen direkt auf jobs2share.",
                    "text3": "Kooperationsvertrag<br>Findet eine Stellensuchende/ein Stellensuchender zwei Saisonstellen (Jobpaket Sommer/Winter) bei registrierten Arbeitgebern und ist dieses von Ihnen und dem zusätzlichen Arbeitgeber online bestätigt worden, so wird dies in seinem jobs2share-Profil ersichtlich und automatisch ein Kooperationsvertrag zwischen beiden Arbeitgebern generiert.",
                    "text4": "Karriereplanung<br>Sie können sich nun mit dem Partnerbetrieb verständigen und gemeinsam für Ihre Mitarbeitenden deren individuelle Karriereplanung in Angriff nehmen.",
                    "text5": "Fachkräfte zurückgewinnen<br>jobs2share unterstützt Sie dabei, Mitarbeitende für die kommende Saison zurück zu gewinnen."
                },
                "label": "So funktioniert's",
                "offerPerspective": {
                    "label": "Sie wollen Ihren Saisonmitarbeitenden eine Perspektive bieten?",
                    "text1": "Erleichtern Sie es Ihren Mitarbeitenden mithilfe von jobs2share eine ergänzende Saisonstelle bei einem attraktiven Arbeitgeber zu finden. Für Ihre Mitarbeitenden ist die Nutzung von jobs2share kostenlos.",
                    "text2": "Dank Ihrer Teilnahme bieten Sie Ihren Mitarbeitenden eine Ganzjahresperspektive und die Möglichkeit, von vielen zusätzlichen Vorteilen zu profitieren. Zudem erhöhen Sie damit die Wahrscheinlichkeit, Ihre Mitarbeitenden für die Saison in einem Jahr zurück zu gewinnen."
                }
            },
            "impress": {
                "contact": "Kontakt",
                "contactDetails": "Verein Mitarbeiter-Sharing<br>c/o Fachhochschule Graubünden<br>Comercialstrasse 22<br>7000 Chur",
                "emailAddress": "info@jobs2share.ch",
                "implementation": {
                    "content": "Umsetzung",
                    "label": "Umsetzung"
                },
                "label": "Impressum",
                "offer": "Jobs2share.ch ist ein Angebot des Vereins Mitarbeiter-Sharing",
                "responsible": "Verantwortlich",
                "responsiblePerson": "Katrin Schillo"
            },
            "jobAdvertisement": {
                "findEmployees": "Mitarbeitende finden",
                "forEmployers": "Für Arbeitgebende",
                "label": "Job ausschreiben"
            },
            "jobFind": {
                "forEmployees": "Für Mitarbeitende",
                "label": "Job finden"
            },
            "jobStatus": [],
            "jobs": {
                "label": "Jobs"
            },
            "jobs2share": {
                "label": "jobs2share"
            },
            "media": {
                "downloadMediaKit": "Download ZIP (70 MB)",
                "downloadPressRelease": "Download «Medienmittelung»",
                "label": "Medien",
                "mediaKit": "«Media-Kit»",
                "mediaReports": "Das berichten die Medien über uns",
                "mediaReportsList": "<ul>\n <li><a href=\"https://www.htr.ch/story/lehrlingsaustausch-zwischen-tessin-und-graubuenden-auf-kurs-22036.html\" target=\"_blank\">HTR - Oktober 2018</a></li>\n  <li><a href=\"https://8094bd36e89df1af34bd54d1c93ce32f.ds11s3ns.swisscom.com/jobs2share/static/de/media-reports/HTR_09_18.pdf\" target=\"_blank\">HTR - September 2018</a></li>\n  <li><a href=\"https://www.nzz.ch/wirtschaft/kampf-gegen-die-saisonale-arbeitslosigkeit-in-den-bergen-ld.1380474\" target=\"_blank\">NZZ - April 2018</a></li>\n  <li><a href=\"https://www.nzz.ch/schweiz/saisonale-personalanstellung-hotels-teilen-sich-die-mitarbeiter-ld.89984\" target=\"_blank\">NZZ - Juni 2017</a></li>\n  <li><a href=\"https://www.srf.ch/play/tv/popupvideoplayer?id=4f6da375-554b-4a54-a247-d5ef3ee8b8ab\" target=\"_blank\">10vor10 - Januar 2017</a></li>\n  <li><a href=\"https://www.nzz.ch/schweiz/saisonale-personalanstellung-hotels-teilen-sich-die-mitarbeiter-ld.89984\" target=\"_blank\">NZZ - Juni 2016</a></li>\n  <li><a href=\"https://www.nzz.ch/wirtschaft/unternehmen/saisonarbeit-im-tourismus-transalpines-mitarbeiter-sharing-ld.16643\" target=\"_blank\">NZZ - April 2016</a></li>\n  <li><a href=\"https://www.srf.ch/sendungen/10vor10/todesfalle-mekka-mitarbeiter-sharing-des-dichters-tochter\" target=\"_blank\">10vor10 - September 2015</a></li>\n</ul>",
                "mediaRepresentative": "Sind Sie Medienschaffende/r?",
                "pressRelease": "Medienmitteilungen",
                "pressReleaseDe": "Medienmitteilungen Deutsch",
                "pressReleaseIt": "Medienmitteilungen Italienisch"
            },
            "newsletter": {
                "label": "Newsletter",
                "text": "Wollen Sie mehr wissen? Bleiben Sie auf dem Laufenden und registrieren Sie sich hier für unseren Newsletter."
            },
            "offerEmployers": {
                "label": "Angebot",
                "sizes": {
                    "employeesPeakSeason": "Anzahl Mitarbeitende (angestellte Personen, nicht VZÄ) während der Peak Season",
                    "large": "Gross",
                    "largeSubtitle": "ab 81 Mitarbeitende*",
                    "largeText": "<ul><li>Ein ganzes Jahr unlimitiert Stelleninserate ausschreiben</li><li>Einfaches und professionelles Management von eingehenden Bewerbungen</li><li>Mit anderen Unternehmen im HR-Bereich kooperieren</li><li>Perspektive für Ihre Saisonmitarbeitenden über die Saison hinaus</li><li>E-Mail Support</li><li>Individuelles Profil zur Stärkung Ihrer Arbeitgebermarke</li><li>Weitere Unternehmen im gleichen Kundenkonto zum Spezialpreis von monatlichen 24.90 CHF pro Zusatzbetrieb verwalten</li></ul>",
                    "medium": "Mittel",
                    "mediumSubtitle": "31-80 Mitarbeitende*",
                    "micro": "Mikro",
                    "microSubtitle": "bis 10 Mitarbeitende*",
                    "priceText": "CHF pro Monat",
                    "small": "Klein",
                    "smallSubtitle": "11-30 Mitarbeitende*",
                    "text": "<ul><li>Ein ganzes Jahr unlimitiert Stelleninserate ausschreiben</li><li>Einfaches und professionelles Management von eingehenden Bewerbungen</li><li>Mit anderen Unternehmen im HR-Bereich kooperieren</li><li>Perspektive für Ihre Saisonmitarbeitenden über die Saison hinaus</li><li>Mehrere Betriebe in einem Kundenkonto verwalten</li><li>E-Mail Support</li><li>Individuelles Profil zur Stärkung Ihrer Arbeitgebermarke</li></ul>"
                },
                "text": "Bereits ab 49.90 CHF pro Monat können Sie unlimitiert Stellenangebote ausschrieben und mit anderen Unternehmen kooperieren, um Mitarbeitenden gemeinsam eine attraktive Ganzjahresperspektive zu bieten. Jobs2share wird von den besten Arbeitgebern in den Bereichen Hotellerie, Gastronomie, Bergbahnen, Skischulen und weiteren Unternehmen genutzt, die saisonale Schwankungen aufweisen.",
                "whatSize": "Wie gross ist Ihr Unternehmen?"
            },
            "partner": {
                "label": "Partner",
                "ourMembers": "Unsere Mitglieder",
                "ourPartners": "Unsere Partner"
            },
            "privacyPolicy": {
                "label": "Datenschutz"
            },
            "rulesOfTheGame": {
                "cooperation": {
                    "label": "Kooperation, Fair Play und Abwerben von Mitarbeitenden",
                    "text": "<p>Um die unter «Mission» genannten Ziele zu erreichen, geben sich die User das Versprechen, sich untereinander jederzeit fair zu verhalten und dazu beizutragen, dass eine langfristige, gewinnbringende Zusammenarbeit möglich ist.</p><p>Fairplay bedeutet, dass die User zu einem positiven Klima innerhalb der Plattform jobs2share beitragen und sich zu einer good-practice in Bezug auf das «Sharen» von Mitarbeitenden bekennen. Jeder einzelne User übernimmt eine Vorbildfunktion mit seinem Handeln auf der Plattform. Das bedeutet beispielsweise, dass User nicht mutwillig Mitarbeitende von anderen Betrieben abwerben, um ihnen eine Ganzjahresstelle anzubieten, obschon eine Rückkehr zu einem teilnehmenden Betrieb (Mitglied, User) für die folgende Saison vorgesehen wäre. Gleichzeitig akzeptieren die User, dass Mitarbeitende sich bietende Gelegenheiten ergreifen, um sich persönlich und beruflich weiterzuentwickeln und gestehen ihnen diese Freiheit auch zu. Nach Möglichkeit sprechen sich die Unternehmen in Bezug auf Übertrittsdaten der Mitarbeitenden ab.</p><p>Ausserdem bekennen sich die als Betrieb registrierten User der Plattform jobs2share gegenüber den als Bewerber bzw. Mitarbeitende registrierten User an die geltenden Gesamtarbeitsvertraglichen (GAV) Vorgaben und Gesetze zu halten.</p>"
                },
                "label": "«Spielregeln Fair Play»",
                "mission": {
                    "label": "Mission",
                    "text": "Das Ziel, ein neues Arbeitsmodell «Mitarbeiter-Sharing» zu etablieren, leitet den gleichnamigen Verein, welcher die Plattfom jobs2share.ch betreibt. Die Idee des Mitarbeiter-Sharings ist es, Sommer- und Wintersaisonstellen zu bündeln und damit Ganzjahresperspektiven zu schaffen. Damit sowie durch die Förderung von Mitarbeitenden, beispielsweise durch gezielte Weiterbildungsangebote, sollen Saisonstellen für Mitarbeitende attraktiver werden und dem Bedürfnis nach einer abwechslungsreichen Tätigkeit mit gleichzeitigen beruflichen Perspektiven entsprochen werden."
                },
                "purposeAndScope": {
                    "label": "Zweck und Geltungsbereich",
                    "text": "User der Plattform jobs2share bekennen sich zu einem fairen Umgang untereinander im Sinne einer nutzenstiftenden Kooperation."
                }
            },
            "secoEmployee": {
                "conditions": {
                    "label": "Die wichtigsten Bedingungen:",
                    "list": "<ul><li>Ihr Wohnsitz befindet sich im Kanton Tessin oder Graubünden</li><li>Um von der ALV-Sonderlösung profitieren zu können, müssen Sie und Ihre Arbeitgeber auf <a href=\"/\">www.jobs2share.ch</a> registriert sein und aktuelle und künftige Jobs in Ihrem Profil eintragen. Falls Sie direkt auf <a href=\"/\">www.jobs2share.ch</a> passende Jobs finden, werden diese automatisch in Ihrem Profil erfasst.</li><li>Sie sind frei, sich passende Saisonjobs zu einem Job-Paket Sommer/Winter zusammenzustellen. Finden Sie auf <a href=\"/\">www.jobs2share.ch</a> attraktive Stellen und bewerben Sie sich direkt online!</li><li>Falls Sie also zwei Saisonstellen pro Jahr (Sommer/Winter-Jobpaket) annehmen und eintragen, wird auf <a href=\"/\">www.jobs2share.ch</a> ein «Kooperationsvertrag» generiert und steht zum Download bereit.</li><li>Übermitteln Sie diese Bestätigung Ihrem zuständigen RAV sind Sie während der Zwischensaison (maximal 6 Wochen pro Jahr) komplett von der Nachweispflicht über getätigte Arbeitsbemühungen befreit.</li></ul>",
                    "listlink": "www.jobs2share.ch"
                },
                "label": "ALV-Leistungen in der Zwischensaison – SECO-Pilotversuch",
                "moreInformation": "Weitere Informationen <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">hier.</a>",
                "text": "<p>Saisonangestellte, die im Mitarbeiter-Sharing-Modell arbeiten, können die Zwischensaisons jetzt ganz einfach und unkompliziert mit Arbeitslosengeld überbrücken. Ganz nach dem Motto «im Sommer am See, im Winter im Schnee».</p><p>Im Rahmen eines SECO-Pilotprojekts besteht die Möglichkeit, <span class=\"highlighted\">bis zu 6 Wochen pro Jahr von erleichtertem Zugang zu Leistungen der Arbeitslosenkasse zu profitieren, ohne Arbeitsbemühungen</span> erbringen zu müssen. Das Angebot steht Mitarbeitenden mit Wohnsitz in den Kantonen Tessin und Graubünden ab dem 1. Januar 2019 zur Verfügung.</p>"
            },
            "secoEmployer": {
                "label": "SECO-Pilotversuch",
                "moreInformation": "Weitere Informationen <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">hier.</a>",
                "moreInformationEmployee": "Weitere Informationen für Ihre Mitarbeitende <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">hier.</a>",
                "moreInformationEmployer": "Weitere Informationen für Arbeitgeber <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">hier.</a>",
                "text1": "Dank einem neuen SECO-Pilotversuch können Sie mit Ihrer Registrierung auf {0} Ihren Mitarbeitenden aus den Kantonen Tessin und Graubünden in den Zwischensaisons einen Mehrwert bieten und sie damit besser binden.",
                "text1link": "www.jobs2share.ch",
                "text2": "Im Rahmen des SECO-Pilotprojekts besteht für Saisonmitarbeitende mit zwei Saisonstellen (Sommer/Winter) die Möglichkeit, <span class=\"highlighted\">bis zu 6 Wochen pro Jahr von erleichtertem Zugang zu Leistungen der Arbeitslosenkasse zu profitieren, ohne Arbeitsbemühungen</span> erbringen zu müssen (ALV-Sonderlösung). Damit können allfällige Erwerbslücken in den Zwischensaisons einfach und unkompliziert überbrückt werden.",
                "text3": "Das Angebot steht Mitarbeitenden mit Wohnsitz in den Kantonen Tessin und Graubünden ab 1. Januar 2019 vorerst für drei Jahre zur Verfügung. Verläuft das Pilotprojekt erfolgreich, kann diese Regelung ausgeweitet werden und bis zur Gesetzesänderung führen. Ihre Teilnahme und Registrierung auf {0} ist daher äusserst wertvoll!",
                "text3link": "www.jobs2share.ch",
                "text4": "Findet ein Stellensuchender auf {0} ein Job-Paket Sommer & Winter und ist dieses von Ihnen und dem zusätzlichen Arbeitgeber online bestätigt worden, so wird dies in seinem Profil ersichtlich und automatisch ein Kooperationsvertrag zwischen beiden Arbeitgebern generiert.{linebreak}{linebreak} Mitarbeitende müssen lediglich den Kooperationsvertrag herunterladen und zusammen mit den beiden Arbeitsverträgen frühzeitig (wenn möglich drei Monate vorher) dem zuständigen RAV zustellen, um von der ALV-Sonderlösung zu profitieren.",
                "text4link": "www.jobs2share.ch"
            },
            "show": "Anzeigen",
            "sponsorship": {
                "label": "Trägerschaft",
                "text": "Hinter jobs2share steht der unabhängige und nicht gewinnorientiert arbeitende Verein Mitarbeiter-Sharing. Dieser Verein richtet sich an den Bedürfnissen seiner Mitglieder/innen und Nutzer/innen aus, also einerseits an Mitarbeitenden, die gerne einer abwechslungsreichen Tätigkeit nachgehen möchten und andererseits an Unternehmen, die Saisonstellen anbieten. Der Verein wurde im Jahre 2016 von der Fachhochschule Graubünden (ehem. Hochschule für Technik und Wirtschaft HTW Chur) zusammen mit mehr als 20 Mitgliedsunternehmen gegründet. Die über 50 Betriebsstätten der Mitgliedsunternehmen stammen grösstenteils aus den Kantonen Graubünden und Tessin."
            },
            "tac": {
                "label": "AGBs"
            }
        },
        "validation": {
            "accepted": "{attribute} muss akzeptiert werden.",
            "active_url": "{attribute} ist keine gültige Internet-Adresse.",
            "after": "{attribute} muss ein Datum nach dem {date} sein.",
            "after_or_equal": "{attribute} muss ein Datum nach dem {date} oder gleich dem {date} sein.",
            "alpha": "{attribute} darf nur aus Buchstaben bestehen.",
            "alpha_dash": "{attribute} darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
            "alpha_num": "{attribute} darf nur aus Buchstaben und Zahlen bestehen.",
            "array": "{attribute} muss ein Array sein.",
            "before": "{attribute} muss ein Datum vor dem {date} sein.",
            "before_or_equal": "{attribute} muss ein Datum vor dem {date} oder gleich dem {date} sein.",
            "between": {
                "numeric": "{attribute} muss zwischen {min} & {max} liegen.",
                "file": "{attribute} muss zwischen {min} & {max} Kilobytes groß sein.",
                "string": "{attribute} muss zwischen {min} & {max} Zeichen lang sein.",
                "array": "{attribute} muss zwischen {min} & {max} Elemente haben."
            },
            "boolean": "{attribute} muss entweder 'true' oder 'false' sein.",
            "confirmed": "{attribute} stimmt nicht mit der Bestätigung überein.",
            "date": "{attribute} muss ein gültiges Datum sein.",
            "date_format": "{attribute} entspricht nicht dem gültigen Format für {format}.",
            "different": "{attribute} und {other} müssen sich unterscheiden.",
            "digits": "{attribute} muss {digits} Stellen haben.",
            "digits_between": "{attribute} muss zwischen {min} und {max} Stellen haben.",
            "dimensions": "{attribute} hat ungültige Bildabmessungen.",
            "distinct": "Das Feld {attribute} beinhaltet einen bereits vorhandenen Wert.",
            "email": "{attribute} muss eine gültige E-Mail-Adresse sein.",
            "ends_with": "Das Feld {attribute} muss mit einem der folgenden Werte enden: {values}",
            "exists": "Der gewählte Wert für {attribute} ist ungültig.",
            "file": "{attribute} muss eine Datei sein.",
            "filled": "{attribute} muss ausgefüllt sein.",
            "image": "{attribute} muss ein Bild sein.",
            "in": "Der gewählte Wert für {attribute} ist ungültig.",
            "in_array": "Der gewählte Wert für {attribute} kommt nicht in {other} vor.",
            "integer": "{attribute} muss eine ganze Zahl sein.",
            "ip": "{attribute} muss eine gültige IP-Adresse sein.",
            "ipv4": "{attribute} muss eine gültige IPv4-Adresse sein.",
            "ipv6": "{attribute} muss eine gültige IPv6-Adresse sein.",
            "json": "{attribute} muss ein gültiger JSON-String sein.",
            "max": {
                "numeric": "{attribute} darf maximal {max} sein.",
                "file": "{attribute} darf maximal {max} Kilobytes groß sein.",
                "string": "{attribute} darf maximal {max} Zeichen haben.",
                "array": "{attribute} darf nicht mehr als {max} Elemente haben."
            },
            "mimes": "{attribute} muss den Dateityp {values} haben.",
            "mimetypes": "{attribute} muss den Dateityp {values} haben.",
            "min": {
                "numeric": "{attribute} muss mindestens {min} sein.",
                "file": "{attribute} muss mindestens {min} Kilobytes groß sein.",
                "string": "{attribute} muss mindestens {min} Zeichen lang sein.",
                "array": "{attribute} muss mindestens {min} Elemente haben."
            },
            "not_in": "Der gewählte Wert für {attribute} ist ungültig.",
            "numeric": "{attribute} muss eine Zahl sein.",
            "phone": "Der gewählte Wert für {attribute} enthält eine ungültige Zahl.",
            "present": "Das Feld {attribute} muss vorhanden sein.",
            "regex": "{attribute} Format ist ungültig.",
            "required": "{attribute} muss ausgefüllt sein.",
            "required_if": "{attribute} muss ausgefüllt sein, wenn {other} {value} ist.",
            "required_unless": "{attribute} muss ausgefüllt sein, wenn {other} nicht {values} ist.",
            "required_with": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_with_all": "{attribute} muss angegeben werden, wenn {values} ausgefüllt wurde.",
            "required_without": "{attribute} muss angegeben werden, wenn {values} nicht ausgefüllt wurde.",
            "required_without_all": "{attribute} muss angegeben werden, wenn keines der Felder {values} ausgefüllt wurde.",
            "same": "{attribute} und {other} müssen übereinstimmen.",
            "size": {
                "numeric": "{attribute} muss gleich {size} sein.",
                "file": "{attribute} muss {size} Kilobyte groß sein.",
                "string": "{attribute} muss {size} Zeichen lang sein.",
                "array": "{attribute} muss genau {size} Elemente haben."
            },
            "string": "{attribute} muss ein String sein.",
            "timezone": "{attribute} muss eine gültige Zeitzone sein.",
            "unique": "{attribute} ist schon vergeben.",
            "uploaded": "Der {attribute} konnte nicht hochgeladen werden.",
            "url": "Das Format von {attribute} ist ungültig.",
            "password_strength": "Das Passwort ist zu wenig stark. Bitte verwenden Sie mindestens: 1 Grossbuchstabe, 1 Kleinbuchstabe, 1 Zahl und 1 Sonderzeichen (z.B. , . _ & ? etc)",
            "password": "Das Passwort ist nicht korrekt.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "Name",
                "username": "Benutzername",
                "email": "E-Mail-Adresse",
                "first_name": "Vorname",
                "last_name": "Nachname",
                "password": "Passwort",
                "password_confirmation": "Passwordbestätigung",
                "city": "Stadt",
                "country": "Land",
                "address": "Adresse",
                "phone": "Telefonnummer",
                "mobile": "Handynummer",
                "age": "Alter",
                "sex": "Geschlecht",
                "gender": "Geschlecht",
                "day": "Tag",
                "month": "Monat",
                "year": "Jahr",
                "hour": "Stunde",
                "minute": "Minute",
                "second": "Sekunde",
                "title": "Titel",
                "content": "Inhalt",
                "description": "Beschreibung",
                "excerpt": "Auszug",
                "date": "Datum",
                "time": "Uhrzeit",
                "available": "verfügbar",
                "size": "Größe"
            }
        },
        "texts": {
            "DataPermanentlyLost": "Ihre Daten gehen endgültig verloren",
            "abort": "Abbrechen",
            "about": "Über uns",
            "acceptAGB": "Ich habe die jobs2share-AGB gelesen und akzeptiert",
            "acceptAGBandPrivacyPolicy": "Ich habe die <a href=\"/de/terms-and-conditions\" target=\"_blank\">jobs2share-AGB und Datenschutzbestimmungen</a> gelesen und akzeptiert",
            "acceptAdvertising": "Ich möchte den jobs2share Newsletter erhalten",
            "acceptPrivacyPolicy": "Ich habe die jobs2share-Datenschutzerklärung gelesen und akzeptiert",
            "acceptRules": "Ich habe die <a href=\"/de/employer/rules-of-the-game\" target=\"_blank\">«Spielregeln Fair Play»</a> gelesen und akzeptiert",
            "actionCannotBeUndone": "Diese Aktion kann nicht rückgängig gemacht werden",
            "actions": "Aktionen",
            "active": "Aktiv",
            "activeApplicationsTablePlaceholder": "Hier werden die Bewerbungen auf Ihre Inserate erscheinen",
            "add": "Hinzufügen",
            "addAddon": "Zusatzabo hinzufügen",
            "addCertificate": "Sonstige hinzufügen",
            "addCompany": "Unternehmen hinzufügen",
            "addDocuments": "Fügen Sie Zeugnisse, Zertifikate, Auszeichnungen oder weitere Dokumente hinzu",
            "addEducation": "Ausbildung hinzufügen",
            "addExperience": "Berufserfahrung hinzufügen",
            "addFavoriteSuccessful": "Inserat wurde erfolgreich als Favorit markiert",
            "addJob": "Stelleninserat erfassen",
            "addLanguage": "Sprache hinzufügen",
            "addNewFiles": "Neue Datei hinzufügen",
            "addOtherDocument": "Sonstige hinzufügen",
            "addSubscription": "Hauptabo hinzufügen",
            "addedOn": "Hinzugefügt am",
            "additionalCompanies": "Zusätzliche Unternehmen",
            "additionalDocuments": "Beilagen",
            "additionalTextSumbitApplication": "Nach dem Einreichen kann die Bewerbung nicht mehr bearbeitet werden",
            "addon": "Zusatzabo|Zusatzabos",
            "address": "Adresse",
            "administrateCompanies": "Unternehmen verwalten",
            "administration": "Administration",
            "alert": {
                "acceptEmployeeError": "Arbeitsverhältnis konnte nicht bestätigt werden",
                "acceptEmployeeSuccessful": "Arbeitsverhältnis wurde erfolgreich bestätigt",
                "addAddonError": "Zusatzabo konnte nicht hinzugefügt werden",
                "addAddonSuccessful": "Zusatzabo wurde erfolgreich hinzugefügt",
                "addCompanyError": "Unternehmen konnte nicht hinzugefügt werden",
                "addCompanySuccessful": "Unternehmen wurde erfolgreich hinzugefügt",
                "addContactPersonError": "Kontaktperson konnte nicht hinzugefügt werden",
                "addContactPersonSuccessful": "Kontaktperson wurde erfolgreich hinzugefügt",
                "addFavoriteError": "Inserat konnte nicht als Favorit gesetzt werden",
                "addJobApplicationError": "Bewerbung konnte nicht gespeichert werden",
                "addJobApplicationSuccessful": "Bewerbung wurde erfolgreich gespeichert",
                "addJobError": "Stelleninserat konnte nicht hinzugefügt werden",
                "addJobSuccessful": "Stelleninserat wurde erfolgreich hinzugefügt",
                "addResumeCertificationsError": "Eintrag konnte nicht hinzugefügt werden",
                "addResumeCertificationsSuccessful": "Eintrag wurde erfolgreich hinzugefügt",
                "addResumeEducationsError": "Ausbildung konnte nicht hinzugefügt werden",
                "addResumeEducationsSuccessful": "Ausbildung wurde erfolgreich hinzugefügt",
                "addResumeJobsError": "Berufserfahrung konnte nicht hinzugefügt werden",
                "addResumeJobsSuccessful": "Berufserfahrung wurde erfolgreich hinzugefügt",
                "addResumeLanguagesError": "Sprache konnte nicht hinzugefügt werden",
                "addResumeLanguagesSuccessful": "Sprache wurde erfolgreich hinzugefügt",
                "addResumeOtherDocumentsError": "Eintrag konnte nicht hinzugefügt werden",
                "addResumeOtherDocumentsSuccessful": "Eintrag wurde erfolgreich hinzugefügt",
                "addSubscrptionError": "Abo konnte nicht hinzugefügt werden",
                "addSubscrptionSuccessful": "Abo wurde erfolgreich hinzugefügt",
                "cancelSubscriptionError": "Abo konnte nicht storniert werden",
                "cancelSubscriptionSuccessful": "Abo wurde erfolgreich storniert",
                "changeBillingCycleSuccessful": "Vielen Dank, Sie haben Ihr Abo auf jobs2share verlängert. Ihr neues Abo endet am {0}.",
                "changeCreditCardError": "Kreditkarte konnte nicht aktualisiert werden",
                "changeCreditCardSuccessful": "Kreditkarte wurde erfolgreich aktualisiert",
                "couponCodeInvalid": "Ungültiger Gutscheincode",
                "couponCodeValid": "Gültiger Gutscheincode",
                "creditCardError": "Ihre Kreditkarte wurde nicht akzeptiert",
                "declineEmployeeError": "Status der Bewerbung konnte nicht aktualisiert werden",
                "declineEmployeeSuccessful": "Status der Bewerbung erfolgreich aktualisiert",
                "declineRenewEmployeeError": "Wiedereintritt konnte nicht abgelehnt werden",
                "declineRenewEmployeeSuccessful": "Wiedereintritt wurde erfolgreich abgelehnt",
                "deleteAddonError": "Zusatzabo konnte nicht gelöscht werden",
                "deleteAddonSuccessful": "Zusatzabo wurde erfolgreich gelöscht",
                "deleteCompanyError": "Unternehmen konnte nicht entfernt werden",
                "deleteCompanySuccessful": "Unternehmen wurde erfolgreich entfernt",
                "deleteJobApplicationError": "Bewerbung konnte nicht gelöscht werden",
                "deleteJobApplicationSuccessful": "Bewerbung wurde erfolgreich gelöscht",
                "deleteJobError": "Stelleninserat konnte nicht gelöscht werden",
                "deleteJobSuccessful": "Stelleninserat wurde erfolgreich gelöscht",
                "deleteProfilePictureError": "Profilbild konnte nicht gelöscht werden",
                "deleteProfilePictureSuccessful": "Profilbild wurde erfolgreich gelöscht",
                "deleteResumeCertificationsError": "Eintrag konnte nicht gelöscht werden",
                "deleteResumeCertificationsSuccessful": "Eintrag wurde erfolgreich gelöscht",
                "deleteResumeEducationsError": "Ausbildung konnte nicht gelöscht werden",
                "deleteResumeEducationsSuccessful": "Ausbildung wurde erfolgreich gelöscht",
                "deleteResumeJobsError": "Berufserfahrung wurde nicht gelöscht",
                "deleteResumeJobsSuccessful": "Berufserfahrung wurde erfolgreich gelöscht",
                "deleteResumeLanguagesError": "Sprache wurde nicht gelöscht",
                "deleteResumeLanguagesSuccessful": "Sprache wurde erfolgreich gelöscht",
                "deleteResumeOtherDocumentsError": "Eintrag wurde nicht gelöscht",
                "deleteResumeOtherDocumentsSuccessful": "Eintrag wurde erfolgreich gelöscht",
                "deleteSubscriptionError": "Abo konnte nicht gelöscht werden",
                "deleteSubscriptionSuccessful": "Abo wurde erfolgreich gelöscht",
                "endOfWorkError": "Arbeitsende muss nach Arbeitsbeginn liegen",
                "formRequiredFieldsError": "Bitte alle rot markierten Felder ausfüllen",
                "jobContainsEmailError": "Stelleninserate dürfen keine Emailadressen enthalten. Bewerbungen erfolgen über das Bewerbungstool von jobs2share. Die kompletten Unterlagen der Bewerber können Sie bequem als PDF herunterladen.",
                "registerNewsletterError": "Anmeldung Newsletter fehlgeschlagen",
                "registerNewsletterSuccessful": "Anmeldung Newsletter erfolgreich",
                "removeFavoriteError": "Stelleninserat wurde nicht von Favoriten entfernt",
                "renewEmployeeError": "Wiedereintritt wurde nicht hinzugefügt",
                "renewEmployeeSuccessful": "Wiedereintritt wurde erfolgreich hinzugefügt",
                "reportErrorError": "Ihre Anfrage konnte nicht übermittelt werden",
                "reportErrorSuccessful": "Ihre Anfrage wurde erfolgreich übermittelt",
                "sendContactError": "Anfrage konnte nicht versendet werden",
                "sendContactSuccessful": "Anfrage erfolgreich versendet",
                "storeAdditionalCompanyError": "Zusätzliches Unternehmen konnte nicht hinzugefügt werden",
                "storeAdditionalCompanySuccessful": "Zusätzliches Unternehmen wurde erfolgreich hinzugefügt",
                "storeSubscriptionCouponError": "Gutscheincode konnte nicht hinzugefügt werden",
                "storeSubscriptionCouponSuccessful": "Gutscheincode wurde erfolgreich hinzugefügt",
                "storeSubscriptionError": "Abo konnte nicht hinzugefügt werden",
                "storeSubscriptionSuccessful": "Abo wurde erfolgreich hinzugefügt",
                "subscriptionRequired": {
                    "updateEmployee": "Arbeitsverhältnisse können nur mit gültigem Abonnement verwaltet werden"
                },
                "updateAddonError": "Zusatzabo wurde nicht aktualisiert",
                "updateAddonSuccessful": "Zusatzabo wurde erfolgreich aktualisiert",
                "updateAllNotificationsError": "Benachrichtigungen konnten nicht als gelesen markiert werden",
                "updateAllNotificationsSuccessful": "Benachrichtigungen wurden erfolgreich aktualisiert",
                "updateCompanyProfileError": "Unternehmensprofil konnte nicht aktualisiert werden",
                "updateCompanyProfileSuccessful": "Unternehmensprofil wurde erfolgreich aktualisiert",
                "updateContactPersonError": "Kontaktperson konnte nicht geändert werden",
                "updateContactPersonSuccessful": "Kontaktperson erfolgreich geändert",
                "updateEntryError": "Eintrag konnte nicht aktualisiert werden",
                "updateEntrySuccessful": "Eintrag wurde erfolgreich aktualisiert",
                "updateJobApplicationError": "Bewerbung konnte nicht aktualisiert werden",
                "updateJobApplicationStatusError": "Status der Bewerbung konnte nicht aktualisiert werden",
                "updateJobApplicationStatusSuccessful": "Status der Bewerbung wurde erfolgreich aktualisiert",
                "updateJobApplicationSuccessful": "Bewerbung erfolgreich aktualisiert",
                "updateJobError": "Stelleninserat konnte nicht geändert werden",
                "updateJobSuccessful": "Stelleninserat erfolgreich geändert",
                "updateLocationError": "Standort konnte nicht geändert werden",
                "updateLocationSuccessful": "Standort wurde erfolgreich geändert",
                "updateProfilePictureError": "Profilbild konnte nicht geändert werden",
                "updateProfilePictureSuccessful": "Profilbild erfolgreich geändert",
                "updateResumeCertificationsError": "Eintrag konnte nicht aktualisiert werden",
                "updateResumeCertificationsSuccessful": "Eintrag wurde erfolgreich aktualisiert",
                "updateResumeEducationsError": "Ausbildung konnte nicht aktualisiert werden",
                "updateResumeEducationsSuccessful": "Ausbildung wurde erfolgreich aktualisiert",
                "updateResumeJobsError": "Berufserfahrung konnte nicht aktualisiert werden",
                "updateResumeJobsSuccessful": "Berufserfahrung wurde erfolgreich aktualisiert",
                "updateResumeLanguagesError": "Sprache konnte nicht aktualisiert werden",
                "updateResumeLanguagesSuccessful": "Sprache wurde erfolgreich aktualisiert",
                "updateSubscriptionError": "Abo konnte nicht aktualisiert werden",
                "updateSubscriptionSuccessful": "Abo wurde erfolgreich aktualisiert",
                "updateUserProfileError": "Profil konnte nicht aktualisiert werden",
                "updateUserProfileSuccessful": "Profil wurde erfolgreich aktualisiert"
            },
            "all": "Alle",
            "allNotificationsRead": "Alle als gelesen markieren",
            "amount": "Betrag",
            "and": "und",
            "applicants": "Bewerber",
            "application": {
                "completed": "Abgeschlossene Bewerbungen",
                "completedInfo": "Text einfügen",
                "label": "Bewerbung|Bewerbungen",
                "noEntries": "Hier erscheinen Ihre Bewerbungen",
                "ongoing": "Offene Bewerbungen",
                "ongoingInfo": "Text einfügen"
            },
            "applicationAs": "Bewerbung als",
            "applicationDetails": "Bewerbungsdetails",
            "applicationDocuments": "Bewerbungsunterlagen",
            "applicationDocumentsSubtitle": "Lebenslauf, Sprachen, Zertifikate",
            "applicationLetter": "Bewerbungsschreiben",
            "applicationStatus": {
                "CONTRACTSENT": "Arbeitsvertrag zugesendet",
                "CONTRACTSIGNED": "Zusage",
                "DRAFT": "Entwurf",
                "INTERVIEW": "Zum Bewerbungsgespräch eingeladen",
                "READ": "Gelesen",
                "REFUSAL": "Absage",
                "REFUSALEMPLOYEE": "Absage durch Bewerbenden",
                "SENT": "Bewerbung eingereicht",
                "change": "Status der Bewerbung ändern"
            },
            "applications": "Bewerbungen",
            "appliedForOn": "Beworben am",
            "apply": "Bewerben",
            "april": "April",
            "archived": "Archiviert",
            "association": "Verein Mitarbeiter-Sharing",
            "attachedFiles": "Angehängte Dateien",
            "attentionNoCurrentJob": "Vergessen Sie nicht Ihre aktuelle Stelle einzutragen, diese könnte zu einem Sommer-Winter-Jobpaket führen.",
            "attentionNoLetter": "Achtung: Sie haben kein Bewerbungsschreiben verfasst.",
            "attentionShortLetter": "Achtung: Ihr Bewerbungsschreiben ist sehr kurz, viele Arbeitgeber wünschen sich ein längeres Schreiben.",
            "august": "August",
            "automaticallyAddedOnReceiptOfJob": "Dieser Eintrag wurde automatisch hinzugefügt, weil ihr Arbeitgeber diese Anstellung bestätigt hat.",
            "avamCodeHelp": {
                "description": "jobs2share benötigt die genaue Berufszurodnung des Stelleninserats.\nGewisse Berufe sind meldepflichtig und müssen vor Veröffentlichung der\nöffentlichen Arbeitsvermittlung gemeldet werden.",
                "moreInformation": "Weitere Informationen finden Sie im",
                "ricac": "Westschweizer Referenzsystem über die Tätigkeiten und Kompetenzen.",
                "title": "Hilfe Berufsbezeichnung"
            },
            "back": "Zurück",
            "backtoOverview": "Zurück zur Übersicht",
            "billingCycle": "Verrechnungszyklus",
            "birthday": "Geburtstag",
            "buySubscription": "Abo kaufen",
            "callOff": "Absageschreiben",
            "cancel": "Abbrechen",
            "cancelSubmitApplication": "Zurück",
            "cancelSubscription": "Kündigen",
            "category": "Kategorie",
            "certificate": "Sonstiges",
            "changeCreditCard": "Kreditkarte ändern",
            "changeSubscription": "Abo wechseln",
            "chargesUp": "Lädt hoch",
            "choose": "Wählen",
            "chooseAddon": "Zusatzabo wählen",
            "chooseCompany": "Unternehmen wählen",
            "chooseReason": "Bitte wählen Sie einen Grund aus:",
            "chooseSubscription": "Abokategorie wählen",
            "closure": "Abschluss",
            "comletedApplicationsTablePlaceholder": "Hier werden die abgeschlossenen Bewerbungen erscheinen",
            "company": {
                "image": "Foto Ihres Unternehmens",
                "label": "Unternehmen",
                "maps": "Google Maps Standort",
                "profile": {
                    "general": "Unternehmensprofil",
                    "general-info": "Standort, Motto und Beschreibung",
                    "images": "Logo und Foto",
                    "images-info": "Ergänzen Sie Ihr Profil mit Logo und Foto",
                    "images-size-info": "Empfohlene Masse: 800px Breite und 230px Höhe",
                    "images-type-info": "Erlaubte Dateitypen: JPG, PNG, GIF",
                    "settings": "Einstellungen"
                },
                "sizes": {
                    "big": "ab 81 Mitarbeitende",
                    "medium": "31 - 80 angestellte Personen (Max. Anzahl während Hauptsaison)",
                    "micro": "Bis zu 10 angestellte Personen (Max. Anzahl während Hauptsaison)",
                    "small": "11 - 30 angestellte Personen (Max. Anzahl während Hauptsaison)"
                },
                "uploadLogo": "Klicken Sie hier, um ein eigenes Logo hochzuladen"
            },
            "companyAlreadyExists": "Dieses Unternehmen wurde bereits registriert.",
            "completeCompanyProfile": "Bitte vervollständigen Sie Ihr Unternehmensprofil:",
            "completeEmployeeProfile": "Einträge über die Berufserfahrung können nur mit vollständigem Profil hinzugefügt werden.",
            "completeProfile": "Profil vervollständigen",
            "completed": "Abgeschlossen",
            "confirm": "Bestätigen",
            "confirmDeleteJobApplication": "Ja, Bewerbung löschen",
            "confirmMessage": "Möchten Sie diese Aktion wirklich ausführen?",
            "confirmSubmitApplication": "Bewerbung einreichen",
            "confirmSubscriptionSelection": "Ich bestätige, dass das gewählte Unternehmen die im Abo maximal erlaubte Anzahl Mitarbeitende während der Hochsaison nicht überschreitet.",
            "contact": "Kontakt",
            "contactDetails": "Kontaktdaten",
            "contactPerson": "Kontaktperson",
            "cook": "Koch/Köchin",
            "cooperation": "Kooperation|Kooperationen",
            "cooperationAgreement": "Kooperationsvertrag|Kooperationsverträge",
            "cooperationAgreementInvalid": "Kooperationsvertrag ungültig",
            "cooperationAgreementPdf": {
                "at": "bei",
                "currentWorkingPermit": "Derzeitige Arbeitsbewilligung",
                "duration": "Laufzeiten Saisonverträge",
                "end": "Ende",
                "information": "Für Arbeitnehmer/innen mit Wohnsitz oder Wochenaufenthalterstatus in den Kantonen Graubünden und Tessin kann der Kooperationsvertrag zusammen mit dem Saisonarbeitsvertrag der kommenden Saison als Nachweis beim zuständigen RAV eingereicht werden, um von den ALV-Sonderregelungen gem. Pilotprojekt «Mitarbeiter-Sharing» vom Seco zu profitieren. Er wird automatisch via jobs2share erstellt und erhält seine Gültigkeit, in dem die beiden Arbeitgeber diese freigeben. Es fällt in die Verantwortung des Mitarbeitenden, das Dokument dem zuständigen RAV frühzeitig vorzulegen.",
                "integratedPart": "Dieser Kooperationsvereinbarung ist ergänzender Bestandteil der einzelnen Arbeitsverträge zwischen",
                "intentionText": "Die Kooperationsvereinbarung zeigt die Absicht der drei Parteien, über die aktuelle Saison hinaus zusammen zu arbeiten. Die beiden Arbeitgeber bestätigen, dass sie den Mitarbeiter/die Mitarbeiterin in seiner/ihrer persönlichen Weiterentwicklung über die einzelne Saison hinaus und im Rahmen ihrer Möglichkeiten gemeinsam unterstützen wollen. Die Kooperationsvereinbarung basiert auf zwei gültigen Arbeitsverträgen (aktuell laufender Saisonarbeitsvertrag sowie ein Saisonarbeitsvertrag für die nachfolgende Saison).",
                "mainResidence": "Wohnsitz",
                "onlineVerification": "Online-Verifikation",
                "position": "Funktion/Stellenbezeichnung",
                "scanInfo": "Zur Überprüfung der Gültigkeit dieses Kooperationsvertrages scannen Sie folgenden QR-Code.",
                "start": "Start"
            },
            "cooperationAgreementValid": "Kooperationsvertrag gültig",
            "copy": "Kopieren",
            "corona": {
                "alertText": "Information zur aktuellen Lage",
                "bag": "Bundesamt für Gesundheit (BAG)",
                "hotelleriesuisseGrisons": "Hotelleriesuisse Graubünden",
                "hotelleriesuisseTicino": "Hotelleriesuisse Ticino",
                "text": "<p>Aufgrund der aktuellen Lage kommt es in vielen unserer Partnerbetriebe zu zeitlichen Verzögerungen in der Planung. Unsere Betriebe sind bemüht, ihre Stellenangebote ständig zu aktualisieren.</p><p>Herzlichen Dank für Ihre Geduld, schon bald werden Sie sich auf interessante Saisonstellen bewerben können!</p><p>Wir wünschen allen Saisonmitarbeitenden und Betrieben gute Gesundheit.</p><p>Ihr Jobs2share.ch-Team & Verein Mitarbeiter-Sharing.</p>",
                "usefulInformation": "Wertvolle Informationen finden Sie hier:"
            },
            "correctDeclinedJobEntry": "Korrigieren Sie die Anstellung und lassen Sie diese vom Arbeitgeber bestätigen. Bestätigte Anstellungen führen zu Job-Paketen und Sie profitieren von vielen Vorteilen.",
            "count": "Anzahl",
            "country": "Land",
            "coupon": "Gutschein",
            "couponCode": "Gutscheincode",
            "create": "Erstellen",
            "createdOn": "Erstellt am",
            "creditCard": "Kreditkarte",
            "creditCardEndsWith": "Kreditkarte endet mit",
            "creditcardInvalid": "Bitte fügen Sie eine gültige Kreditkarte hinzu.",
            "currentJob": "Aktueller Job",
            "dashboard": {
                "applicationDescription": "Offene Bewerbungen verbleiben hier, bis sie von Ihnen angenommen oder abgelehnt werden.",
                "assignmentDescription": "Arbeiten diese Personen aktuell oder künftig bei Ihnen? Bitte bestätigen Sie.",
                "jobsDescription": "Ihre aktiven Stelleninserate auf einen Blick",
                "label": "Dashboard",
                "reenterDescription": "Welche Ihrer Mitarbeitenden kommen zu Ihnen zurück? Aktualisieren Sie den Status und helfen Sie ihren Mitarbeitenden frühzeitig Jobpakete Sommer/Winter zu schnüren!"
            },
            "date": "Datum",
            "day": "Tag|Tage",
            "december": "Dezember",
            "decline": "Ablehnen",
            "declineEmployeeTypes": {
                "DATE": "Zeitraum ist nicht korrekt",
                "OTHER": "Andere Gründe",
                "TITLE": "Stellenbeschreibung ist nicht korrekt",
                "UNKNOWN": "Name ist uns nicht bekannt"
            },
            "declineRequest": "Anfrage ablehnen",
            "delete": "Löschen",
            "deleteCompany": "Unternehmen löschen",
            "deleteCompanyQuestion": "Möchten Sie dieses Unternehmen wirklich löschen?",
            "deleteDefinitely": "Endgültig löschen",
            "deleteEntry": "Eintrag löschen",
            "deleteEntryInfo": "Diese Stelle ist Teil eines Jobpakets bzw. eines Kooperationsvertrages und kann nicht geändert oder gelöscht werden. Sie wurde vom Arbeitgeber bestätigt. Mit dem Button „Fehler melden“ können Sie uns mitteilen, wenn etwas nicht stimmt.",
            "deleteEntryQuestion": "Möchten Sie diesen Eintrag wirklich löschen?",
            "deleteJob": "Stelleninserat löschen",
            "deleteJobApplication": "Bewerbung löschen",
            "deleteJobApplicationSuccessful": "Bewerbung wurde erfolgreich gelöscht.",
            "deleteJobQuestion": "Möchten Sie folgendes Inserat wirklich endgültig löschen?",
            "deletePermanently": "Endgültig löschen",
            "deleteProfile": "Profil löschen",
            "deleteProfilePicture": "Profilbild löschen",
            "deleteProfileQuestion": "Möchten Sie Ihr Profil wirklich löschen?",
            "description": "Beschreibung",
            "details": "Details",
            "directCall": "Direktwahl",
            "displayContract": "Vertrag anzeigen",
            "domesticEconomy": "Hauswirtschaft",
            "draft": "Entwurf",
            "duration": "Dauer",
            "duringPeakSeason": "Während Hauptsaison",
            "edit": "Bearbeiten",
            "editAddon": "Zusatzabo ändern",
            "editCertificate": "Eintrag bearbeiten",
            "editEducation": "Ausbildung bearbeiten",
            "editExperience": "Berufserfahrung bearbeiten",
            "editJob": "Stelleninserat bearbeiten",
            "editLanguage": "Sprache bearbeiten",
            "editOtherDocument": "Dokument bearbeiten",
            "editSubscription": "Abo ändern",
            "editorPlaceholder": "Geben Sie hier Ihren Text ein",
            "education": "Ausbildung",
            "email": "E-Mailadresse",
            "employee": {
                "all": "Alle Angestellten",
                "assignment": "Arbeitsverhältnis bestätigen",
                "assignmentInfo": "Text einfügen",
                "edit": "Arbeitsverhältnis bearbeiten",
                "employed": "Derzeit angestellt",
                "employedInfo": "Text einfügen",
                "employmentChange": "Anstellung ändern",
                "employmentDidNotTakeUp": "Mitarbeitende/r hat Stelle nicht angetreten",
                "employmentTerminated": "Anstellung wurde aufgelöst",
                "employmentWillNotTakeUp": "Mitarbeitende/r wird Stelle nicht antreten",
                "former": "Ehemals angestellt",
                "formerInfo": "Text einfügen",
                "future": "Zukünftig angestellt",
                "futureInfo": "Text einfügen",
                "label": "Angestellte",
                "noEntries": "Keine Arbeitnehmenden gefunden"
            },
            "employeeInfo": "Derzeit können sich nur Unternehmen registrieren",
            "employeeReEnter": {
                "APPROVE": "Mitarbeiter wird wieder zu uns zurückkehren",
                "DECLINE": "Mitarbeiter wird nicht zu uns zurückkehren",
                "label": "Wiedereintritt"
            },
            "employeeTitle": "Mitarbeiter|Mitarbeiterin",
            "employees": "Mitarbeiter/in",
            "emptyJobs": "Noch keine Inserate erfasst",
            "end": "Ende",
            "endMonth": "Endmonat",
            "endOfTraining": "Ausbildungsende",
            "endOfWork": "Arbeitsende",
            "english": "English",
            "enterDateOfBirth": "Geburtsdatum eingeben",
            "entriesPerPage": "Einträge pro Seite",
            "error": "Fehler",
            "errorMessage": "Es ist ein Fehler aufgetreten. Bitte teilen Sie uns das Auftreten dieses Fehlers über die Schaltfläche 'Fehler melden' mit",
            "favorites": "Favoriten",
            "february": "Februar",
            "feedback": "Feedback",
            "filename": "Dateiname",
            "filter": "Filter",
            "finishRegistration": "Registrierung abschliessen",
            "firstName": "Vorname",
            "forgotPassword": "Passwort vergessen",
            "french": "Französisch",
            "fullTime": "Vollzeit",
            "functionNotAvailable": "Diese Funktion ist noch nicht verfügbar",
            "functionOnlyLoggedInAvailable": "Diese Funktion ist nur eingeloggt verfügbar.",
            "garden": "Garten",
            "german": "Deutsch",
            "help": "Hilfe",
            "home": "Home",
            "hotelCategory": "Hotelkategorie",
            "imageUploadInfo": "Bild hochladen (wird automatisch gespeichert)",
            "impress": "Impressum",
            "info": {
                "label": "Info",
                "noFavorites": "Sie haben keine Stelleninserate als Favoriten markiert."
            },
            "insertJobtitle": "Stellenbezeichnung",
            "insertPassword": "Passwort eingeben",
            "interruption": "Unterbruch",
            "introduction": "Einleitung",
            "invalidCredentials": "E-Mailadresse oder Passwort ungültig",
            "invoice": {
                "address": "Empfänger",
                "after": "ab",
                "alreadyPaid": "Der Betrag wurde Ihrer Kreditkarte belastet.",
                "date": "Rechnungsdatum",
                "footer": "Verein Mitarbeiter-Sharing, c/o Fachhochschule Graubünden, Comercialstrasse 22, 7000 Chur",
                "info": {
                    "monthly": "Die Abrechnung erfolgt monatlich. Ihr Jahresabo können Sie im letzten Monat der Laufzeit kündigen.",
                    "yearly": "Die Abrechnung erfolgt jährlich. Ihr Jahresabo können Sie im letzten Monat der Laufzeit kündigen."
                },
                "number": "Rechnungsnummer",
                "offcoupon": "Rabatt mit Gutscheincode",
                "on": "im Abo",
                "remainingTime": "Verbleibende Zeit",
                "title": "Rechnung",
                "unitPrice": "Preis pro Stück",
                "unusedTime": "Ungenutzte Zeit"
            },
            "issuingAuthority": "Ausgebende Stelle",
            "italian": "Italienisch",
            "janitor": "Hausdienst",
            "january": "Januar",
            "job": "Stelleninserat",
            "jobActive": "Stelleninserat aktiv",
            "jobAdvertisementsOnlyWithValidSubscription": "Stelleninserate eines Unternehmens sind nur mit laufendem Abo aktiv.",
            "jobApproved": "Von {company} bestätigt",
            "jobCategory": {
                "1": "Küche",
                "2": "Service",
                "3": "Réception & Administration",
                "4": "Hauswirtschaft",
                "5": "Wellness, Beauty, Health, Sport",
                "6": "Technik, Unterhalt, Garten",
                "7": "Sonstiges",
                "label": "Stellenkategorie"
            },
            "jobDeclined": "Von {company} abgelehnt",
            "jobEntryDate": "Stellenantritt",
            "jobExitDate": "Stellenaustritt",
            "jobLanguage": "Sprache des Stelleninserats",
            "jobNotifiedApproved": "Stelle bereits gemeldet und freigegeben",
            "jobOverPlatform": "Job über jobs2share erhalten",
            "jobPosition": {
                "1": "Ausbildung",
                "2": "Praktikum",
                "3": "Angelernt",
                "4": "Fachkraft",
                "5": "Führungskraft",
                "label": "Position"
            },
            "jobRoomWaitingActivation": "Stelleninserat wartet auf die Freischaltung durch den Jobroom.",
            "jobSearch": "Stellensuche",
            "jobStatus": {
                "CANCELLED": "Storniert",
                "INSPECTING": "In Prüfung",
                "PUBLISHED_PUBLIC": "Veröffentlicht",
                "PUBLISHED_RESTRICTED": "Sperrfrist",
                "REJECTED": "Abgelehnt",
                "UNSYNCRONIZED": "Synchronisation ausstehend"
            },
            "jobTitle": "Stelleninserate",
            "jobTitleAvam": "Berufsbezeichnung (Avam)",
            "jobroomConfirmationPending": "Bestätigung Jobroom ausstehend",
            "jobs": "Stelleninserate",
            "jobsTableNoEntries": "Keine Stelleninserate erfasst",
            "jobsTablePlaceholder": "Hier erscheinen Ihre Stelleninserate",
            "july": "Juli",
            "june": "Juni",
            "kitchen": "Küche",
            "label": "Bezeichnung",
            "language": {
                "ar": "Arabisch",
                "cs": "Tschechisch",
                "da": "Dänisch",
                "de": "Deutsch",
                "el": "Griechisch",
                "en": "Englisch",
                "es": "Spanisch",
                "fi": "Finnisch",
                "fr": "Französisch",
                "he": "Hebräisch",
                "hu": "Ungarisch",
                "it": "Italienisch",
                "ja": "Japanisch",
                "ko": "Koreanisch",
                "label": "Sprache|Sprachen",
                "nl": "Niederländisch",
                "no": "Norwegisch",
                "pl": "Polnisch",
                "pt": "Portugiesisch",
                "ro": "Rumänisch",
                "ru": "Russisch",
                "sv": "Schwedisch",
                "sì": "Singhalesisch",
                "tr": "Türkisch",
                "yes": "Armenisch",
                "zh": "Chinesisch"
            },
            "lastActivity": "Letzte Aktivität",
            "lastName": "Nachname",
            "line": "Zeile|Zeilen",
            "locality": "Ortschaft",
            "lodging": "Unterkunft vorhanden",
            "login": "Login",
            "logo": "Logo",
            "logout": "Logout",
            "mainScubscription": "Hauptabonnement",
            "mainSubscriptionShort": "Hauptabo",
            "maintenanceText": "Jobs2share.ch ist zurzeit nur eingeschränkt verfügbar.",
            "manager": "Führungskraft",
            "march": "März",
            "maxDurationSeasonJobInfo": "Es können nur Saisonstellen erfasst werden. Die Dauer einer Saisonstelle beträgt max. 9 Monate.",
            "maximalDurationExceeded": "Maximale Dauer von 9 Monaten überschritten",
            "may": "May",
            "message": "Nachricht",
            "months": {
                "1": "Januar",
                "10": "Oktober",
                "11": "November",
                "12": "Dezember",
                "2": "Februar",
                "3": "März",
                "4": "April",
                "5": "Mai",
                "6": "Juni",
                "7": "Juli",
                "8": "August",
                "9": "September",
                "label": "Monat|Monate"
            },
            "moreInformation": "Weitere Informationen",
            "moreInformations": "Mehr Informationen",
            "motto": "Motto",
            "mustBeInFuture": "Darf nicht in der Vergangenheit liegen",
            "myJobs": "Meine Stellen",
            "myJobsIntro": "Hier sollten die wichtigsten beruflichen Stationen Ihrer bisherigen und zukünftigen Laufbahn eingefügt werden.<br>Aktuelle Stellen sind besonders wichtig, denn sie werden von Ihrem Arbeitgeber bestätigt und können zu einem Jobpaket führen.",
            "name": "Name",
            "nameOfCertificate": "Titel",
            "nameOfCompany": "Name des Unternehmens",
            "nameOfDocument": "Titel",
            "nationality": "Nationalität",
            "neither": "Keine",
            "newJob": "Neues Inserat",
            "newNotifications": "Neue Benachrichtigungen",
            "news": "News",
            "next": "Weiter",
            "nextCharge": "Nächste Belastung",
            "no": "Nein",
            "noAccountYet": "Haben Sie noch keinen Account?",
            "noActiveApplications": "Keine offenen Bewerbungen",
            "noCompaniesAddedYet": "Noch keine Unternehmen hinzugefügt",
            "noCompanyWithoutSubscription": "Kein Unternehmen ohne Abo verfügbar",
            "noCompletedApplications": "Keine abgeschlossenen Bewerbungen",
            "noCooperationAgreements": "Hier werden die Kooperationsverträge Ihrer Mitarbeitenden dargestellt",
            "noCooperationIdenticalCompany": "Achtung: In Ihrem Profil ist {company} bereits als Ihr vorheriger Arbeitgeber eingetragen. Mit Ihrer Bewerbung kommt kein Job-Paket zustande.",
            "noEndDate": "Kein Enddatum",
            "noExpirationDate": "Kein Ablaufdatum",
            "noNotifications": "Keine Benachrichtigungen",
            "noResults": "Keine passenden Inserate gefunden",
            "noSearchEntries": "Keine passenden Suchresultate",
            "noSubjectToRegistration": "Keine Meldepflicht",
            "notifications": {
                "applicationOpenReminder": {
                    "message": "Haben Sie {first_name} {last_name} eingestellt? Bitte aktualisieren Sie den Status der eingegangenen Bewerbungen."
                },
                "applicationOpenReminderPart1": "Haben Sie",
                "applicationOpenReminderPart2": "eingestellt? Bitte aktualisieren Sie den Status der eingegangenen Bewerbungen.",
                "applicationReceived": {
                    "message": "Neue Bewerbung von {first_name} {last_name}"
                },
                "companyLinkedToResumeJob": {
                    "message": "{first_name} {last_name} hat Ihr Unternehmen in seinem/ihrem Lebenslauf eingetragen. Bitte überprüfen Sie den Eintrag."
                },
                "cooperationAgreementChanged": {
                    "message": "Es wurden Änderungen am Kooperationsvertrag mit {company1} und {company2} vorgenommen"
                },
                "resumeJobEntryChanged": {
                    "message": "Es wurden Änderungen an Ihrer Stelle als {job_title} bei {company} vorgenommen"
                }
            },
            "november": "November",
            "numberOfEmployees": "Anzahl Mitarbeitende",
            "numberOfJobs": "Anzahl zu besetzender Stellen",
            "october": "October",
            "of": "von",
            "oldNotifications": "Ältere Benachrichtigungen",
            "onlyForEmployees": "Nur für Arbeitnehmende",
            "onlyForEmployeesText": "Diese Funktion ist nur für Arbeitnehmende verfügbar.",
            "open": "Offen",
            "openAccount": "Account anlegen",
            "other": "Sonstiges",
            "otherDocuments": "Sonstige Dokumente",
            "password": "Passwort",
            "passwordConfirmation": "Passwort wiederholen",
            "passwordResetFailed": "Passwort konnte nicht zurückgesetzt werden",
            "passwordResetInfo": "Sie erhalten eine E-Mail, um Ihr Passwort zurückzusetzen",
            "passwordResetSuccessful": "Passwort erfolgreich zurückgesetzt",
            "paymentPeriod": "Zahlungszyklus",
            "perMonth": "Pro Monat",
            "perYear": "Pro Jahr",
            "percent": "Prozent",
            "percentMax": "Prozent Maximum",
            "percentMin": "Prozent Minimum",
            "personalResponsibility": "Personalverantwortliche/r",
            "phone": "Telefonnummer",
            "place": "Ort",
            "platformName": "jobs2share",
            "pleaseLogIn": "Bitte loggen Sie sich ein",
            "preview": "Vorschau",
            "price": "Preis",
            "pricePerMonth": "Preis pro Monat",
            "pricePerYear": "Preis pro Jahr",
            "product": "Produkt|Produkte",
            "proficiency": {
                "1": "Grundkenntnisse",
                "2": "Gut",
                "3": "Fliessend",
                "4": "Muttersprache",
                "label": "Kenntnis"
            },
            "profile": "Profil",
            "profilePicture": "Profilbild",
            "profilePicture-size-info": "Empfohlene Masse: 500px Breite und 500px Höhe",
            "publishedOm": "Veröffentlicht am",
            "questionDeleteJobApplication": "Möchten Sie die Bewerbung endgültig löschen?",
            "questionSubmitApplication": "Möchten Sie die Bewerbung endgültig einreichen?",
            "questionsToCompany": "Bei Fragen wenden Sie sich bitte direkt an den Betrieb",
            "reason": "Begründung",
            "reasonDetail": "Detaillierte Begründung",
            "receipt": "Beleg|Belege",
            "reception": "Réception",
            "redeemCoupon": "Gutschein einlösen",
            "redeemCouponDescription": "Gutscheincode für das ausgewählte Abonnement einlösen.",
            "refreshlocation": "Standort aktualisieren",
            "register": "Registrieren",
            "registerNow": "Jetzt registrieren",
            "registration": "Registrierung",
            "rejectDeleteJobApplication": "Nein, Bewerbung behalten",
            "removeCompany": "Unternehmen entfernen",
            "removeCompanyText": "Möchten Sie das Unternehmen \"{companyName}\" wirklich entfernen? Sämtliche von diesem Unternehmen veröffentlichte Stelleninserate werden bei diesem Vorgang deaktiviert.",
            "removeFavoriteSuccessful": "Inserat wurde erfolgreich als Favorit entfernt",
            "renewJobs": "Inserate erneuern",
            "reportError": "Fehler melden",
            "reportProblem": "Problem melden",
            "resetFilter": "Filter zurücksetzen",
            "resetPassword": "Passwort zurücksetzen",
            "residencePermit": {
                "B": "B: Aufenthaltsbewilligung",
                "C": "C: Niederlassungsbewilligung",
                "G": "G: Grenzgänger",
                "L": "L: Kurzaufenthaltsbewilligung",
                "label": "Aufenthaltsbewilligungen"
            },
            "results": "Resultate",
            "resume": "Lebenslauf",
            "rowsPerPage": "Zeilen pro Seite",
            "salutation": "Anrede",
            "salutationMr": "Herr",
            "salutationMrText": "Lieber Herr",
            "salutationMrs": "Frau",
            "salutationMrsText": "Liebe Frau",
            "salutationText": "Guten Tag",
            "save": "Speichern",
            "saveAsDraft": "Als Entwurf speichern",
            "saveChanges": "Änderungen speichern",
            "search": "Suchen",
            "searchCompany": "Suchen Sie ihr Unternehmen",
            "searchResults": "Suchresultate",
            "season": "Saison",
            "seasonalJob": "Saisonstelle",
            "seasonalJobEndDateAfter": "Saisonstelle mit Enddatum nach dem {date}",
            "seasonalJobEndDateBefore": "Saisonstelle mit Enddatum vor dem {date}",
            "selectBillingCycle": "Verrechnungszyklus wählen, damit verlängern Sie automatisch Ihr Abo.<br>\nHerzlichen Dank für Ihr Vertrauen!",
            "selectFile": "Datei auswählen",
            "semiskilled": "Angelernt",
            "send": "Senden",
            "sent": "Gesendet",
            "september": "September",
            "service": "Service",
            "shortDescription": "Kurzbeschreibung",
            "show": "Anzeigen",
            "showAll": "Alle anzeigen",
            "showAllNotifications": "Alle Benachrichtigungen anzeigen",
            "showAndEdit": "Anzeigen und bearbeiten",
            "showApplication": "Bewerbung anzeigen",
            "skilledEmployee": "Fachkraft",
            "slogan": "Jobs2share<br>Saisonstellen mit Ganzjahresperspektive",
            "star": "Sterne|Stern",
            "start": "Start",
            "startMonth": "Startmonat",
            "startOfTraining": "Ausbildungsbeginn",
            "startOfWork": "Arbeitsbeginn",
            "status": "Status",
            "street": "Strasse",
            "streetNumber": "Nummer",
            "subject": "Betreff",
            "subjectToRegistration": "meldepflichtig",
            "submitApplication": "Bewerbung einreichen",
            "submitApplicationSuccessful": "Bewerbung wurde erfolgreich eingereicht",
            "subscription": "Abonnement",
            "subscriptionFreeExtension": "({0} Tage kostenlose Aboverlängerung)",
            "subscriptionInfoDialog": {
                "label": "Abo-Informationen",
                "link": "hier.",
                "text": "Sie können mehrere Unternehmen in Ihrem Account verwalten, in dem Sie \"Hauptabo hinzufügen\" wählen. Als Besitzer eines Hauptabo der Kategorie «Gross» können Sie zudem von einem Spezialangebot gebrauch machen: Für jedes zusätzliche Unternehmen in ihrem Account bezahlen Sie lediglich 24.90 CHF / Monat anstelle des regulären Preises (ab 49.90 CHF). Wenn Sie dieses attraktive Angebot nutzen wollen, dann wählen Sie «Zusatzabo hinzufügen». Weitere Infos zu den Abos finden Sie {0}"
            },
            "subscriptionInformation": "Abo-Informationen",
            "subscriptionPeriod": "Laufzeit",
            "subscriptionRenewOn": "Abo wird verlängert am",
            "subscriptionRenewOnInfoText": "Sie haben Ihr Abo am {0} gewechselt und dadurch Ihr Abo verlängert.",
            "subscriptionRequiredText": "Inserate werden nur mit gültigem Abonnement veröffentlicht",
            "subscriptionShort": "Abo",
            "subscriptionTerminateDialog": {
                "hasActiveAdditionalCompanies": "Dieses Abonnement verfügt über aktive zusätzliche Unternehmen und kann nicht gekündet werden.<br>Bitte künden Sie zuerst die zusätzlichen Unternehmen.",
                "info": "Nach Ihrer Kündigung werden ab dem {0} folgende Möglichkeiten nicht mehr zur Verfügung stehen.",
                "intro": "Sie möchten das Abonnement für folgendes Unternehmen künden?",
                "options": "<ul>\n<li>Veröffentlichen von Stelleninseraten</li>\n<li>Erhalten von Bewerbungen</li>\n<li>Akzeptieren von Mitarbeitern</li>\n</ul>"
            },
            "subscriptionTerminatedOn": "Abo wird gekündigt per",
            "subscriptions": {
                "additional": "Zusatzabo",
                "base": "Hauptabo Kategorie",
                "large": "Gross",
                "largeText": "Für Unternehmen ab 81 angestellten Personen",
                "micro": "Mikro",
                "microText": "Für Unternehmen bis zu maximal 10 angestellten Personen",
                "middle": "Mittel",
                "middleText": "Für Unternehmen mit zwischen 31-80 angestellten Personen",
                "small": "Klein",
                "smallText": "Für Unternehmen mit zwischen 11 - 30 angestellten Personen"
            },
            "successful": "Erfolgreich",
            "summary": "Zusammenfassung",
            "summer": "Sommer",
            "survey": "Übersicht",
            "tableNoEntries": "Keine Einträge",
            "technique": "Technik & Unterhalt",
            "temporary": "Aushilfe",
            "terminate": "Kündigen",
            "terminated": "Gekündigt",
            "testing": "Prüfen",
            "title": "Titel",
            "titleJob": "Titel des Stelleninserats",
            "to": "bis",
            "toJob": "Zum Inserat",
            "toTheActiveApplications": "Zu den aktiven Bewerbungen",
            "today": "heute",
            "training": "Praktikum",
            "trainingFacility": "Ausbildungsstätte",
            "type": "Typ",
            "typeCompany": "Ich bin ein Unternehmen (Arbeitgeber)",
            "typeEmployee": "Ich bin eine Privatperson (Arbeitnehmer)",
            "typeQuestion": "Möchten Sie sich als Privatperson oder als Unternehemen registrieren?",
            "typeYourPassword": "Passwort eingeben",
            "understood": "Verstanden",
            "unlimitedPosition": "Unbefristete Stelle",
            "updateApplication": "Status aktualisieren",
            "updateCreditCard": "Kreditkarte aktualisieren",
            "updateDraft": "Entwurf aktualisieren",
            "uploadProfilePicture": "Profilbild zum Hochladen hinzufügen<br>(Max 5 MB)",
            "uploading": "Hochladen",
            "url": "URL",
            "userData": "Benutzerdaten",
            "username": "Benutzername",
            "validityOf": "Gültigkeit von",
            "validityUntil": "Gültigkeit bis",
            "value": "Wert",
            "website": "Webseite",
            "wellness": "Wellness, Beauty, Health",
            "what": "Worum geht's",
            "whatToChange": "Was möchten Sie ändern?",
            "winter": "Winter",
            "withoutJobAdvertisement": "Ohne Stelleninserat",
            "workExperience": "Berufserfahrung",
            "workload": "Pensum %",
            "workplace": "Stelle",
            "year": "Jahr",
            "yes": "Ja",
            "yourConcern": "Ihre Mitteilung",
            "zip": "PLZ"
        }
    },
    "en": {
        "pagedefinitions": {
            "about": {
                "metaTags": {
                    "description": "Here you will find information on jobs2share",
                    "keywords": "jobs2share, seasonal jobs"
                },
                "path": "About",
                "title": "About"
            },
            "agb": {
                "metaTags": {
                    "description": "Here you can find the privacy policy and terms and conditions of jobs2share.",
                    "keywords": "privacy policy, terms and conditions, legal notice"
                },
                "path": "terms-and-conditions",
                "title": "Privacy policy and terms and conditions"
            },
            "careerday": {
                "metaTags": {
                    "description": "Come by, get to know exciting work places and maybe even find yourself a job for the next season.",
                    "keywords": "careerday"
                },
                "path": "careerday",
                "title": "Mitarbeiter-Sharing Career Day"
            },
            "employee": {
                "path": "employee"
            },
            "employer": {
                "path": "employer"
            },
            "findAJob": {
                "metaTags": {
                    "description": "Working with a lot of variety and adventure: Combine two exciting seasonal jobs to a year-round-prospect that suits you.",
                    "keywords": "Jobs in Switzerland, Job, Jobs"
                },
                "path": "find-a-job",
                "title": "Combine summer and winter jobs and benefit"
            },
            "furtherEducation": {
                "metaTags": {
                    "description": "Use your off-seasons for personal further education with our partners. Find something suitable here.",
                    "keywords": "on the job, education low season, education"
                },
                "path": "further-education",
                "title": "Further education during off-seasons"
            },
            "home": {
                "metaTags": {
                    "description": "Jobs2share bundles summer and winter season vacancies into exciting year-round-prospects and brings professionals and employers together in an uncomplicated manner.",
                    "keywords": "Jobs in Switzerland, Job, Jobs"
                },
                "title": "Year-round-prospect thanks to employee-sharing"
            },
            "howItWorks": {
                "path": "how-it-works"
            },
            "impress": {
                "metaTags": {
                    "description": "Here you can find the legal notice of jobs2share.",
                    "keywords": "legal notice"
                },
                "path": "legal-notice",
                "title": "Legal notice"
            },
            "jobAdvertisement": {
                "metaTags": {
                    "description": "Recruit on a new level: Win and retain seasonal staff with state-of-the-art HR tools. Offer more than just a seasonal job.",
                    "keywords": "Jobs in Switzerland, publish jobs, Jobs"
                },
                "path": "find-staff",
                "title": "Find and retain seasonal staff with jobs2share"
            },
            "jobs": {
                "metaTags": {
                    "description": "Work with a lot of variety and adventure: combine two exciting seasonal positions to create a year-round perspective that suits you.",
                    "keywords": "Seasonal position, find a job"
                },
                "title": "Combine and benefit from summer and winter jobs"
            },
            "rulesOfTheGame": {
                "metaTags": {
                    "description": "Users of the jobs2share platform are committed to treating each other with fairness in terms of a beneficial cooperation.",
                    "keywords": "Rules of the game, fair play, commitment, enticement, cooperation"
                },
                "path": "rules",
                "title": "\"Fair Play\" rules"
            },
            "secoPilotEmployee": {
                "metaTags": {
                    "description": "Jobs2share not only offers top summer and winter jobs, but also solutions to bridge the off-seasons – thanks to a SECO pilot project.",
                    "keywords": "off-season, unemployment benefits, low-season"
                },
                "path": "seco-pilot",
                "title": "Bridge the off-season – this is how it works"
            },
            "secoPilotEmployer": {
                "metaTags": {
                    "description": "Jobs2share not only offers top summer and winter jobs, but also solutions to bridge the off-seasons – thanks to a SECO pilot project.",
                    "keywords": "off-season, unemployment benefits, low-season"
                },
                "path": "seco-pilot",
                "title": "Bridge the off-season – this is how it works"
            }
        },
        "content": {
            "advantagesEmployee": {
                "label": "Advantages",
                "text1": "Life is too short for a boring job. On jobs2share you will find summer and winter jobs that suit you. Besides that, you can get to know the most beautiful regions of Switzerland, boost your career, make new friends and improve your language skills. Employees with a summer/winter job package benefit from {0} and easier access to {1} The simple application tool allows you to send a professional application with just a few clicks.",
                "text1Additional": "* Due to an innovative SECO pilot project employees living in the cantons Ticino and Grisons can benefit. Further information can be found {0}",
                "text1Additionallink": "here.",
                "text1link1": "training opportunities",
                "text1link2": "unemployment benefits in the off-season*.",
                "unemploymentBenefits": "Unemployment benefits"
            },
            "advantagesEmployer": {
                "forYouremployees": {
                    "label": "The advantages for your employees",
                    "text1": "Exciting work environment along the lines of «lakeside and snow, ready to go»",
                    "text2": "Year-round prospect and career planning",
                    "text3": "Further education offers during the off-season. {action}",
                    "text3link": "More information here.",
                    "text4": "Employees living in the cantons Grisons and Ticino have the opportunity to benefit from easier access to unemployment benefits during the off-seasons, without providing evidence of applying to open positions or other bureaucratic measures to the unemployment insurance. {action}",
                    "text4link": "More information here."
                },
                "label": "Advantages",
                "yours": {
                    "label": "Your advantages",
                    "text1": "You upgrade your seasonal positions and offer your employees «more» than only a seasonal job.",
                    "text2": "You recruit and cooperate with prestigious companies but stay autonomous in every department.",
                    "text3": "You can increase your employee satisfaction and your employee loyalty."
                }
            },
            "archived": "Archived",
            "careerday": {
                "additional": "No registration required<br>\nPlease bring your CV with you!",
                "duration": {
                    "label": "When",
                    "value": "Presumably from 9&colon;30 - 11&colon;30 and 14&colon;00 - 16&colon;00"
                },
                "intro": "On <strong>Tuesday, August 17, 2021</strong> the Mitarbeiter-Sharing <strong>Career Day</strong> will take place in Losone, Ticino! Come by, get to know interesting companies and find a job for the next winter season 2021/22 - true to the motto: \"Lakeside and snow, ready to go!\".",
                "label": "Career Day",
                "place": {
                    "label": "Where",
                    "value": "<a href=\"https://goo.gl/maps/xXNjPRxAoK3SFrNRA\" target=\"_blank\">Albergo Losone</a>"
                },
                "price": {
                    "label": "Costs",
                    "value": "Free of charge"
                },
                "title": "Mitarbeiter-Sharing Career Day 2021"
            },
            "contact": {
                "cantSolveProblem": "You could not solve your problem yet? We would love to help you! Please contact us directly.",
                "employees": "Employee",
                "employers": "Employer",
                "importantQuestions": "The most important questions and answers can be found here",
                "label": "Contact"
            },
            "employeesSays": {
                "1": {
                    "person": "Marika Somaini, hotel professional",
                    "text": "«Thanks to the platform jobs2share we have the opportunity to discover the cultural and climatic diversities as well as the variety of landscapes in Switzerland. We are privileged to work where others enjoy their vacation. The continuity of work and the continuous professional development keeps one active and fulfilled.»"
                },
                "10": {
                    "person": "Rodella Massimo",
                    "text": "Thanks to Jobs2share we have the opportunity to choose between one or more job offers in order to achieve a continuous work situation, even without having an annual contract."
                },
                "11": {
                    "person": "Patti Clara",
                    "text": "For years I have been a member of the Tschuggen Group. I am currently working at the Castello del Sole hotel in Ascona to expand my expertise. I'm looking forward to returning to the Hotel Valsana in Arosa for the winter season."
                },
                "2": {
                    "person": "Alessia Tagli, gastronomy professional",
                    "text": "«For me, jobs2share is an awesome chance for my personal and professional development. Winters I work at the Schweizerhof Lenzerheide, summers at the Delfino Lugano – two very interesting but different hotels where I get the opportunity to learn a lot for my future career. »"
                },
                "3": {
                    "person": "Fabio Dell’Ava, 2. Concierge",
                    "text": "Jobs2share as a platform gives me the opportunity to have a more varied, dynamic and enticing job situation. Living in two fantastic locations and knowing two different working realities."
                },
                "4": {
                    "person": "Corrado Taglioni, II. Maitre d’hôtel",
                    "text": "Jobs2share provides me the opportunity to work in two prestigious hotels. One directly on the lake and the other one in the mountains, where I can ski in addition to work."
                },
                "5": {
                    "person": "Nina della Vedova, Demi Chef de Rang",
                    "text": "I'm very proud of being able to make use of the platform Jobs2share, as it enables me to work in large luxurious hotels. In these hotels I can extend my basic knowledge on a daily base. Thanks to this platform I achieve a working continuity of 10 months per year."
                },
                "6": {
                    "person": "Paula Da Silva Rego, room-maid & Nuno Ferreira da Fonseca, office employee",
                    "text": "Thanks to the platform Jobs2share, we have the opportunity to work in two luxury hotels in two different cantons. We can increase our knowledge better. The hotels also offer the possibility to rent a studio or an apartment to make the employees feel a bit like home."
                },
                "7": {
                    "person": "Leopold Ott, Sous-Chef",
                    "text": "Jobs2share offers the opportunity to seamlessly change to a new job position with little efforts and therefore being able to concentrate on ones work again. This process widens your own horizon workwise and privately. I can only recommend it and would use it again."
                },
                "8": {
                    "person": "Robert Fiedler, Sous-Chef",
                    "text": "Jobs2share gave me the opportunity to work in two renowned Swiss Deluxe Hotels. A great opportunity to develop professionally and personally. By offering apartments to employees, you can concentrate one hundred percent on your new activity as the housing search is eliminated. Working where others spend their holidays."
                },
                "9": {
                    "person": "Torri Davide",
                    "text": "Thanks to the platform Jobs2share we can work in large, traditional houses, which offer us constant opportunities for further education, provide security for the future and deliberately counteract unemployment."
                },
                "label": "What employees say"
            },
            "employersSays": {
                "1": {
                    "person": "Corinne Denzler, General Manager<br>Tschuggen Hotel Group",
                    "text": "«Jobs2share is a great way to offer a year-round prospect to our employees.»"
                },
                "10": {
                    "person": "Ralph Treuthardt, Director<br>Hotel Guarda Val Sporz AG",
                    "text": "«Finding well-trained employees living authentic warmness has become very difficult nowadays. Jobs2share is a real win for us as well as for employees. It gives us the opportunity to prevent seasonal gaps for employees of other companies and to further qualify them by working in different company structures and philosophies.»"
                },
                "11": {
                    "person": "Fabian Mauerhofer, Food & Beverage Manager<br>Vitznauerhof",
                    "text": "«It is essential to use the sharing platform not only as an aid to employee search, but also to support our profession with various practical trainings and linguistic assistance. »"
                },
                "2": {
                    "person": "Marcel Krähenmann, Director<br>Boutique Hotel La Rocca",
                    "text": "«The hotel and food service industry is increasingly affected by the skilled worker shortage. Our answer to that is employee-sharing. We use jobs2share to cooperate with other seasonal businesses and offer our employees an exciting year-round prospect – the formula to success in order to remain competitive.»"
                },
                "3": {
                    "person": "Andreas and Claudia Züllig-Landolt, Executive Board and Hosts<br>Hotel Schweizerhof Lenzerheide",
                    "text": "«Jobs2share inspires us! The businesses in the canton of Grisons can benefit from excellent manpower from Ticino and other Swiss regions during the demanding winter months. During summer those employees can return to their regular employer and by doing this become highly valuable for both – the entrepreneurs and the guests. »"
                },
                "4": {
                    "person": "Franzisca Rechsteiner<br>HR-Manager Hotel Castello del Sole Ascona",
                    "text": "«Employee-sharing as well as the jobs2share platform are pioneering methods for us to not only inspire but also hire and finally to retain employees at our business.»"
                },
                "5": {
                    "person": "Regula Peter, Director of Human Resources<br>Badrutt’s Palace Hotel St. Moritz",
                    "text": "«The Badrutt’s Palace Hotel takes great efforts to support the career advancement of the employees.  These include to provide interesting job opportunities. With the employee-sharing project and jobs2share we can offer preferred possibilities to apply for summer positions at businesses within the jobs2share network to our employees. As a result of this project we were given the opportunity to merge with other hotels where our participating employees can adapt their competences and gain an insight in other businesses - thereby have the chance for a year-round position.»"
                },
                "6": {
                    "person": "Federico Haas, Director and owner<br>Hotel Delfino Lugano",
                    "text": "«Variety makes life beautiful”.\nWith this slogan we inspire especially our young employees to take part in the employee-sharing project.»"
                },
                "7": {
                    "person": "Esther Oubina, HR Manager<br>Villa Orselina",
                    "text": "«Jobs2share enables us to offer long-term prospect and career development plans to our employees. An obvious win-win situation for everyone.»"
                },
                "8": {
                    "person": "Thomas Gruber, Human Resources Manager<br>Grand Hotel Villa Castagnola, Lugano",
                    "text": "<p>«I look into the radiant eyes of our employees when they talk about the positive exchange within the cooperation. Jobs2share offers reassuring security when a contract for the coming season in one of our renowned partner companies can be signed in advanced.</p><p>For us employers, and especially for our regular guests, there is nothing better than meeting well-known employee faces again who are already familiar with the services and philosophy of the company.</p><p>Employee sharing and the associated platform jobs2share is a win-win offer, from which both sides benefit equally.»</p>"
                },
                "9": {
                    "person": "Sandy Stöckenius HR Manager<br>BELVEDERE HOTELS SCUOL",
                    "text": "«What is more exciting for employees than a good chance on a year-round-prospect and the opportunity to participate in two opposing destinations?»"
                },
                "label": "What employers say"
            },
            "faqsEmployees": {
                "cooperations": {
                    "1a": "If you combine a summer job with a winter job on jobs2share, this is documented in a so-called contract of cooperation. You can download this documenta s PDF from your customer account. Therefore, you need a current seasonal job and a seasonal job fort he next season within companies participating in the employee-sharing programm and which are registered on the jobs2share-plattform.{linebreak}{linebreak} The cooperation agreement forms the bridge between the two employers and the employee and creates transparency.{linebreak}{linebreak} This allows employers to create added value beyond the season for their common employees. To achieve this the employers plan the next career steps and personal development of their employees together. In addition, they provide further training for their employees and agree on their entry and exit dates.{linebreak}{linebreak} Also, within the {action} employees that are living in the cantons of Grisons or/and Ticino and submit the contract of cooperation to the unemployment insurance are eligible to benefit from easier access to unemployment benefits during the off-season without providing evidence to the unemployment insurance. The offer is available from 1st of January 2019.",
                    "1alink": "SECO pilot project,",
                    "1q": "What is a cooperation contract?",
                    "2a": "<p>A cooperation contract is created when two seasonal jobs are bundled to a year-round-prospect (summer/winter job package).<br>This happens when a current seasonal position and a future seasonal position, a so-called summer / winter job package, has been entered and confirmed by two registered employers in the profile of an employee on jobs2share.</p><p>There are two ways a summer/winter job package can lead to a contract of cooperation on the platform:</p><ol><li>You already have a current seasonal position or have a confirmation for a future seasonal position.<ul><li>Enter this seasonal job in your profile. The employer of the current or upcoming seasonal job must also confirm this on jobs2share.</li><li>In addition, apply on the jobs2share platform for a second seasonal job in the immediately following season. As soon as you also receive a confirmation from this employer registered on jobs2share, your job package summer / winter is bundled and visible in your profile. Now a cooperation agreement is automatically generated and is ready for you to download.</li></ul></li><li>You currently have no current or future seasonal position. You do not have a current seasonal position or a confirmation for a future seasonal position.\n<ul><li>Apply for suitable jobs on jobs2share. As soon as you have found a suitable job for the current and the following season, and employers have confirmed both of these jobs on jobs2share, your job package summer / winter is bundled and visible in your profile. Now a cooperation agreement is automatically generated and is ready for you to download.</li></ul></li></ol>",
                    "2q": "How is a contract of cooperation created?",
                    "3a": "You can enter your profile including your application documents free of charge on jobs2share and thus create a good prerequisite for your applications. The information entered in your profile forms the basis for your applications. The company you apply for on jobs2share will have access access to the information you provide (in the form of your application). \nAs soon as a cooperation contract is created in your profile, you and both employers will receive the contract of cooperation, containing the contact details of both employers and of the employee, the duration of the employment and the function of the employee.",
                    "3q": "What information is shared with my employers?",
                    "4a": "You can view the entries in your CV. If you detect an error, e.g. because a current or former company has confirmed something wrong, you can request a correction by the employer. Please report errors Error please report {action}",
                    "4alink": "here.",
                    "4q": "Errors in the cooperation agreement: How can I correct or report mistakes?",
                    "5a": "Summer/winter job packages will only lead to cooperation contracts, if both employers join the employee-sharing program and are registered on jobs2share. Hence, a cooperation contract is only possible if your job package summer / winter consists of jobs with employers who are registered on jobs2share and have also confirmed your seasonal jobs on the platform.",
                    "5q": "Why is there is no cooperation contract in my profile, although I have a summer and winter job?",
                    "label": "Contract of Cooperation: working together with two employers"
                },
                "label": "FAQs",
                "notifications": {
                    "1a": "You will receive the most important news per Email. You find all current topics neatly arranged on your dashboard after logging in.",
                    "1q": "How will I be notified about news on the platform?",
                    "label": "Notifications"
                },
                "offSeason": {
                    "1a": "As part of a SECO pilot project, it is possible to benefit from easier access to unemployment benefits for up to 6 weeks per year without providing evidence to the unemployment insurance. The offer is available from the 1st of January 2019 to employees living in the cantons of Ticino and Grisons.{linebreak}{linebreak} You must have a summer / winter job package registered on jobs2share that covers the period in which you wish to receive unemployment benefits. The cooperation agreement is stored in your customer account as a PDF and must be submitted to the responsible unemployment insurance at an early stage. Further information can be found {action}",
                    "1alink": "here.",
                    "1q": "How can I covert he off seasons with unemployment benefits without providing evidence to the unemployment insurance?",
                    "2a": "Apply for exciting jobs on jobs2share. If you already have a current or future seasonal job, you can easily add it to your jobs2share profile in your resume. As soon as a summer and winter season job is registered and confirmed in your profile, a job package is created. The only condition: Both employers must be registered on jobs2share.",
                    "2q": "How do I get a summer / winter job package?",
                    "3a": "It is very simple: register, log in, search for exciting jobs under \"job search\" and apply directly on jobs2share. Thanks to the built-in application tool, you can use the certificates and information stored in your profile repeatedly and save a lot of time. You can also write an individual motivation letter. Thanks to this you always have a professional application which inreases your chances of success!",
                    "3q": "How do I apply?",
                    "4a": "This depends on the number of vacancies of employers.",
                    "4q": "How often are new job advertisements published?",
                    "5a": "You can browse the job vacancies without registering. In order to use all the features of the platform, however, a one-time registration is necessary.",
                    "5q": "Is a registration neccessary?",
                    "6a": "No. The job advertisements, which you marked as favourites are only visible to you.",
                    "6q": "Does an employer see when I mark his job advertisement as a favorite?",
                    "7a": "That depends on the reaction time of the employer.",
                    "7q": "How soon do I receive feedback on my application?",
                    "8a": "No. The use of the platform is completely free of charge for employees.",
                    "8q": "Are there any costs for me?",
                    "label": "Applications and unenmployment benefits during the off-season (SECO-Pilot special offer)"
                }
            },
            "faqsEmployers": {
                "cooperations": {
                    "1a": "The contact details of either involved employers or contact persons will be provided as soon as a summer/winter job package of an employer is registered on jobs2share. Now it is simple and uncomplicated for you to communicate with the cooperating company and for example together plan the further beyond-the-season development for an employee.",
                    "1q": "How does the cooperation with other employers work?",
                    "2a": "This is necessary to capture the job packages of your employees and automatically generate the cooperation contracts on the platform. In addition, it ensures a kind of surveillance (four-eye-principle), as not only the employees state their employment but also the employer himself affirm this.",
                    "2q": "Why do I as a company need to confirm the employment of an employee?",
                    "3a": "<p>A cooperation contract is created when two seasonal jobs are bundled to a year-round-prospect. The contract of cooperation contains the contact details of both employers and of the employee, the duration of the employment and the function of the employee.</p><p>The cooperation agreement forms the bridge between the two employers and the employee and creates transparency.<br>This allows employers to create added value beyond the season for their common employees. To achieve this the employers plan the next career steps and personal development of their employees together. In addition, they provide further training for their employees and agree on their entry and exit dates.</p><p>Also, within the SECO pilot project, employees that are living in the cantons of Grisons or/and Ticino and submit the contract of cooperation to the unemployment insurance are eligible to benefit from easier access to unemployment benefits during the off-season without providing evidence to the unemployment insurance. The offer is available from 1st of January 2019.</p>",
                    "3q": "What is a contract of cooperation?",
                    "label": "Cooperations"
                },
                "deleteAccount": {
                    "1a": "Deletion of the customer account can be requested {0}",
                    "1alink": "via contact form.",
                    "1q": "How can I permanently delete my customer account?",
                    "label": "Delete the customer account"
                },
                "jobAdvertisements": {
                    "1a": "After logging in as an employer, you can update the content / date of existing or deactivated job postings in the \"job advertisements\" area under the corresponding company. Thanks to the flat rate, you can add as many job advertisements as you like. If a position is filled, you can delete the advertisement or temporarily deactivate it.",
                    "1q": "How do I publish a job advertisement?",
                    "2a": "Publishing job advertisements on jobs2share is included in the flat rate and does not incur any additional costs. Any number of job advertisements can be published with your flat rate.",
                    "2q": "How much does a job advertisement on jobs2share cost?",
                    "3a": "You can retrieve the application documents in your customer account for 1.5 years after receiving the application. If you want to keep the dossiers for a longer period, you can conveniently export them as PDF within this 1.5-year period and save them locally.",
                    "3q": "How long do the application documents remain stored on the platform?",
                    "4a": "Yes, that is easily possible. You find all application dossiers listed under «applications». These can be exported as PDF.",
                    "4q": "Can I download application dossiers?",
                    "5a": "Report the problem via the {0}",
                    "5alink": "button contact form.",
                    "5q": "You falsely rejected an application?",
                    "6a": "Report the problem via the {0}",
                    "6alink": "button contact form.",
                    "6q": "You falsely accepted an application?",
                    "label": "Job advertisements and applications"
                },
                "label": "FAQ",
                "notifications": {
                    "1a": "You will receive the most important news per Email. You find all current topics neatly arranged on your dashboard after logging in.",
                    "1q": "How will I be notified about news on the platform?",
                    "label": "Notifications"
                },
                "paymentTerms": {
                    "1a": "The annual fee depends on the size of your business. {action} The billing takes place monthly by credit card. The billing statements are provided in your customer account.",
                    "1alink": "The prices can be found here.",
                    "1q": "How much does it cost to use jobs2share? How does the flatrate work?",
                    "2a": "The monthly fee for using the platform depends on the size of your business based on the number of employees during your high season (regardless of workload or proportion of seasonal employees). If you choose the subscription category «Large», you can manage additional companies in the same customer account for a reduced price of CHF 24.90 monthly per additional company (instead of paying the regular price of CHF 49.90).<ul><li>Subscription Micro: up to 10 employees</li><li>Subscription Small: 11-30 employees</li><li>Subscription Medium: 31- 80 employees</li><li>Subscription Large: 81 or more employees</li></ul>",
                    "2q": "Which subscription category do I need for my company?",
                    "3a": "Decisive is the number of employees during your peak season, regardless of workload or proportion of seasonal employees.",
                    "3q": "How is the company size calculated?",
                    "4a": "No, this is impossible. You receive an annual flat rate on very attractive terms with which you can not only recruit seasonal employees and place as many job advertisements as you like, but also offer your employees a perspective beyond the season. The cooperation among other companies is only possible if you participate the whole year.",
                    "4q": "Are there monthly subsriptions available?",
                    "5a": "You may cancel your subscription and any additional subscriptions by the end of the duration (1 year) during the last month of each term. You need to cancel your subscription directly in your customer account. You will receive an early reminder by email. The annual subscription renews automatically, unless you cancel in the month before your subscription expires. If you cancel your subscription, your customer account will remain on the platform and can be used again for purchasing a subscription.",
                    "5q": "When and how can I cancel my subscription?",
                    "6a": "You can add additional companies to your customer account in order to manage them there directly. With this, you can publish seasonal job offers on the platform on behalf of this additional company and take advantage of all the other features. To add another subscription to your customer account, you must first create a profile for the additional company. Once this is created, you can purchase a subscription for the additional company and add it to your account. If you already have the subscription category «Large», you can manage additional companies in the same customer account for an additional reduced fee of CHF 24.90 monthly per additional company (instead of paying the {action} of CHF 49.90).",
                    "6alink": "regular price",
                    "6q": "How can I manage several businesses in one customer account?",
                    "label": "Payment terms and subscriptions"
                }
            },
            "findStaff": {
                "label": "Find employees"
            },
            "furtherEducation": {
                "gastronomyCoursesGrisons": {
                    "label": "Gastronomy courses Grisons",
                    "text": "Various one- and multi-day catering courses are offered to improve specific knowledge. More information <a href=\"https://www.gastrograubuenden.ch/aus-weiterbildung/alle-kurse\" target=\"_blank\">here.</a>"
                },
                "gastronomyCoursesTicino": {
                    "label": "Gastronomy courses Ticino",
                    "text": "Various one-day gastronomy courses are offered to enhance specific knowledge. More information <a href=\"http://www.gastroformazione.ch\" target=\"_blank\">here.</a>"
                },
                "intro": "Further education gives your career a new impulse, as you learn new professional qualities and develop your personal potential. The companies on Jobs2share want to value and promote their employees. The following training offers are currently available:",
                "label": "Further education",
                "languageCourses": {
                    "label": "Language courses",
                    "text1": "Hotel & Gastro formation Switzerland offers a specialized fide language course (in German) for the hospitality sector for businesses from the cantons of Ticino and Grisons. The courses are offered at levels A1, A2 and B1 and will take place in Lugano or Losone from June to October 2021 and from November to December 2021. The fide language course is subsidized by the L-GAV.  Until the 31.12.2021, the courses are completely <a href=\"https://weiterbildung-inklusive.ch/\" target=\"_blank\">free of charge</a>. In addition, the costs for teaching materials, meals, any overnight stays of the course participants as well as a generous share of the wage replacement are covered. Detailed information and dates can be found <a href=\"/static/documents/fide/Fide_Sprachkurs_Tessin_Jobs2share_2021_DE.pdf\" target=\"_blank\">here</a>.<br>\nVarious Jobs2share employers offer their own language courses on site or online. Please ask your employer directly."
                },
                "progressoCourses": {
                    "label": "Progresso courses (gastronomy / hotel industry)",
                    "text": "Hotel & Gastro formation Switzerland offers again this year during the off-season a Progresso training course in Chur and Losone in the fields of service, kitchen and housekeeping. The 5-week courses will take place in spring 2021 and autumn 2021. The course is subsidised by the L-GAV. Until the 31.12.2021, the courses are completely <a href=\"https://weiterbildung-inklusive.ch/\" target=\"_blank\">free of charge</a>. In addition, the costs for teaching materials, meals, any overnight stays of the course participants as well as a generous share of the wage replacement are covered. Detailed information and dates can be found <a href=\"/static/documents/progresso/Progresso_Jobs2share_AN_2021_DE.pdf\" target=\"_blank\">here</a>.<br>\nHotel & Gastro formation offers Progresso courses for professionals or career changers in kitchen, service and housekeeping sectors. Courses are funded through the Collective Labor Agreement (L-GAV) and therefore are almost free of charge for participants. Data and more information for courses in Grisons <a href=\"https://mein-progresso.ch/\" target=\"_blank\">here</a>."
                }
            },
            "howItWorksEmployee": {
                "label": "How it works",
                "text1": "Combine seasonal jobs at a whim, for example along the lines of «summers at the lake, winters in the snow». Or rather in the summer in the city, in the winter in the country? In the winter mountain hut, in the summer 5-star palace? Barista in summer, ski instructor in winter?",
                "text2": "Jobs2share makes this simple. Finding a dream job is only the first step. We help you to create exciting summer/winter job packages tailored to your needs. Jobs2share offers you access to some of the best employers in Switzerland. They offer you prospects beyond the season."
            },
            "howItWorksEmployer": {
                "fillOpenJobs": {
                    "label": "You want to fill open job vacancies?",
                    "text1": "Job advertisements<br>Advertise unlimited seasonal vacancies – due to our flat rate the individual advertisement is free of charge.",
                    "text2": "Manage applications<br>Recieve and manage your applications directly on jobs2share",
                    "text3": "Contract of cooperation<br>Once an employee finds two seasonal vacancies (a job package summer/winter) at registered employers and it is confirmed through you as well as the additional employer, it appears in the employees jobs2share profile and automatically generates a «contract for cooperation» between the two employers.",
                    "text4": "Career management<br>You now can communicate with the cooperating company and together attempt the individual career planning for your employees.",
                    "text5": "Retain your employees<br>Jobs2share supports you to win your employees back for the next season."
                },
                "label": "How it works",
                "offerPerspective": {
                    "label": "You want to offer your seasonal employees a perspective?",
                    "text1": "Make it easier for your employees to find a complementary seasonal vacancy at an attractive employer on jobs2share. The usage of jobs2share is free of charge for your employees.",
                    "text2": "Due to your participation, you offer your employees a year-round-prospect and the possibility to profit from many further advantages. In addition, you increase the probability to win them back for next year`s season."
                }
            },
            "impress": {
                "contact": "Contact",
                "contactDetails": "Association Mitarbeiter-Sharing<br>c/o University of Applied Sciences of the Grisons<br>Comercialstrasse 22<br>7000 Chur",
                "emailAddress": "info@jobs2share.ch",
                "implementation": {
                    "label": "Implementation"
                },
                "label": "Legal notice",
                "offer": "Jobs2share.ch is an offer of the association Mitarbeiter-Sharing",
                "responsible": "Responsible",
                "responsiblePerson": "Katrin Schillo"
            },
            "jobAdvertisement": {
                "findEmployees": "Find employees",
                "forEmployers": "For employers",
                "label": "Submit a vacancy"
            },
            "jobFind": {
                "forEmployees": "For employees",
                "label": "Job search"
            },
            "jobStatus": [],
            "jobs": {
                "label": "Jobs"
            },
            "jobs2share": {
                "label": "jobs2share"
            },
            "media": {
                "downloadMediaKit": "Download ZIP (70 MB)",
                "downloadPressRelease": "Download «press release»",
                "label": "Media",
                "mediaKit": "«Media-kit»",
                "mediaReports": "What the media reports about us",
                "mediaReportsList": "<ul>\n  <li><a href=\"https://8094bd36e89df1af34bd54d1c93ce32f.ds11s3ns.swisscom.com/jobs2share/static/en/media-reports/HTR_09_18.pdf\" target=\"_blank\">HTR - September 2018</a></li>\n  <li><a href=\"https://www.nzz.ch/wirtschaft/kampf-gegen-die-saisonale-arbeitslosigkeit-in-den-bergen-ld.1380474\" target=\"_blank\">NZZ - April 2018</a></li>\n  <li><a href=\"https://www.nzz.ch/schweiz/saisonale-personalanstellung-hotels-teilen-sich-die-mitarbeiter-ld.89984\" target=\"_blank\">NZZ - June 2017</a></li>\n  <li><a href=\"https://www.rts.ch/play/tv/19h30/video/une-plateforme-online-met-en-reseau-des-etablissements-touristiques?id=8373604&station=a9e7621504c6959e35c3ecbe7f6bed0446cdf8da\" target=\"_blank\">RTS - February 2017</a></li>\n  <li><a href=\"https://www.srf.ch/play/tv/popupvideoplayer?id=4f6da375-554b-4a54-a247-d5ef3ee8b8ab\" target=\"_blank\">10vor10- January 2017</a></li>\n  <li><a href=\"https://www.rsi.ch/la1/programmi/informazione/tempi-moderni/in-prima/L%E2%80%99unione-fa-la-forza-8276689.html\" target=\"_blank\">RSI - November 2016</a></li>\n  <li><a href=\"https://www.nzz.ch/schweiz/saisonale-personalanstellung-hotels-teilen-sich-die-mitarbeiter-ld.89984\" target=\"_blank\">NZZ June - 2016</a></li>\n  <li><a href=\"https://www.nzz.ch/wirtschaft/unternehmen/saisonarbeit-im-tourismus-transalpines-mitarbeiter-sharing-ld.16643\" target=\"_blank\">NZZ - April 2016</a></li>\n  <li><a href=\"https://www.tagesanzeiger.ch/wirtschaft/konjunktur/Im-Winter-steigt-die-Arbeitslosigkeit-auf-bis-zu-43-Prozent/story/26027667\" target=\"_blank\">Tagesanzeiger - April 2016</a></li>\n  <li><a href=\"https://www.srf.ch/sendungen/10vor10/todesfalle-mekka-mitarbeiter-sharing-des-dichters-tochter\" target=\"_blank\">10vor10 - September 2015</a></li>\n</ul>",
                "mediaRepresentative": "Are you a media representative?",
                "pressRelease": "Press releases",
                "pressReleaseDe": "Press release German",
                "pressReleaseIt": "Press release Italian"
            },
            "newsletter": {
                "label": "Newsletter",
                "text": "Do you want to know more? Stay up to date and register here for our Newsletter."
            },
            "offerEmployers": {
                "label": "Offer",
                "sizes": {
                    "employeesPeakSeason": "Number of employees (employees, not FTE) during peak season",
                    "large": "Large",
                    "largeSubtitle": "81 or more employees*",
                    "largeText": "<ul><li>Publish unlimited job advertisements for a whole year</li><li>Simple and professional management of incoming applications</li><li>Cooperate with other companies in the field of HR</li><li>Perspective for your seasonal employees beyond the season</li><li>Email support</li><li>Individual profile to strengthen your employer brand</li><li>Manage additional companies in the same client account for a special monthly rate of CHF 24.90 per additional company.</li></ul>",
                    "medium": "Medium",
                    "mediumSubtitle": "31-80 employees*",
                    "micro": "Micro",
                    "microSubtitle": "up to 10 employees*",
                    "priceText": "CHF per month",
                    "small": "Small",
                    "smallSubtitle": "11-30 employees*",
                    "text": "<ul><li>Publish unlimited job advertisements for a whole year</li><li>Simple and professional management of incoming applications</li><li>Cooperate with other companies in the field of HR</li><li>Perspective for your seasonal employees beyond the season</li>\n<li>Manage various companies in one account (only possible in category «Large») </li><li>Email support</li><li>Individual profile to strengthen your employer brand</li><li>Option: Manage various companies in one account</li></ul>"
                },
                "text": "Starting at 49.90 CHF per month, you can sign up and publish unlimited job advertisements. Furthermore you can cooperate with other companies to offer employees an attractive year-round-prospect. Jobs2share is used by the best employers in the hotel, catering, mountain railways, ski schools and other businesses, which have seasonal fluctuations.",
                "whatSize": "What size is your company?"
            },
            "partner": {
                "label": "Partners",
                "ourMembers": "Our members",
                "ourPartners": "Our partners"
            },
            "privacyPolicy": {
                "label": "Data privacy"
            },
            "rulesOfTheGame": {
                "cooperation": {
                    "label": "Cooperation, fair play and wooing employees",
                    "text": "<p>In order to achieve the objectives set out in \"Mission\", users promise to be fair to each other at all times and to help ensure long-term, profitable collaboration.</p><p>Fair play means that users contribute to a positive climate within the jobs2share platform and commit to good practice in terms of “sharing” employees. Each individual user assumes a role model function with his actions on the platform. This means, for example, that users do not want to woo employees from other companies in order to offer them a year-round position, although a return to a participating company (member, user) would be provided for the following season. At the same time, users accept that employees seize opportunities to develop personally and professionally, and allow them to do so. Whenever possible, the companies talk about the dates for the transfers of employees.</p><p>In addition, registered users of the jobs2share platform are committed to respecting the applicable collective labor agreement (GAV) requirements and laws towards those registered as applicants or employees.</p>"
                },
                "label": "Rules of the game «Fair Play»",
                "mission": {
                    "label": "Mission",
                    "text": "The goal of establishing a new working model \"Mitarbeiter-Sharing\" (employee sharing) leads the same-named association as owner of jobs2share. The idea of employee sharing is to bundle summer and winter seasonal jobs and thus create year-round prospects. This, and the promotion of employees, for example through goal oriented further education programs, should make seasonal jobs more attractive to employees and meet the need for both, a more varied employment and simultaneous career prospects."
                },
                "purposeAndScope": {
                    "label": "Purpose and scope",
                    "text": "Jobs2share platform users commit themselves to interact fair among each other for the purpose of generating a beneficial cooperation."
                }
            },
            "secoEmployee": {
                "conditions": {
                    "label": "The most important conditions:",
                    "list": "<ul><li>You need to live in the cantons of Ticino or/and Grisons to participate at this pilot project.</li><li>To be able to profit from easier access to unemployment benefits (ALV special offer), both you and your employer must be registered on <a href=\"/\">www.jobs2share.ch</a> and enter current and future job positions. Suitable jobs found directly on <a href=\"/\">www.jobs2share.ch</a> will be added to your profile automatically. </li><li>As an employee you are free to decide for suitable positions to compose your “Jobs2share” summer & winter job-package. You will find exciting positions for the current or upcoming season on <a href=\"/\">www.jobs2share.ch</a> and are welcome to apply directly online.</li><li>If you find a summer & winter job on <a href=\"/\">www.jobs2share.ch</a> and add this to your profile, a «contract for cooperation” will be generated automatically and can easily be downloaded from the platform.</li><li>Just submit the «contract for cooperation» as well as the employment contracts for the «Jobs2share» winter & summer job-package to your responsible employment agency RAV in time to have access to unemployment benefits completely exempt from the obligation to produce proof for attempts in terms of applications (for up to 6 weeks per year).</li></ul>",
                    "listlink": "www.jobs2share.ch"
                },
                "label": "Unemployment benefits in the off-season – SECO pilot project",
                "moreInformation": "Further information can be found <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">here.</a>",
                "text": "<p>Seasonal employees living and working in the cantons of Ticino and Grisons can simply cover the off-season with unemployment benefits if they decide to sign up for the employee sharing model from “Jobs2share” – summers at the lake, winters in the snow. </p><p>As part of a SECO pilot project, it is possible to benefit from easier access to unemployment benefits for up to 6 weeks per year without applying to year-round positions and providing evidence to the unemployment insurance (ALV special offer). The offer is available from the 1st of January 2019 to employees living in the cantons of Ticino and Grisons.</p>"
            },
            "secoEmployer": {
                "label": "SECO pilot project",
                "moreInformation": "Further information can be found <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">here.</a>",
                "moreInformationEmployee": "Further information for your employees can be found <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">here.</a>",
                "moreInformationEmployer": "Further information for employers can be found <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-de-20190601.pdf\" target=\"_blank\">here.</a>",
                "text1": "With the registration on {0} you will have the chance to improve the commitment of your seasonal employees living in the cantons of Ticino and Grisons while providing an added value during the off-season.",
                "text1link": "www.jobs2share.ch",
                "text2": "As part of the SECO pilot project, seasonal employees with a winter as well as a summer position will have the opportunity to benefit from easier access to unemployment benefits for up to 6 weeks per year without applying to year-round positions and providing evidence to the unemployment insurance (ALV special offer). Thereby it is possible to bridge off-season gaps easily and uncomplicated.",
                "text3": "At present the offer is available starting from 1st of January 2019 to employees living in the cantons Ticino and Grisons. If the pilot project is successful, this regulation will be extended and might even lead to a legislation amendment. Hence, your participation and registration on {0} is of high value.",
                "text3link": "www.jobs2share.ch",
                "text4": "As soon as an employee finds a winter & summer job-package and it is confirmed through you as employer and the additional employer, it appears in the employees {action} profile and automatically generates a «contract for cooperation».{linebreak}{linebreak} Employees simply download this «contract for cooperation» and submit it to the responsible employment agency RAV at an early stage, ideally three months in advanced. By doing this, employees can benefit from the ALV special offer during the 6 weeks off-season gap.",
                "text4link": "www.jobs2share.ch"
            },
            "show": "Show",
            "sponsorship": {
                "label": "Sponsorship",
                "text": "Jobs2share stands for the independently and non-profitably operating association named Mitarbeiter-Sharing (Employee-Sharing). This association concentrates on the needs of its members and users, which on the one hand are employees, who want to hold down a varied job, and on the other hand companies offering seasonal jobs.<br>The association was founded in 2016 by the University of Applied Sciences of the Grisons (former HTW Chur) together with more than 20 member companies. Most of the more than 50 business premises of these member companies are based in the cantons Grisons and Ticino."
            },
            "tac": {
                "label": "GTC"
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field is required.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "phone": "The {attribute} field contains an invalid number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "password_strength": "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)",
            "password": "The password is incorrect.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "texts": {
            "DataPermanentlyLost": "Your data will be lost permanently",
            "abort": "Cancel",
            "about": "About us",
            "acceptAGB": "I have read and accepted the terms and conditions of jobs2share",
            "acceptAGBandPrivacyPolicy": "I have read and accepted the <a href=\"/de/terms-and-conditions\" target=\"_blank\">terms and conditions and data privacy statements</a>",
            "acceptAdvertising": "I would like to receive the jobs2share newsletter",
            "acceptPrivacyPolicy": "I have read and accepted the data privacy statement of jobs2share",
            "acceptRules": "I have read and accepted the <a href=\"/en/employer/rules-of-the-game\" target=\"_blank\">Rules of the game «Fair Play»</a>",
            "actionCannotBeUndone": "This action cannot be undone",
            "actions": "Actions",
            "active": "Active",
            "activeApplicationsTablePlaceholder": "The applications for your ads will appear here",
            "add": "Add",
            "addAddon": "Add additional subscription",
            "addCertificate": "Add more",
            "addCompany": "Add company",
            "addDocuments": "Add credentials, certificates, awards or other documents",
            "addEducation": "Add education",
            "addExperience": "Add work experience",
            "addFavoriteSuccessful": "Job ad was successfully marked as favorite",
            "addJob": "Add job ad",
            "addLanguage": "Add language",
            "addNewFiles": "Add new file",
            "addOtherDocument": "Add more",
            "addSubscription": "Add main subscription",
            "addedOn": "Added on",
            "additionalCompanies": "Additional companies",
            "additionalDocuments": "Attachments",
            "additionalTextSumbitApplication": "After submitting, the application can no longer be edited",
            "addon": "Additional subscription(s)",
            "address": "Address",
            "administrateCompanies": "Manage subscription",
            "administration": "Administration",
            "alert": {
                "acceptEmployeeError": "Employment could not be confirmed",
                "acceptEmployeeSuccessful": "Employment has been confirmed successfully",
                "addAddonError": "Additional subscription could not be added",
                "addAddonSuccessful": "Additional subsciption was added successfully",
                "addCompanyError": "Company could not be added",
                "addCompanySuccessful": "Company was added successfully",
                "addContactPersonError": "Contact person could not be added",
                "addContactPersonSuccessful": "Contact person was added successfully",
                "addFavoriteError": "Job ad could not be added to your favorites",
                "addJobApplicationError": "Application could not be saved",
                "addJobApplicationSuccessful": "Application was saved successfully",
                "addJobError": "Job advertisement could not be added",
                "addJobSuccessful": "Job advertisement was added successfully",
                "addResumeCertificationsError": "Entry could not be added",
                "addResumeCertificationsSuccessful": "Entry was added successfully",
                "addResumeEducationsError": "Education could not be added",
                "addResumeEducationsSuccessful": "Education was added successfully",
                "addResumeJobsError": "Work experience could not be added",
                "addResumeJobsSuccessful": "Work experience was added successfully",
                "addResumeLanguagesError": "Language could not be added",
                "addResumeLanguagesSuccessful": "Language was added successfully",
                "addResumeOtherDocumentsError": "Entry could not be added",
                "addResumeOtherDocumentsSuccessful": "Entry was added successfully",
                "addSubscrptionError": "Subscription could not be added",
                "addSubscrptionSuccessful": "Subscription was added successfully",
                "cancelSubscriptionError": "Subscription could not be cancelled",
                "cancelSubscriptionSuccessful": "Subscription was successfully cancelled",
                "changeBillingCycleSuccessful": "Thank you, you have renewed your jobs2share subscription. Your new subscription ends on {0}.",
                "changeCreditCardError": "Credit card could not be updated",
                "changeCreditCardSuccessful": "Credit card was successfully updated",
                "couponCodeInvalid": "Invalid voucher",
                "couponCodeValid": "Valid voucher",
                "creditCardError": "Your credit card was not accepted",
                "declineEmployeeError": "Application status could not be updated",
                "declineEmployeeSuccessful": "Application status successfully updated",
                "declineRenewEmployeeError": "Reentry could not be refused",
                "declineRenewEmployeeSuccessful": "Reentry has been refused successfully",
                "deleteAddonError": "Additional subscription could not be deleted",
                "deleteAddonSuccessful": "Additional subsription was deleted successfully",
                "deleteCompanyError": "Company could not be deleted",
                "deleteCompanySuccessful": "Company was deleted successfully",
                "deleteJobApplicationError": "Application could not be deleted",
                "deleteJobApplicationSuccessful": "Application was deleted successfully",
                "deleteJobError": "Job ad could not be deleted",
                "deleteJobSuccessful": "Job ad was deleted successfully",
                "deleteProfilePictureError": "Profile picture could not be deleted",
                "deleteProfilePictureSuccessful": "Profile picture was deleted successfully",
                "deleteResumeCertificationsError": "Entry could not be deleted",
                "deleteResumeCertificationsSuccessful": "Entry was deleted successfully",
                "deleteResumeEducationsError": "Education could not be deleted",
                "deleteResumeEducationsSuccessful": "Education was deleted successfully",
                "deleteResumeJobsError": "Work experience could not be deleted",
                "deleteResumeJobsSuccessful": "Work experience was deleted successfully",
                "deleteResumeLanguagesError": "Language could not be deleted",
                "deleteResumeLanguagesSuccessful": "Language was deleted successfully",
                "deleteResumeOtherDocumentsError": "Entry could not be deleted",
                "deleteResumeOtherDocumentsSuccessful": "Entry was deleted successfully",
                "deleteSubscriptionError": "Subscription could not be deleted",
                "deleteSubscriptionSuccessful": "Subscription was deleted successfully",
                "endOfWorkError": "End of job must be after start of job",
                "formRequiredFieldsError": "Please fill in all spaces highlighted red",
                "jobContainsEmailError": "Job advertisements may not contain email addresses. Applications should be submitted via jobs2share's application tool. You can later download the applicants' complete documents as a PDF file.",
                "registerNewsletterError": "Newsletter registration failed",
                "registerNewsletterSuccessful": "Newsletter registration successful",
                "removeFavoriteError": "Job ad could not be removed from your favorites",
                "renewEmployeeError": "Reentry could not be added",
                "renewEmployeeSuccessful": "Reentry was added successfully",
                "reportErrorError": "Your request could not be submitted",
                "reportErrorSuccessful": "Your request has been submitted successfully",
                "sendContactError": "Request could not be sent",
                "sendContactSuccessful": "Request successfully sent",
                "storeAdditionalCompanyError": "Additional company could not be added",
                "storeAdditionalCompanySuccessful": "Additional company was added successfully",
                "storeSubscriptionCouponError": "Voucher code could not be added",
                "storeSubscriptionCouponSuccessful": "Voucher code was added successfully",
                "storeSubscriptionError": "Subscription could not be added",
                "storeSubscriptionSuccessful": "Subscription was added successfully",
                "subscriptionRequired": {
                    "updateEmployee": "Employments can only be managed with a valid subscription"
                },
                "updateAddonError": "Additional subscription was not updated",
                "updateAddonSuccessful": "Additional subscription was updated successfully",
                "updateAllNotificationsError": "Notifications could not be marked as read",
                "updateAllNotificationsSuccessful": "Notifications were updated successfully",
                "updateCompanyProfileError": "Company profile could not be updated",
                "updateCompanyProfileSuccessful": "Company profile has been updated successfully",
                "updateContactPersonError": "Contact person could not be modified",
                "updateContactPersonSuccessful": "Contact person modified successfully",
                "updateEntryError": "Entry could not be updated",
                "updateEntrySuccessful": "Entry has been updated successfully",
                "updateJobApplicationError": "Application could not be updated",
                "updateJobApplicationStatusError": "Status of your application could not be updated",
                "updateJobApplicationStatusSuccessful": "Status of your application has been updated successfully",
                "updateJobApplicationSuccessful": "Application updated successfully",
                "updateJobError": "Job ad could not be modified",
                "updateJobSuccessful": "Job ad modified successfully",
                "updateLocationError": "Location could not be modified",
                "updateLocationSuccessful": "Location has been modified successfully",
                "updateProfilePictureError": "Profile picture could not be changed",
                "updateProfilePictureSuccessful": "Profile picture changed successfully",
                "updateResumeCertificationsError": "Entry could not be updated",
                "updateResumeCertificationsSuccessful": "Entry successfully updated",
                "updateResumeEducationsError": "Education could not be updated",
                "updateResumeEducationsSuccessful": "Education has been successfully updated",
                "updateResumeJobsError": "Work experience could not be updated",
                "updateResumeJobsSuccessful": "Work experience has been successfully updated",
                "updateResumeLanguagesError": "Language could not be updated",
                "updateResumeLanguagesSuccessful": "Language has been successfully updated",
                "updateSubscriptionError": "Subscription could not be updated",
                "updateSubscriptionSuccessful": "Subscription has been updated successfully",
                "updateUserProfileError": "Profile could not be updated",
                "updateUserProfileSuccessful": "Profile successfully updated"
            },
            "all": "All",
            "allNotificationsRead": "Mark all as read",
            "amount": "Amount",
            "and": "and",
            "applicants": "Applicant",
            "application": {
                "completed": "Completed applications",
                "completedInfo": "Insert text",
                "label": "Application|Applications",
                "noEntries": "Your applications appear here",
                "ongoing": "Pending applications",
                "ongoingInfo": "Insert text"
            },
            "applicationAs": "Application as",
            "applicationDetails": "Application details",
            "applicationDocuments": "Application documents",
            "applicationDocumentsSubtitle": "Curriculum Vitae, Languages, Certificates",
            "applicationLetter": "Application letter",
            "applicationStatus": {
                "CONTRACTSENT": "Employment contract sent",
                "CONTRACTSIGNED": "Confirm employment",
                "DRAFT": "Draft",
                "INTERVIEW": "Invited to job interview",
                "READ": "Read",
                "REFUSAL": "Declined",
                "REFUSALEMPLOYEE": "Declined through applicant",
                "SENT": "Application submitted",
                "change": "Change application status"
            },
            "applications": "Applications",
            "appliedForOn": "Applied on",
            "apply": "Apply",
            "april": "April",
            "archived": "Archived",
            "association": "Association Mitarbeiter-Sharing",
            "attachedFiles": "Attached files",
            "attentionNoCurrentJob": "Don't forget to enter your current job. It could lead to a summer-winter job package.",
            "attentionNoLetter": "Attention: You did not draft an application.",
            "attentionShortLetter": "Attention: Your letter of application is very short. Many employers wish a more detailed letter of application.",
            "august": "August",
            "automaticallyAddedOnReceiptOfJob": "This entry was added automatically because your employer confirmed the employment.",
            "avamCodeHelp": {
                "description": "Jobs2share requires the exact job assignment of the job advertisement.\nCertain professions are subject to registration and must be reported to the public employment service before publication.",
                "moreInformation": "Further information can be found",
                "ricac": "Westschweizer Referenzsystem über die Tätigkeiten und Kompetenzen.",
                "title": "Help Job title"
            },
            "back": "Back",
            "backtoOverview": "Back to overview",
            "billingCycle": "Billing cycle",
            "birthday": "Birthday",
            "buySubscription": "Subscribe",
            "callOff": "Letter of declination",
            "cancel": "Cancel",
            "cancelSubmitApplication": "Back",
            "cancelSubscription": "Cancel",
            "category": "Category",
            "certificate": "Other",
            "changeCreditCard": "Change credit card",
            "changeSubscription": "Change subscription",
            "chargesUp": "Uploading",
            "choose": "Select",
            "chooseAddon": "Select additional subscription",
            "chooseCompany": "Select company",
            "chooseReason": "Please select a reason:",
            "chooseSubscription": "Select subscription category",
            "closure": "Completion",
            "comletedApplicationsTablePlaceholder": "The completed applications will appear here",
            "company": {
                "image": "Photo of your company",
                "label": "Company",
                "maps": "Google Maps Location",
                "profile": {
                    "general": "Company profile",
                    "general-info": "Location, slogan and description",
                    "images": "Logo and picture",
                    "images-info": "Complete your profile;  add logo and picture",
                    "images-size-info": "Recommended image size: 800px width and 230px height",
                    "images-type-info": "Allowed data types: JPG, PNG, GIF",
                    "settings": "Settings"
                },
                "sizes": {
                    "big": "81 or more employees",
                    "medium": "31 - 80 employees (max. capacity during peak season)",
                    "micro": "Up to 10 employees (max. capacity during peak season)",
                    "small": "10 - 30 employees (max. capacity during peak season)"
                },
                "uploadLogo": "Click here to upload your own logo"
            },
            "companyAlreadyExists": "This company has already been registered.",
            "completeCompanyProfile": "Please complete your company profile:",
            "completeEmployeeProfile": "Entries on work experience can only be added with a full profile.",
            "completeProfile": "Complete profile",
            "completed": "Completed",
            "confirm": "Confirm",
            "confirmDeleteJobApplication": "Yes, delete application",
            "confirmMessage": "Do you really want to carry out this action?",
            "confirmSubmitApplication": "Submit application",
            "confirmSubscriptionSelection": "I confirm that the selected company does not exceed the maximum count of employees allowed in the subscription during the peak season.",
            "contact": "Contact",
            "contactDetails": "Contact details",
            "contactPerson": "Contact Person",
            "cook": "Cook",
            "cooperation": "Cooperation|Cooperations",
            "cooperationAgreement": "Contract of cooperation|Contracts of cooperation",
            "cooperationAgreementInvalid": "Contract of cooperation invalid",
            "cooperationAgreementPdf": {
                "at": "at",
                "currentWorkingPermit": "Current working permit",
                "duration": "Terms of seasonal contracts",
                "end": "End",
                "information": "Employees living or staying in a weekly residence in the cantons of Grisons and Ticino, can submit their cooperation contract together with their seasonal employment contract for the coming season to the responsible unemployment insurance RAV as evidence to benefit from the SECO pilot project “employee-sharing”, in accordance with the ALV special regulations. The contract of cooperation is created automatically on the jobs2share-platform and is only valid after the two employers release it. It is the responsibility of the employee to submit the document to the responsible RAV at an early stage.",
                "integratedPart": "This cooperation agreement is an integral part of the individual employment contracts between",
                "intentionText": "This contract of cooperation outlines the intention of the three parties involved to cooperate during and beyond the current season. Both employers confirm that they intent to support the employee`s personal development beyond the ongoing season within the bounds of their possibilities. The agreement of cooperation is based on two valid seasonal contracts of employment (one for the current and one for the subsequent season).",
                "mainResidence": "Main residence",
                "onlineVerification": "Online verification",
                "position": "Position/Job title",
                "scanInfo": "Please scan the following QR code to verify the validity of this contract of cooperation.",
                "start": "Start"
            },
            "cooperationAgreementValid": "Contract of cooperation valid",
            "copy": "Copy",
            "corona": {
                "alertText": "Information on the current situation",
                "bag": "Federal Office of Public Health FOPH",
                "hotelleriesuisseGrisons": "Hotelleriesuisse Graubünden",
                "hotelleriesuisseTicino": "Hotelleriesuisse Ticino",
                "text": "<p>Due to the current situation, many of our partner companies are experiencing delays in their planning. Our companies are constantly striving to update their job offers. </p><p>We thank you for your patience, you will soon be able to apply for interesting seasonal jobs!</p><p>We thank you for your understanding in case of delays. We wish the seasonal employees and businesses good health. </p><p>Your Jobs2share.ch team & Association  Mitarbeiter-Sharing.</p>",
                "usefulInformation": "You can find valuable information here:"
            },
            "correctDeclinedJobEntry": "Check the entry and have the employer confirm the job. Confirmed positions lead to job packages and you benefit from many advantages.",
            "count": "Count",
            "country": "Country",
            "coupon": "Voucher",
            "couponCode": "Voucher code",
            "create": "Create",
            "createdOn": "Created on",
            "creditCard": "Credit card",
            "creditCardEndsWith": "Credit card ending in",
            "creditcardInvalid": "Please add a valid credit card.",
            "currentJob": "Current job",
            "dashboard": {
                "applicationDescription": "Pending job application remain here, until you accept or decline them.",
                "assignmentDescription": "Do these people currently work for you or will they work for you in the future? Please confirm.",
                "jobsDescription": "Overview of your active job ads",
                "label": "Dashboard",
                "reenterDescription": "Which of your employees will return? Keep the status up to date and help them to combine their summer/winter job packages early!"
            },
            "date": "Date",
            "day": "Day|Days",
            "december": "December",
            "decline": "Decline",
            "declineEmployeeTypes": {
                "DATE": "Incorrect time period",
                "OTHER": "Other reasons",
                "TITLE": "Incorrect job description",
                "UNKNOWN": "Name has not been recognized"
            },
            "declineRequest": "Decline request",
            "delete": "Delete",
            "deleteCompany": "Delete company",
            "deleteCompanyQuestion": "Are you sure you want to delete this company?",
            "deleteDefinitely": "Delete permanently",
            "deleteEntry": "Delete entry",
            "deleteEntryInfo": "This job is part of a job package and cooperation contract and cannot be changed or deleted. It was confirmed by the employer. With the button \"Report error\" you can inform us if something is wrong.",
            "deleteEntryQuestion": "Are you sure you want to delete this entry?",
            "deleteJob": "Delete job ad",
            "deleteJobApplication": "Delete job application",
            "deleteJobApplicationSuccessful": "Application has been successfully deleted.",
            "deleteJobQuestion": "Are you sure you want to permanently delete this job ad?",
            "deletePermanently": "Delete permanently",
            "deleteProfile": "Delete profile",
            "deleteProfilePicture": "Delete profile picture",
            "deleteProfileQuestion": "Are you sure you want to delete your profile?",
            "description": "Description",
            "details": "Details",
            "directCall": "Direct dial",
            "displayContract": "Show contract",
            "domesticEconomy": "Housekeeping",
            "draft": "Draft",
            "duration": "Duration",
            "duringPeakSeason": "During peak season",
            "edit": "Edit",
            "editAddon": "Change additional subscription",
            "editCertificate": "Modify entry",
            "editEducation": "Modify education",
            "editExperience": "Modify work experience",
            "editJob": "Modify job ad",
            "editLanguage": "Modify language",
            "editOtherDocument": "Modify document",
            "editSubscription": "Change subscription",
            "editorPlaceholder": "Enter your text here",
            "education": "Education",
            "email": "E-mail address",
            "employee": {
                "all": "All employees",
                "assignment": "Confirm employment",
                "assignmentInfo": "Insert text",
                "edit": "Modify employment",
                "employed": "Currently employed",
                "employedInfo": "Insert text",
                "employmentChange": "Change employment",
                "employmentDidNotTakeUp": "Employee has not taken up the job",
                "employmentTerminated": "Employment was annulled",
                "employmentWillNotTakeUp": "Employee will not take up job",
                "former": "Former employee",
                "formerInfo": "Insert text",
                "future": "Future employment",
                "futureInfo": "Insert text",
                "label": "Employees",
                "noEntries": "No employees found"
            },
            "employeeInfo": "At present only companies can register",
            "employeeReEnter": {
                "APPROVE": "Employee will return to us",
                "DECLINE": "Employee will not return to us",
                "label": "Reentry"
            },
            "employeeTitle": "Employee|Employee",
            "employees": "Employee",
            "emptyJobs": "No job ads available yet",
            "end": "End",
            "endMonth": "Ending month",
            "endOfTraining": "End of training",
            "endOfWork": "End of job",
            "english": "English",
            "enterDateOfBirth": "Enter date of birth",
            "entriesPerPage": "Entries per page",
            "error": "Error",
            "errorMessage": "An error has occurred. Please inform us about the occurrence of this error via button 'Report error'",
            "favorites": "Favorites",
            "february": "February",
            "feedback": "Feedback",
            "filename": "File name",
            "filter": "Filter",
            "finishRegistration": "Complete registration",
            "firstName": "First name",
            "forgotPassword": "Forgot password",
            "french": "French",
            "fullTime": "Full time",
            "functionNotAvailable": "This feature is not available yet",
            "functionOnlyLoggedInAvailable": "This feature is only available when logged in",
            "garden": "Garden",
            "german": "German",
            "help": "Help",
            "home": "Home",
            "hotelCategory": "Hotel category",
            "imageUploadInfo": "Upload image (is being stored automatically)",
            "impress": "Legal Notice",
            "info": {
                "label": "Info",
                "noFavorites": "You have not marked any job advertisements as favorites."
            },
            "insertJobtitle": "Enter job title",
            "insertPassword": "Enter password",
            "interruption": "Interruption",
            "introduction": "Introduction",
            "invalidCredentials": "Email or password invalid",
            "invoice": {
                "address": "Recipient",
                "after": "after",
                "alreadyPaid": "The amount has been charged to your credit card.",
                "date": "Invoice date",
                "footer": "Association Mitarbeiter-Sharing, c/o University of Applied Sciences of the Grisons, Comercialstrasse 22, 7000 Chur",
                "info": {
                    "monthly": "Billing is on a monthly basis. You can cancel your annual subscription in the last month of the term.",
                    "yearly": "Billing is on a yearly basis. You can cancel your annual subscription in the last month of the term."
                },
                "number": "Invoice number",
                "offcoupon": "discount with voucher",
                "on": "on subscription",
                "remainingTime": "Remaining time",
                "title": "Invoice",
                "unitPrice": "Price per unit",
                "unusedTime": "Unused time"
            },
            "issuingAuthority": "Issuing authority",
            "italian": "Italian",
            "janitor": "Facility management and services",
            "january": "January",
            "job": "Job advertisement",
            "jobActive": "Job ad active",
            "jobAdvertisementsOnlyWithValidSubscription": "Job advertisements of a company are only active with a current subscription.",
            "jobApproved": "Confirmed by {company}",
            "jobCategory": {
                "1": "Kitchen",
                "2": "Service",
                "3": "Reception & administration",
                "4": "Housekeeping",
                "5": "Wellness, beauty, health, sports",
                "6": "Tech & maintainance, garden",
                "7": "Other",
                "label": "Job category"
            },
            "jobDeclined": "From {company} denied",
            "jobEntryDate": "Starting date",
            "jobExitDate": "Ending date",
            "jobLanguage": "Job language",
            "jobNotifiedApproved": "Job already reported and approved",
            "jobOverPlatform": "Get a job via jobs2share",
            "jobPosition": {
                "1": "Education",
                "2": "Training",
                "3": "Semiskilled",
                "4": "Skilled employee",
                "5": "Manager",
                "label": "Position"
            },
            "jobRoomWaitingActivation": "Job ad is waiting to be activated by the Jobroom",
            "jobSearch": "Job search",
            "jobStatus": {
                "CANCELLED": "Cancelled",
                "INSPECTING": "Inspecting",
                "PUBLISHED_PUBLIC": "Published",
                "PUBLISHED_RESTRICTED": "Restriction period",
                "REJECTED": "Rejected",
                "UNSYNCRONIZED": "Unsyncronized"
            },
            "jobTitle": "Job ads",
            "jobTitleAvam": "Job title (Avam)",
            "jobroomConfirmationPending": "Jobroom confirmation pending",
            "jobs": "Job ads",
            "jobsTableNoEntries": "No job ads published",
            "jobsTablePlaceholder": "Your job ads will appear here",
            "july": "July",
            "june": "June",
            "kitchen": "Kitchen",
            "label": "Job title",
            "language": {
                "ar": "Arabic",
                "cs": "Czech",
                "da": "Danish",
                "de": "German",
                "el": "Greek",
                "en": "English",
                "es": "Spanish",
                "fi": "Finnish",
                "fr": "French",
                "he": "Hebrew",
                "hu": "Hungarian",
                "it": "Italian",
                "ja": "Japanese",
                "ko": "Korean",
                "label": "Language|Languages",
                "nl": "Dutch",
                "no": "Norwegian",
                "pl": "Polish",
                "pt": "Portuguese",
                "ro": "Romanian",
                "ru": "Russian",
                "sv": "Swedish",
                "sì": "Cingalese",
                "tr": "Turkish",
                "yes": "Armenic",
                "zh": "Chinese"
            },
            "lastActivity": "Last Activity",
            "lastName": "Last Name",
            "line": "Line|Lines",
            "locality": "Locality",
            "lodging": "Accommodation available",
            "login": "Login",
            "logo": "Logo",
            "logout": "Logout",
            "mainScubscription": "Main Subscription",
            "mainSubscriptionShort": "Main subscription",
            "maintenanceText": "Jobs2share.ch is currently only available to a limited extent.",
            "manager": "Management",
            "march": "March",
            "maxDurationSeasonJobInfo": "You can only add seasonal jobs. The max. duration of a seasonal position is 9 months",
            "maximalDurationExceeded": "Exceeded the max. duration of 9 months",
            "may": "May",
            "message": "Notification",
            "months": {
                "1": "January",
                "10": "October",
                "11": "November",
                "12": "December",
                "2": "February",
                "3": "March",
                "4": "April",
                "5": "May",
                "6": "June",
                "7": "July",
                "8": "August",
                "9": "September",
                "label": "Month|Months"
            },
            "moreInformation": "More Information",
            "moreInformations": "More Information",
            "motto": "Motto",
            "mustBeInFuture": "Cannot be in the past",
            "myJobs": "My positions",
            "myJobsIntro": "Here you should insert the most important professional stages of your current and future career. <br>Current positions are particularly important because they are confirmed by your employer and can lead to a summer/winter job package.",
            "name": "Name",
            "nameOfCertificate": "Title",
            "nameOfCompany": "Company name",
            "nameOfDocument": "Title",
            "nationality": "Nationality",
            "neither": "None",
            "newJob": "New job ad",
            "newNotifications": "New notification",
            "news": "News",
            "next": "Next",
            "nextCharge": "Next charge",
            "no": "No",
            "noAccountYet": "You don't have an account yet?",
            "noActiveApplications": "No open applications",
            "noCompaniesAddedYet": "No added companies yet",
            "noCompanyWithoutSubscription": "No company without subscription available",
            "noCompletedApplications": "No completed applications",
            "noCooperationAgreements": "Your contracts of cooperation will be displayed here",
            "noCooperationIdenticalCompany": "Attention: {company} is already registered in your profile as your previous employer. Your application will not result in a job package.",
            "noEndDate": "No end date",
            "noExpirationDate": "No expiry date",
            "noNotifications": "No notifications",
            "noResults": "No matching jobs found",
            "noSearchEntries": "No matching search results",
            "noSubjectToRegistration": "No reporting obligation",
            "notifications": {
                "applicationOpenReminder": {
                    "message": "Did you hire set {first_name} {last_name}? Please update the status of the applications received."
                },
                "applicationOpenReminderPart1": "Did you",
                "applicationOpenReminderPart2": "hire? Please update the status of the applications received.",
                "applicationReceived": {
                    "message": "New application of {first_name} {last_name}"
                },
                "companyLinkedToResumeJob": {
                    "message": "{first_name} {last_name} has tagged your company in his/her CV. Please update the status of the tag."
                },
                "cooperationAgreementChanged": {
                    "message": "Changes were made in your cooperation contract between {company1} and {company2}"
                },
                "resumeJobEntryChanged": {
                    "message": "Changes were made to your job position {job_title} at  {company}"
                }
            },
            "november": "November",
            "numberOfEmployees": "Number of employees",
            "numberOfJobs": "Number of jobs to be occupied",
            "october": "October",
            "of": "from",
            "oldNotifications": "Older notifications",
            "onlyForEmployees": "Only for employees",
            "onlyForEmployeesText": "This feature is only available to employees.",
            "open": "Pending",
            "openAccount": "Create account",
            "other": "Other",
            "otherDocuments": "Other documents",
            "password": "Password",
            "passwordConfirmation": "Repeat password",
            "passwordResetFailed": "Password could not be resetted",
            "passwordResetInfo": "You receive an Email to reset your password",
            "passwordResetSuccessful": "Password reset successfully",
            "paymentPeriod": "Billing cycle",
            "perMonth": "Per month",
            "perYear": "Per year",
            "percent": "Percent",
            "percentMax": "Percent maximum",
            "percentMin": "Percent minimum",
            "personalResponsibility": "HR manager",
            "phone": "Phone number",
            "place": "Place",
            "platformName": "jobs2share",
            "pleaseLogIn": "Please login",
            "preview": "Preview",
            "price": "Price",
            "pricePerMonth": "Price per month",
            "pricePerYear": "Price per year",
            "product": "Product|Products",
            "proficiency": {
                "1": "Basic knowledge",
                "2": "Good",
                "3": "Fluent",
                "4": "Mother tongue",
                "label": "Knowledge"
            },
            "profile": "Profile",
            "profilePicture": "Profile picture",
            "profilePicture-size-info": "Recommended image size: 500px width and 500px height",
            "publishedOm": "Published on",
            "questionDeleteJobApplication": "Do you want to delete this application permanently?",
            "questionSubmitApplication": "Would you like to finally submit your application?",
            "questionsToCompany": "If you have any questions, please contact the cooperation company directly",
            "reason": "Reasoning",
            "reasonDetail": "Detailed reasoning",
            "receipt": "Receipt|Receipts",
            "reception": "Reception",
            "redeemCoupon": "Use a voucher",
            "redeemCouponDescription": "Use the voucher code for the selected subscription",
            "refreshlocation": "Update location",
            "register": "Register",
            "registerNow": "Register now",
            "registration": "Registration",
            "rejectDeleteJobApplication": "No, keep application",
            "removeCompany": "Remove company",
            "removeCompanyText": "Are you sure you want to remove company \"{companyName}\"? All published job ads by this company will be deactivated during this process.",
            "removeFavoriteSuccessful": "Job ad was successfully removed from favorites",
            "renewJobs": "Renew job ads",
            "reportError": "Report mistake",
            "reportProblem": "Report problem",
            "resetFilter": "Reset filter",
            "resetPassword": "Reset password",
            "residencePermit": {
                "B": "B: residence permit",
                "C": "C: residence permit",
                "G": "G: cross-border commuter",
                "L": "L: short-term residence permit",
                "label": "Residence permits"
            },
            "results": "Results",
            "resume": "Résumé",
            "rowsPerPage": "Lines per page",
            "salutation": "Salutation",
            "salutationMr": "Mr.",
            "salutationMrText": "Dear Mr.",
            "salutationMrs": "Ms.",
            "salutationMrsText": "Dear Ms.",
            "salutationText": "Hello",
            "save": "Save",
            "saveAsDraft": "Save draft",
            "saveChanges": "Save changes",
            "search": "Search",
            "searchCompany": "Find your company",
            "searchResults": "Search results",
            "season": "Season",
            "seasonalJob": "Seasonal job",
            "seasonalJobEndDateAfter": "Seasonal job ending after {date}",
            "seasonalJobEndDateBefore": "Seasonal job ending before {date}",
            "selectBillingCycle": "Select the billing cycle and automatically renew your subscription.<br>\nMany thanks for your trust in us!",
            "selectFile": "Select file",
            "semiskilled": "Semi-skilled",
            "send": "Send",
            "sent": "Sent",
            "september": "September",
            "service": "Service",
            "shortDescription": "Brief description",
            "show": "Show",
            "showAll": "Show all",
            "showAllNotifications": "Show all notifications",
            "showAndEdit": "Display and edit",
            "showApplication": "Show application",
            "skilledEmployee": "Skilled employee",
            "slogan": "Jobs2share<br>Seasonal jobs with an all-year perspective",
            "star": "Stars|Star",
            "start": "Start",
            "startMonth": "Start month",
            "startOfTraining": "Start of training",
            "startOfWork": "Start of job",
            "status": "Status",
            "street": "Street",
            "streetNumber": "Number",
            "subject": "Subject",
            "subjectToRegistration": "subject to registration",
            "submitApplication": "Submit application",
            "submitApplicationSuccessful": "Application successfully submitted",
            "subscription": "Subscription",
            "subscriptionFreeExtension": "({0} days free extension of your subscription)",
            "subscriptionInfoDialog": {
                "label": "Subscription information",
                "link": "here.",
                "text": "You can manage several companies in your account by choosing \"Add main subscription\", then you purchase a subscription at the regular price. As the owner of an account in the category \"Large\" , you can purchase a subscription at a special rate of only CHF 24.90 / month for every additional company in your account. If you want to take advantage of this attractive offer, then select \"Add additional subscription\". Further information about subscriptions can be found {0}"
            },
            "subscriptionInformation": "Subscription information",
            "subscriptionPeriod": "Subscription period",
            "subscriptionRenewOn": "Subscription will be extended on",
            "subscriptionRenewOnInfoText": "You have changed your subscription on {0} and thereby extended your subscription.",
            "subscriptionRequiredText": "Job ads are only published with a valid subscription",
            "subscriptionShort": "Subscription",
            "subscriptionTerminateDialog": {
                "hasActiveAdditionalCompanies": "This subscription has active additional companies and cannot be cancelled.<br>Please cancel the additional companies first.",
                "info": "After your cancellation, the following options will no longer be available after {0}.",
                "intro": "Would you like to cancel the subscription for the following company?",
                "options": "<ul>\n<li>Publishing job advertisements</li>\n<li>Receiving applications</li>\n<li>Accepting employees</li>\n</ul>"
            },
            "subscriptionTerminatedOn": "Subscription will be cancelled per",
            "subscriptions": {
                "additional": "Additional subscription",
                "base": "Main subscription category",
                "large": "Large",
                "largeText": "For companies with 81 or more employees",
                "micro": "Micro",
                "microText": "For companies with a maximum of 10 employees",
                "middle": "Medium",
                "middleText": "For companies with 31 to 80 employees",
                "small": "Small",
                "smallText": "For companies with between 11 to 30 employees"
            },
            "successful": "Successful",
            "summary": "Summary",
            "summer": "Summer",
            "survey": "Overview",
            "tableNoEntries": "No entries",
            "technique": "Tech & maintainance",
            "temporary": "Temporary",
            "terminate": "Cancel",
            "terminated": "Cancelled",
            "testing": "Check",
            "title": "Title",
            "titleJob": "Job title",
            "to": "to",
            "toJob": "Go to job ad",
            "toTheActiveApplications": "To the active applications",
            "today": "Today",
            "training": "Training",
            "trainingFacility": "Training center",
            "type": "Type",
            "typeCompany": "I am a company (employer)",
            "typeEmployee": "I am looking for a job (staff)",
            "typeQuestion": "Would you like to register as an individual or as a company?",
            "typeYourPassword": "Insert password",
            "understood": "Understood",
            "unlimitedPosition": "Permanent position",
            "updateApplication": "Update status",
            "updateCreditCard": "Update credit card",
            "updateDraft": "Update draft",
            "uploadProfilePicture": "Add profile pic for upload<br>(Max 5 MB)",
            "uploading": "Upload",
            "url": "URL",
            "userData": "User data",
            "username": "User name",
            "validityOf": "Validity since",
            "validityUntil": "Validity until",
            "value": "Value",
            "website": "Website",
            "wellness": "Wellness, Beauty, Health",
            "what": "What it is about",
            "whatToChange": "What do you want to change?",
            "winter": "Winter",
            "withoutJobAdvertisement": "Without job ad",
            "workExperience": "Work experience",
            "workload": "Average workload (%)",
            "workplace": "Job",
            "year": "Year",
            "yes": "Yes",
            "yourConcern": "Your message",
            "zip": "ZIP code"
        }
    },
    "fr": {
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure au {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale au {date}.",
            "alpha": "Le champ {attribute} doit contenir uniquement des lettres.",
            "alpha_dash": "Le champ {attribute} doit contenir uniquement des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} doit contenir uniquement des chiffres et des lettres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure au {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale au {date}.",
            "between": {
                "numeric": "La valeur de {attribute} doit être comprise entre {min} et {max}.",
                "file": "La taille du fichier de {attribute} doit être comprise entre {min} et {max} kilo-octets.",
                "string": "Le texte {attribute} doit contenir entre {min} et {max} caractères.",
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "Le champ de confirmation {attribute} ne correspond pas.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_equals": "Le champ {attribute} doit être une date égale à {date}.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "different": "Les champs {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit contenir entre {min} et {max} chiffres.",
            "dimensions": "La taille de l'image {attribute} n'est pas conforme.",
            "distinct": "Le champ {attribute} a une valeur en double.",
            "email": "Le champ {attribute} doit être une adresse email valide.",
            "ends_with": "Le champ {attribute} doit se terminer par une des valeurs suivantes : {values}",
            "exists": "Le champ {attribute} sélectionné est invalide.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "gt": {
                "numeric": "La valeur de {attribute} doit être supérieure à {value}.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir plus de {value} caractères.",
                "array": "Le tableau {attribute} doit contenir plus de {value} éléments."
            },
            "gte": {
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {value}.",
                "file": "La taille du fichier de {attribute} doit être supérieure ou égale à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au moins {value} caractères.",
                "array": "Le tableau {attribute} doit contenir au moins {value} éléments."
            },
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être un document JSON valide.",
            "lt": {
                "numeric": "La valeur de {attribute} doit être inférieure à {value}.",
                "file": "La taille du fichier de {attribute} doit être inférieure à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir moins de {value} caractères.",
                "array": "Le tableau {attribute} doit contenir moins de {value} éléments."
            },
            "lte": {
                "numeric": "La valeur de {attribute} doit être inférieure ou égale à {value}.",
                "file": "La taille du fichier de {attribute} doit être inférieure ou égale à {value} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au plus {value} caractères.",
                "array": "Le tableau {attribute} doit contenir au plus {value} éléments."
            },
            "max": {
                "numeric": "La valeur de {attribute} ne peut être supérieure à {max}.",
                "file": "La taille du fichier de {attribute} ne peut pas dépasser {max} kilo-octets.",
                "string": "Le texte de {attribute} ne peut contenir plus de {max} caractères.",
                "array": "Le tableau {attribute} ne peut contenir plus de {max} éléments."
            },
            "mimes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "mimetypes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "min": {
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {min}.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {min} kilo-octets.",
                "string": "Le texte {attribute} doit contenir au moins {min} caractères.",
                "array": "Le tableau {attribute} doit contenir au moins {min} éléments."
            },
            "not_in": "Le champ {attribute} sélectionné n'est pas valide.",
            "not_regex": "Le format du champ {attribute} n'est pas valide.",
            "numeric": "Le champ {attribute} doit contenir un nombre.",
            "password": "Le mot de passe est incorrect",
            "present": "Le champ {attribute} doit être présent.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_if": "Le champ {attribute} est obligatoire quand la valeur de {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {values}.",
            "required_with": "Le champ {attribute} est obligatoire quand {values} est présent.",
            "required_with_all": "Le champ {attribute} est obligatoire quand {values} sont présents.",
            "required_without": "Le champ {attribute} est obligatoire quand {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est requis quand aucun de {values} n'est présent.",
            "same": "Les champs {attribute} et {other} doivent être identiques.",
            "size": {
                "numeric": "La valeur de {attribute} doit être {size}.",
                "file": "La taille du fichier de {attribute} doit être de {size} kilo-octets.",
                "string": "Le texte de {attribute} doit contenir {size} caractères.",
                "array": "Le tableau {attribute} doit contenir {size} éléments."
            },
            "starts_with": "Le champ {attribute} doit commencer avec une des valeurs suivantes : {values}",
            "string": "Le champ {attribute} doit être une chaîne de caractères.",
            "timezone": "Le champ {attribute} doit être un fuseau horaire valide.",
            "unique": "La valeur du champ {attribute} est déjà utilisée.",
            "uploaded": "Le fichier du champ {attribute} n'a pu être téléversé.",
            "url": "Le format de l'URL de {attribute} n'est pas valide.",
            "uuid": "Le champ {attribute} doit être un UUID valide",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "nom",
                "username": "nom d'utilisateur",
                "email": "adresse email",
                "first_name": "prénom",
                "last_name": "nom",
                "password": "mot de passe",
                "password_confirmation": "confirmation du mot de passe",
                "city": "ville",
                "country": "pays",
                "address": "adresse",
                "phone": "téléphone",
                "mobile": "portable",
                "age": "âge",
                "sex": "sexe",
                "gender": "genre",
                "day": "jour",
                "month": "mois",
                "year": "année",
                "hour": "heure",
                "minute": "minute",
                "second": "seconde",
                "title": "titre",
                "content": "contenu",
                "description": "description",
                "excerpt": "extrait",
                "date": "date",
                "time": "heure",
                "available": "disponible",
                "size": "taille"
            }
        }
    },
    "it": {
        "pagedefinitions": {
            "about": {
                "metaTags": {
                    "description": "Qui trovate informazioni su Job2share",
                    "keywords": "jobs2share, posti di lavoro stagionali"
                },
                "path": "su-di-noi",
                "title": "su-di-noi"
            },
            "agb": {
                "metaTags": {
                    "description": "Qui si trovano le norme sulla privacy e termini e condizioni",
                    "keywords": "Privacy, termini e condizioni"
                },
                "path": "termini-e-condizioni",
                "title": "Privacy e termini e condizioni"
            },
            "careerday": {
                "metaTags": {
                    "description": "Passa a trovarci, scopri interessanti imprese e assicurati magari già il tuo impiego stagionale estivo",
                    "keywords": "careerday"
                },
                "path": "careerday",
                "title": "Mitarbeiter-Sharing Career Day"
            },
            "employee": {
                "path": "dipendenti"
            },
            "employer": {
                "path": "aziende"
            },
            "findAJob": {
                "metaTags": {
                    "description": "Lavorare con un sacco di varietà e avventura: combinare due emozionanti posizioni stagionali in una prospettiva tutto l'anno che è perfetto per voi!",
                    "keywords": "Ricerca di lavoro, lavoro stagionale, lavoro in svizzera"
                },
                "path": "trova-lavori",
                "title": "Trova lavori entusiasmanti. Combina estivo e invernale"
            },
            "furtherEducation": {
                "metaTags": {
                    "description": "Nel periodo della bassa stagione, frequentare corsi di formazione con i nostri partner. Trova qui qualcosa di adatto",
                    "keywords": "Formazione, corsi di lingua, formazione continua"
                },
                "path": "formazione-continua",
                "title": "Formazione continua in bassa stagione"
            },
            "home": {
                "metaTags": {
                    "description": "Combina le posizioni stagionali estive e invernali sulla piattaforma online jobs2share per creare prospettive entusiasmanti durante tutto l'anno.",
                    "keywords": "lavoro stagionale in svizzera, impiego, Lavorare in gastronomia"
                },
                "title": "Prospettive lavorative su tutto l’arco dell’anno"
            },
            "howItWorks": {
                "path": "come-funziona"
            },
            "impress": {
                "metaTags": {
                    "description": "Qui si trovano le informazione legale",
                    "keywords": "informazione legale"
                },
                "path": "informazione-legale",
                "title": "Informazione legale"
            },
            "jobAdvertisement": {
                "metaTags": {
                    "description": "Inizia a reclutare e trattenere i migliori lavoratori stagionali con una nuova modalità",
                    "keywords": "trovare dipendenti, Inserisci lavoro, lavoratori qualificati"
                },
                "path": "trovare-personale",
                "title": "Trovare e trattenere personale stagionale con jobs2share"
            },
            "jobs": {
                "metaTags": {
                    "description": "Lavorate con molta varietà e avventura: Combinate due emozionanti posizioni stagionali in un pacchetto di impiego estate/inverno, in base alle vostre specifiche esigenze",
                    "keywords": "Lavori stagionali, trovare un impiego"
                },
                "title": "Combina posti di lavoro estivi e invernali e approfitta"
            },
            "rulesOfTheGame": {
                "metaTags": {
                    "description": "Gli utenti della piattaforma jobs2share si impegnano ad un equo trattamento reciproco nel senso di una proficua collaborazione.",
                    "keywords": "Regole del gioco, fair play, impegno, cooperazione"
                },
                "path": "regole",
                "title": "Regole \"Fair Play\""
            },
            "secoPilotEmployee": {
                "metaTags": {
                    "description": "Non ci sono solo i migliori posti di lavoro estivi e invernali, ma anche soluzioni per superare la off-season - grazie ad un progetto pilota della SECO",
                    "keywords": "pilota della SECO, superare la stagioni intermedie, bassa stagione"
                },
                "path": "pilota-seco",
                "title": "Superare le stagioni intermedie. Così funziona."
            },
            "secoPilotEmployer": {
                "metaTags": {
                    "description": "Non ci sono solo i migliori posti di lavoro estivi e invernali, ma anche soluzioni per superare la off-season - grazie ad un progetto pilota della SECO",
                    "keywords": "pilota della SECO, superare la stagioni intermedie, bassa stagione"
                },
                "path": "pilota-seco",
                "title": "Superare le stagioni intermedie. Così funziona."
            }
        },
        "content": {
            "advantagesEmployee": {
                "label": "Vantaggi",
                "text1": "La vita è troppo breve per accontentarsi di un impiego poco stimolante. Su jobs2share trovate impieghi stagionali estivi e invernali che fanno al caso vostro. Per di più potete scoprire le più belle regioni della Svizzera, dare una spinta alla vostra carriera, fare nuove amicizie e migliorare le vostre conoscenze linguistiche. Lavoratrici e lavoratori con un pacchetto di impiego estate/inverno possono usufruire di opportunità di {0} e di un accesso agevolato a {1} Questo semplice strumento di candidatura vi consente di inviare, con pochi clic, una candidatura di lavoro professionale.",
                "text1Additional": "* Possono usufruire di questo servizio le persone residenti nei Grigioni e in Ticino nel quadro di un progetto pilota autorizzato dalla SECO. Ulteriori informazioni sono disponibili {0}",
                "text1Additionallink": "qui.",
                "text1link1": "perfezionamento professionale",
                "text1link2": "indennità di disoccupazione durante le stagioni intermedie*.",
                "unemploymentBenefits": "Indennità di disoccupazione"
            },
            "advantagesEmployer": {
                "forYouremployees": {
                    "label": "I vantaggi per il vostro personale",
                    "text1": "Stimolante ambiente di lavoro in base allo slogan «Montagne e lago, lavoro e svago».",
                    "text2": "Prospettive lavorative sull’intero arco dell’anno e pianificazione della carriera.",
                    "text3": "Offerta di corsi di perfezionamento professionale durante le stagioni intermedie. {action}",
                    "text3link": "Qui troverete maggiori informazioni al riguardo.",
                    "text4": "Nel quadro di un progetto pilota autorizzato dalla Segreteria di Stato dell’economia (SECO), le lavoratrici e i lavoratori residenti nei Grigioni e in Ticino usufruiscono in modo agevolato, durante le stagioni intermedie, di prestazioni concesse dalla Cassa di disoccupazione, senza l’obbligo di comprovare l’impegno nella ricerca di un impiego o senza dover soddisfare requisiti burocratici aggiuntivi. {action}",
                    "text4link": "Qui troverete maggiori informazioni in merito."
                },
                "label": "Vantaggi",
                "yours": {
                    "label": "I vostri vantaggi",
                    "text1": "In questo modo impreziosite la vostra offerta di impieghi stagionali e proponete al vostro personale molto più di un semplice impiego stagionale.",
                    "text2": "Reclutate e collaborate con imprese rinomate mantenendo piena autonomia sotto tutti i punti di vista.",
                    "text3": "Incrementate la soddisfazione del vostro personale e create con esso un legame più stretto"
                }
            },
            "archived": "Archiviato",
            "careerday": {
                "additional": "Nessuna registrazione richiesta<br>\nNon dimenticare di portare il tuo curriculum vitae!",
                "duration": {
                    "label": "Orario",
                    "value": "Previsto alle 9&colon;30 - 11&colon;30 e 14&colon;00 - 16&colon;00"
                },
                "intro": "<strong>Martedì, il 17 agosto 2021</strong> si svolgerà il Mitarbeiter-Sharing Career Day a Losone, in Ticino! Passa a trovarci, scopri aziende interessanti e assicurati già un impiego per la prossima stagione invernale 2021/22.<br>\nTutto ciò in linea con il nostro motto: «Montagne e lago, lavoro e svago».",
                "label": "Career Day",
                "place": {
                    "label": "Luogo",
                    "value": "<a href=\"https://goo.gl/maps/xXNjPRxAoK3SFrNRA\" target=\"_blank\">Albergo Losone</a>"
                },
                "price": {
                    "label": "Costo di partecipazione",
                    "value": "gratuito!"
                },
                "title": "Mitarbeiter-Sharing Career Day 2021"
            },
            "contact": {
                "cantSolveProblem": "Il vostro problema non è ancora stato risolto? Vi offriamo tutto il nostro supporto. Mettetevi in contatto con noi.",
                "employees": "Lavoratrici",
                "employers": "Lavoratori",
                "importantQuestions": "Qui troverete le principali domande e le relative risposte",
                "label": "Contatto"
            },
            "employeesSays": {
                "1": {
                    "person": "Marika Somaini, impiegata d’albergo",
                    "text": "«Grazie al progetto Mitarbeiter-Sharing si scopre la diversità culturale, climatica e paesaggistica della Svizzera. Abbiamo il privilegio di lavorare dove gli altri vanno in vacanza. Si rimane attivi e sereni sapendo di avere una continuità lavorativa ed un‘ evoluzione professionale costante.»"
                },
                "10": {
                    "person": "Rodella Massimo",
                    "text": "La piattaforma Jobs2share mi dà la possibilità , di avere una o più possibilità di scegliere opportunità di impiego al fine di avere una continuità lavorativa per tutto l’anno, pur non  disponendo di un contratto di lavoro a tempo indeterminato."
                },
                "11": {
                    "person": "Patti Clara",
                    "text": "Sono una collaboratrice del Tschuggen group, lavoro da molti anni in questo gruppo, sto facendo una nuova esperienza presso il Castello del Sole ad Ascona, e sarei molto felice di ritornare all’ hotel Valsana per la prossima stagione invernale."
                },
                "2": {
                    "person": "Alessia Tagli, impiegata di ristorazione",
                    "text": "«Jobs2share è per me una fantastica opportunità di crescita personale e professionale. Durante l’inverno lavoro presso lo Schweizerhof Lenzerheide, mentre durante l’estate presso il Delfino Lugano- due realtà affascinanti e molto diverse tra di loro, in cui posso imparare molto.»"
                },
                "3": {
                    "person": "Fabio Dell’Ava, 2. Concierge",
                    "text": "Grazie alla piattaforma Jobs2share ho l’opportunità di rendere la mia situazione professionale più varia, dinamica e allettante. Vivendo in due luoghi fantastici e conoscendo due realtà lavorative differenti."
                },
                "4": {
                    "person": "Corrado Taglioni, II. Maitre d’hôtel",
                    "text": "Jobs2share mi da la possibilità di lavorare in due prestigiosi Hotel, uno sul lago e l’altro in montagna dove oltre al lavoro posso praticare la sci!"
                },
                "5": {
                    "person": "Nina della Vedova, Demi Chef de Rang",
                    "text": "Sono molto orgogliosa di poter usufruire della piattaforma Jobs2share perché mi permette di volgere il mio lavoro in grandi e lussuosi alberghi, dove posso ampliare le mie conoscenze general quotidianamente. Grazie a questa piattaforma avendo comunque una continuità professionale per 10 messi annui."
                },
                "6": {
                    "person": "Paula Da Silva Rego, cameriera  & Nuno Ferreira da Fonseca, impiegato d’ufficio",
                    "text": "Grazie alla piattaforma Jobs2share abbiamo la possibilità di lavorare in due hotel di lusso in diversi cantoni dove possiamo espandere le nostre conoscenze. Dove gli stessi hotel ci danno l’opportunità di affittare uno studio/appartamento in modo che i lavoratori si sentano un po` a casa."
                },
                "7": {
                    "person": "Leopold Ott, Sous-Chef",
                    "text": "Jobs2share offre l’opportunità, con un minimo sforzo, di cambiare impiego e concentrarsi sul nuovo lavoro. l proprio bagaglio professionale e personale si sviluppa in modo importante durante questo processo. Non posso che consigliarlo e tornerei ad approfittare di questa opportunità."
                },
                "8": {
                    "person": "Robert Fiedler, Sous-Chef",
                    "text": "Grazie a Jobs2share mi è stata data la possibilità di lavorare presso due rinomati Swiss Deluxe Hotel. Una fantastica opportunità di crescere personalmente e professionalmente. Grazie all’offerta di appartamenti del personale si può concentrare al 100% alle proprie nuove mansioni senza perdere tempo nella ricerca d’alloggio. Lavorare dove gli altri passano le loro vacanze."
                },
                "9": {
                    "person": "Torri Davide",
                    "text": "Grazie alla piattaforma Jobs2share abbiamo la possibilità di lavorare in grandi aziende di tradizione che ci offrono continui aggiornamenti lavorativi, sicurezza per il futuro, e la consapevolezza di creare un aiuto integrativo per contrastare la disoccupazione."
                },
                "label": "I dipendenti dicono"
            },
            "employersSays": {
                "1": {
                    "person": "Corinne Denzler, General Manager<br>Tschuggen Hotel Group",
                    "text": "«Jobs2share è per noi un’eccellente occasione per offrire prospettive lavorative su tutto l’arco dell’anno.»"
                },
                "10": {
                    "person": "Ralph Treuthardt, direttore<br>Hotel Guarda Val, Sporz",
                    "text": "«Trovare dipendenti ben formati e con spirito cordiale è diventato molto difficile. jobs2share è una vera vittoria per noi e per il personale. Offre l'opportunità ai dipendenti di formarsi ulteriormente lavorando in diverse strutture e con diverse filosofie aziendali.»"
                },
                "11": {
                    "person": "Fabian Mauerhofer, Food & Beverage Manager<br>Vitznauerhof",
                    "text": "« È essenziale non solo utilizzare la piattaforma jobs2share come strumento per la ricerca dei dipendenti, ma anche sostenere la nostra professione con vari corsi di formazione pratica e assistenza linguistica.»"
                },
                "2": {
                    "person": "Marcel Krähenmann, Direttore<br>Boutique Hotel La Rocca",
                    "text": "«Il settore alberghiero e della ristorazione sentono sempre più la mancanza di personale qualificato. La nostra soluzione è Sharing dei dipendenti. Usiamo jobs2share per collaborare con altre aziende stagionali e offrire ai dipendenti prospettive interessanti per tutto l'anno - una ricetta per il successo al fine di rimanere competitivi!»"
                },
                "3": {
                    "person": "Andreas e Claudia Züllig-Landolt, direttori e alberghieri<br>Hotel Schweizerhof Lenzerheide",
                    "text": "«Jobs2share ci esalta! Nei Grigioni collaboriamo con dipendenti ticinesi e di altre cantoni che torneranno in estate nella regione d’origine e diventeranno quindi \"un valore aggiunto\" per le aziende e per gli ospiti.»"
                },
                "4": {
                    "person": "<Franzisca Rechsteiner, HR Manager<brHotel Castello del Sole Ascona",
                    "text": "\"Sharing dei dipendenti e la piattaforma jobs2share sono strumenti rivolti al futuro, pensati per ispirare, reclutare e trattenere i dipendenti presso la nostra azienda.\""
                },
                "5": {
                    "person": "Regula Peter, Director of Human Resources<br>Badrutt’s Palace Hotel St. Moritz",
                    "text": "«Il Badrutt's Palace Hotel investe molto nella formazione dei dipendenti. Ciò include anche l'offerta di interessanti prospettive di lavoro. Attraverso lo Sharing dei dipendenti e jobs2share, offriamo ai nostri collaboratori le migliori opportunità per lavori estivi. A oggi il progetto ha già portato a grandi collaborazioni, attraverso le quali creiamo nuove opportunità di lavoro per i dipendenti partecipanti, networking con altre aziende e quindi anche opportunità di sviluppo. »"
                },
                "6": {
                    "person": "Federico Haas, direttore e proprietario<br>Hotel Delfino Lugano",
                    "text": "«Il cambio rende la vita magnifica”. Con questo motto, motiviamo specialmente i nostri collaboratori più giovani a fare parte del progetto Sharing dei dipendenti»"
                },
                "7": {
                    "person": "Esther Oubina, HR Manager<br>Villa Orselina",
                    "text": "«Jobs2share ci consente di motivare e mantenere i nostri dipendenti con prospettive a lungo termine e programmi di supporto. Una vittoria per tutti.»"
                },
                "8": {
                    "person": "Thomas Gruber, Human Resources Manager<br>Grand Hotel Villa Castagnola, Lugano",
                    "text": "<p>«Guardo gli occhi raggianti dei nostri dipendenti quando parlano dello scambio positivo e delle collaborazioni. jobs2share offre certezze al momento della firma di un contratto per la prossima stagione in una delle nostre rinomate aziende partner.</p><p>Per noi datori di lavoro e, soprattutto, per i nostri ospiti abituali, non c'è niente di meglio che incontrare volti noti di impiegati che hanno già familiarità con i servizi e la filosofia dell'azienda.</p><p>Sharing dei dipendenti e la piattaforma associata jobs2share sono un'offerta vantaggiosa per datori e collaboratori.»</p>"
                },
                "9": {
                    "person": "Sandy Stöckenius HR Manager<br>Belvédère Hotels Scuol",
                    "text": "«Ottime opportunità per i dipendenti di avere un lavoro annuale e la possibilità di conoscere due destinazioni differenti - Cosa c'è di più eccitante?»"
                },
                "label": "Le aziende dicono"
            },
            "faqsEmployees": {
                "cooperations": {
                    "1a": "Se attraverso jobs2share combinate un impiego estivo e un impiego invernale, tale pacchetto combinato viene inserito in un cosiddetto contratto di collaborazione. Questo documento può essere scaricato come file in formato PDF nel proprio account cliente. A tal fine dovete disporre di un impiego stagionale attuale e di un impiego stagionale integrativo presso imprese che partecipano al progetto Mitarbeiter-Sharing e che sono registrate sulla piattaforma jobs2share.{linebreak}{linebreak} Il contratto di collaborazione rappresenta il legame lavorativo tra i due datori di lavoro e il dipendente, creando così trasparenza tra le parti coinvolte.{linebreak}{linebreak} \nCiò consente ai datori di lavoro di offrire un valore aggiunto al proprio dipendente comune oltre la singola stagione. In tal senso, i datori di lavoro pianificano insieme i passi successivi per la carriera e lo sviluppo professionale del dipendente. Inoltre offrono corsi di perfezionamento professionale ai propri impiegati, concordando la data d’ingresso e quella di uscita.{linebreak}{linebreak}\nNel quadro di un progetto {action} a partire dal 1° gennaio 2019 presentando il contratto di collaborazione le lavoratrici e i lavoratori residenti nei Grigioni e in Ticino usufruiscono in modo agevolato, durante le stagioni intermedie, di prestazioni concesse dalla Cassa di disoccupazione, senza l’obbligo di comprovare nei confronti dell’Ufficio regionale di collocamento (URC) competente il proprio impegno nella ricerca di un impiego.",
                    "1alink": "pilota autorizzato dalla Segreteria di Stato dell’economia (SECO),",
                    "1q": "Cos’è un contratto di collaborazione?",
                    "2a": "<p>Un contratto di collaborazione viene generato quando due impieghi stagionali (pacchetto di impiego estate/inverno) vengono combinati per offrire prospettive lavorative sull’intero arco dell’anno. Ciò avviene quando, nel profilo della lavoratrice o del lavoratore su jobs2share, vengono combinati un impiego stagionale attuale e un impiego stagionale integrativo – appunto un pacchetto di impiego estate/inverno – presso due datori di lavoro registrati sulla piattaforma, i quali hanno confermato tale impiego.</p><p>Il pacchetto di impiego estate/inverno può generare in due modi un contratto di collaborazione sulla piattaforma:</p>\n<ol><li>Disponete già di un impiego stagionale attuale oppure vi è già stato confermato un impiego stagionale integrativo.<ul><li>Inserite tale impiego stagionale nel vostro profilo. Il datore di lavoro di questo impiego stagionale attuale o dell’imminente impiego stagionale integrativo deve anch’esso confermare l’impiego in questione su jobs2share.\n</li><li>Candidatevi sulla piattaforma jobs2share per un secondo impiego stagionale nella stagione immediatamente successiva. Non appena avrete ricevuto una conferma anche da questo datore di lavoro registrato su jobs2share, il vostro pacchetto di impiego estate/inverno è stato creato ed è visibile all’interno del vostro profilo. Ora viene generato automaticamente un contratto di collaborazione, pronto per essere scaricato.</li></ul></li><li>Al momento non disponete né di un impiego stagionale attuale né di un impiego stagionale integrativo.<ul><li>Candidatevi su jobs2share per idonei impieghi stagionali. Non appena avrete trovato un idoneo impiego per la stagione attuale e anche per la stagione successiva, e dopo che entrambi gli impieghi sono stati confermati su jobs2share dai rispettivi datori di lavoro, il vostro pacchetto di impiego estate/inverno è stato creato ed è visibile all’interno del vostro profilo. Ora viene generato automaticamente un contratto di collaborazione, pronto per essere scaricato.</li></ul></li></ol>",
                    "2q": "Come viene generato un contratto di collaborazione?",
                    "3a": "Su jobs2share inserite gratuitamente i dati relativi al vostro profilo e la documentazione di candidatura, creando così ottimi presupposti per le vostre candidature. Le informazioni da voi inserite nel vostro profilo formano la base per le vostre candidature. Se vi candidate su jobs2share per un impiego, l’impresa in questione ha accesso alle informazioni da voi inserite (come vostra candidatura). Se viene creato un pacchetto di impiego estate/inverno, voi e i due datori di lavoro ricevete il contratto di collaborazione, in cui sono contenuti i dati principali riguardanti la data d’inizio e la data conclusiva dei vostri impieghi, la mansione e i dati di contatto dei due datori di lavoro.",
                    "3q": "Quali informazioni vengono inoltrate ai miei datori di lavoro?",
                    "4a": "Nel vostro profilo potete visualizzare inserimenti nel vostro curriculum. Se sono presenti degli errori, ad esempio perché un’impresa attuale o precedente ha confermato un dato erroneo, potete chiedere che tali errori vengano corretti dal datore di lavoro in questione. {action} potete comunicare eventuali errori.",
                    "4alink": "Qui",
                    "4q": "Errore nel contratto di collaborazione: cosa devo fare per comunicare o correggere un eventuale errore?",
                    "5a": "I pacchetti di impiego estate/inverno generano dei contratti di collaborazione se entrambi i datori di lavoro partecipano al progetto Mitarbeiter-Sharing e se entrambi sono registrati su jobs2share. Un contratto di collaborazione viene quindi generato solo se il vostro pacchetto di impiego estate/inverno è formato da impieghi presso datori di lavori che sono registrati su jobs2share e che hanno confermato su jobs2share i vostri impieghi stagionali.",
                    "5q": "Nel mio profilo non è presente alcun contratto di collaborazione, nonostante io disponga di un impiego estivo e di un impiego invernale. Come mai?",
                    "label": "Contratto di collaborazione: collaborare con due datori di lavoro"
                },
                "label": "Domande frequenti",
                "notifications": {
                    "1a": "Le notizie più importanti vi vengono recapitate per e-mail. Tutte le altre operazioni possono essere eseguite direttamente su jobs2share.",
                    "1q": "Come vengo avvisato dell’esistenza di una novità sulla piattaforma?",
                    "label": "Avvisi"
                },
                "offSeason": {
                    "1a": "Nel quadro di un progetto pilota autorizzato dalla Segreteria di Stato dell’economia (SECO), a partire dal 1° gennaio 2019 le lavoratrici e i lavoratori residenti nei Grigioni e in Ticino percepiscono un’indennità di disoccupazione per un periodo massimo di sei settimane all’anno durante le stagioni intermedie, senza l’obbligo di comprovare nei confronti dell’Ufficio regionale di collocamento (URC) competente il proprio impegno nella ricerca di un impiego. Essi devono disporre di un pacchetto di impiego estate/inverno registrato su jobs2share che copre il periodo intermedio in cui desiderano percepire un’indennità di disoccupazione. Il relativo contratto di collaborazione è depositato come file in formato in PDF all’interno dell’account cliente e deve essere presentato tempestivamente all’URC competente. Ulteriori informazioni al riguardo sono disponibili {action}",
                    "1alink": "qui.",
                    "1q": "Cosa devo fare per percepire un’indennità di disoccupazione durante la stagione intermedia, senza dover comprovare nei confronti dell’Ufficio regionale di collocamento (URC) il mio impegno nella ricerca di un impiego?",
                    "2a": "Candidatevi su jobs2share per interessanti offerte di lavoro. Se disponete già di un impiego stagionale attuale o di un impiego stagionale integrativo potete, in tutta semplicità, inserirlo nel vostro curriculum nel vostro profilo jobs2share. Non appena un impiego stagionale estivo e un impiego stagionale invernale sono stati inseriti nel vostro profilo e sono stati confermati, viene creato un pacchetto di impiego. Unica condizione: entrambi i datori di lavoro devono essere registrati sulla piattaforma jobs2share.",
                    "2q": "Cosa devo fare per creare un pacchetto di impiego estate/inverno?",
                    "3a": "È semplicissimo: registrarsi, effettuare il login, alla voce «Ricerca di impieghi» ricercare impieghi idonei e candidarsi direttamente su jobs2share. Grazie all’integrato strumento di candidatura potete riutilizzare i certificati e i dati inseriti nel vostro profilo risparmiando un sacco di tempo. Inoltre potete redigere un testo di presentazione individuale. La vostra candidatura sarà così sempre perfetta e professionale, aumentando le vostre probabilità di successo.",
                    "3q": "Cosa devo fare per candidarmi?",
                    "4a": "Dipende dal numero di posti vacanti presso i datori di lavoro.",
                    "4q": "Ogni quanto vengono pubblicati nuovi annunci di lavoro?",
                    "5a": "Potete consultare le offerte di lavoro senza dover essere registrati. Per poter beneficiare di tutti i vantaggi offerti dalla piattaforma dovete tuttavia registrarvi.",
                    "5q": "È necessario registrarsi?",
                    "6a": "No. Solo voi potete visualizzare quali annunci di lavoro sono da voi stati contrassegnati come preferiti.",
                    "6q": "Un datore di lavoro vede se contrassegno il suo annuncio di lavoro come preferito?",
                    "7a": "Dipende dal tempo di reazione del datore di lavoro.",
                    "7q": "In quanto tempo ricevo una risposta alla mia candidatura?",
                    "8a": "No. Per le lavoratrici e i lavoratori, l’utilizzo della piattaforma è completamente gratuito.",
                    "8q": "Maturano per me eventuali costi?",
                    "label": "Candidature e indennità di disoccupazione nelle stagioni intermedie (soluzione speciale del progetto pilota della SECO)"
                }
            },
            "faqsEmployers": {
                "cooperations": {
                    "1a": "Non appena su jobs2share viene registrato, per una collaboratrice o un collaboratore, un pacchetto di impiego estate/inverno vengono messi a disposizione i dati di contatto dei due datori di lavoro coinvolti rispettivamente dei relativi interlocutori. Dopodiché potrete mettervi, in tutta semplicità, in contatto con l’altra impresa e pianificare insieme, ad esempio, le opportunità di crescita di una collaboratrice o di un collaboratore oltre la singola stagione.",
                    "1q": "Come funziona la collaborazione con altri datori di lavoro?",
                    "2a": "Per fare in modo che i pacchetti di impiego dei dipendenti dell’impresa in questione vengano registrati sulla piattaforma generando, così, automaticamente dei contratti di collaborazione. In questo modo viene inoltre garantito un certo controllo (principio del doppio controllo): il dipendente indica l’impresa presso la quale lavora e il datore di lavoro conferma tale informazione.",
                    "2q": "Perché un’impresa partecipante deve confermare l’assunzione di una collaboratrice / un collaboratore?",
                    "3a": "Un contratto di collaborazione viene generato quando due impieghi stagionali vengono assemblati per offrire al dipendente prospettive lavorative sull’intero arco dell’anno. Il contratto di collaborazione contiene i dati di contatto di entrambi i datori di lavoro nonché quelli del dipendente, la durata d’assunzione e la mansione del dipendente. \nIl contratto di collaborazione rappresenta il legame lavorativo tra i due datori di lavoro e il dipendente, creando così trasparenza tra le parti coinvolte.<br>Ciò consente ai datori di lavoro di offrire un valore aggiunto al proprio dipendente comune oltre la singola stagione. In tal senso, i datori di lavoro pianificano insieme i passi successivi per la carriera e lo sviluppo professionale del dipendente. Inoltre offrono corsi di perfezionamento professionale ai propri impiegati, concordando la data d’ingresso e quella di uscita.<br>Nel quadro di un progetto pilota autorizzato dalla Segreteria di Stato dell’economia (SECO), a partire dal 1° gennaio 2019 presentando il contratto di collaborazione le lavoratrici e i lavoratori residenti nei Grigioni e in Ticino usufruiscono in modo agevolato, durante le stagioni intermedie, di prestazioni concesse dalla Cassa di disoccupazione, senza l’obbligo di comprovare nei confronti dell’Ufficio regionale di collocamento (URC) competente il proprio impegno nella ricerca di un impiego.",
                    "3q": "Cos’è un contratto di collaborazione?",
                    "label": "Collaborazioni"
                },
                "deleteAccount": {
                    "1a": "L’eliminazione dell’account cliente può essere richiesta attraverso {0}",
                    "1alink": "il modulo di contatto.",
                    "1q": "Cosa devo fare per eliminare definitivamente il mio account cliente?",
                    "label": "Eliminazione dell’account cliente"
                },
                "jobAdvertisements": {
                    "1a": "Dopo aver effettuato il login come datore di lavoro, sotto la relativa impresa alla voce «Annunci di lavoro» potete inserire nuovi annunci o aggiornare i contenuti / la data di annunci di lavoro pubblicati o disattivati. Grazie alla tariffa flat potete inserire un numero illimitato di annunci di lavoro. Se è stato trovato un lavoratore o una lavoratrice per l’impiego vacante in questione, il relativo annuncio può essere eliminato o disattivato temporaneamente.",
                    "1q": "Cosa devo fare per pubblicare un annuncio di lavoro?",
                    "2a": "L’inserimento di annunci di lavoro su jobs2share è compreso nella tariffa flat e non maturano costi supplementari. Si può pubblicare un numero illimitato di annunci di lavoro.",
                    "2q": "Quanto costa la pubblicazione di un annuncio di lavoro sulla piattaforma jobs2share?",
                    "3a": "La documentazione di candidatura può essere consultata nel relativo account cliente per un periodo di 18 mesi dalla ricezione della stessa. Se desiderate conservare più a lungo la documentazione, durante il suddetto lasso di tempo di 18 mesi potete esportarla comodamente come file in formato PDF e salvarla localmente.",
                    "3q": "La documentazione di candidatura rimane per quanto tempo sulla piattaforma?",
                    "4a": "Sì, in massima semplicità. Sotto «Candidature» sono riportati tutti i dossier di candidatura che possono essere esportati come file in formato PDF.",
                    "4q": "Posso scaricare la documentazione di candidatura?",
                    "5a": "Comunicate il problema utilizzando il pulsante {0}",
                    "5alink": "«Modulo di contatto».",
                    "5q": "Avete rifiutato erroneamente una candidatura?",
                    "6a": "Comunicate il problema utilizzando il pulsante {0}",
                    "6alink": "«Modulo di contatto».",
                    "6q": "Avete accettato erroneamente una candidatura?",
                    "label": "Bandi di candidatura per impieghi vacanti e relative candidature"
                },
                "label": "Domande frequenti",
                "notifications": {
                    "1a": "Le notizie più importanti vengono recapitate per e-mail. Dopo aver effettuato il login sulla piattaforma potete leggere in qualsiasi momento tutte le notizie più recenti sulla vostra pagina riepilogativa (dashboard).",
                    "1q": "Come vengo avvisato dell’esistenza di una novità sulla piattaforma?",
                    "label": "Avvisi"
                },
                "paymentTerms": {
                    "1a": "La tassa annuale viene calcolata in funzione delle dimensioni dell’impresa. {action} Il pagamento va effettuato mensilmente tramite carta di credito. Le ricevute vengono messe a disposizione all’interno dell’account cliente.",
                    "1alink": "I prezzi sono riportati qui.",
                    "1q": "Quanto costa l’utilizzo della piattaforma jobs2share? Come funziona la tariffa flat?",
                    "2a": "<p>La tassa mensile per l’utilizzo della piattaforma viene calcolata in funzione delle dimensioni dell’impresa in questione sulla base del numero di dipendenti assunti durante l’alta stagione (indipendentemente dal carico di lavoro o dalla quota di impiegati stagionali). Scegliendo la categoria di abbonamento «Grande» si possono gestire imprese aggiuntive all’interno dello stesso account cliente al prezzo ridotto di CHF 24.90 al mese per ogni impresa aggiuntiva (al posto del prezzo normale a partire da CHF 49.90).</p><ul><li>Abbonamento per impresa «Micro»: fino a 10 Persone</li><li>Abbonamento per impresa «Piccola»: 11-30 Persone</li><li>Abbonamento per impresa «Media»: 31-80 Persone</li><li>Abbonamento per impresa «Grande»: a partire da 81 Persone</li></ul>",
                    "2q": "In quale categoria di abbonamento rientra la mia impresa?",
                    "3a": "È determinante il numero di dipendenti assunti durante l’alta stagione, indipendentemente dal carico di lavoro degli impiegati o dalla quota di personale stagionale.",
                    "3q": "Come viene calcolata la grandezza dell’impresa?",
                    "4a": "No, non è possibile. Avrete a disposizione una tariffa flat annuale a condizioni particolarmente vantaggiose per poter non solo reclutare personale stagionale e pubblicare un numero illimitato di annunci di lavoro ma anche per offrire ai vostri dipendenti prospettive lavorative oltre la singola stagione. La collaborazione con altre imprese funziona solo se utilizzate la piattaforma durante l’intero arco dell’anno.",
                    "4q": "Posso sottoscrivere un abbonamento mensile?",
                    "5a": "Potete disdire il vostro abbonamento ed eventuali abbonamenti supplementari direttamente nel vostro account cliente, con cessazione al termine del periodo stipulato (1 anno), durante l’ultimo mese del periodo d’abbonamento. Riceverete puntualmente una mail di promemoria. L’abbonamento annuale si rinnova automaticamente, salvo relativa disdetta nel mese prima della scadenza dello stesso. Anche se disdite il vostro abbonamento, il vostro account cliente permane sulla piattaforma e può essere riutilizzato dopo aver acquistato un nuovo abbonamento.",
                    "5q": "Quando e come posso disdire il mio abbonamento?",
                    "6a": "Al vostro account cliente potete aggiungere ulteriori imprese per poterle gestire direttamente all’interno del vostro account cliente. In nome di questa impresa aggiuntiva potete così pubblicare sulla piattaforma offerte di impieghi stagionali e utilizzare tutte le altre funzioni. Per aggiungere un ulteriore abbonamento al vostro account cliente dovete dapprima creare un profilo dell’impresa. Dopodiché potete sottoscrivere un abbonamento anche per questa impresa aggiuntiva e aggiungerlo al vostro account. Se disponete già di un abbonamento della categoria «Grande», un’impresa aggiunta sotto lo stesso account cliente costa supplementarmente CHF 24.90 al mese per ogni impresa aggiuntiva al posto del normale prezzo {action} (a partire da CHF 49.90).",
                    "6alink": "dell’abbonamento",
                    "6q": "Come posso gestire più imprese attraverso lo stesso account cliente?",
                    "label": "Modalità di pagamento e abbonamenti"
                }
            },
            "findStaff": {
                "label": "Trova collaboratori"
            },
            "furtherEducation": {
                "gastronomyCoursesGrisons": {
                    "label": "Corsi di gastronomia nei Grigioni",
                    "text": "Diversi corsi di gastronomia della durata di uno o più giorni vengono offerti per ampliare le proprie conoscenze specialistiche. Ulteriori informazioni sono reperibili <a href=\"https://www.gastrograubuenden.ch/aus-weiterbildung/alle-kurse\" target=\"_blank\">qui.</a>"
                },
                "gastronomyCoursesTicino": {
                    "label": "Corsi di gastronomia in Ticino",
                    "text": "Diversi corsi di gastronomia della durata di un giorno vengono offerti per ampliare le proprie conoscenze specialistiche. Ulteriori informazioni sono reperibili <a href=\"http://www.gastroformazione.ch\" target=\"_blank\">qui.</a>"
                },
                "intro": "Attraverso un perfezionamento professionale date una nuova spinta alla vostra carriera, imparando cose nuove e utili nonché sviluppando il vostro potenziale. Su Jobs2share, le imprese vogliono valorizzare e incentivare il proprio personale. Al momento vengono offerti i seguenti corsi di perfezionamento professionale:",
                "label": "Formazione continua",
                "languageCourses": {
                    "label": "Corsi di lingua",
                    "text1": "Hotel & Gastro formazione Svizzera propone un corso di lingue fide specifico per gastronomia / settore alberghiero destinato ad aziende dei Cantoni Ticino e Grigioni. I corsi sono offerti ai livelli A1, A2 e B1 e si svolgeranno da giugno a ottobre 2021 e da novembre a dicembre 2021 a Lugano o Losone. I corsi vengono finanziati attraverso il Contratto collettivo nazionale di lavoro (CCNL). Fino al 31.12.2021 i corsi sono completamente <a href=\"https://formazione-inclusa.ch/\" target=\"_blank\">gratuiti</a>. Inoltre, saranno coperti i costi del materiale didattico, i pasti, l'eventuale pernottamento dei partecipanti al corso e una generosa quota di sostituzione del salario. Dati e informazioni dettagliate trovate <a href=\"/static/documents/fide/Fide_Sprachkurs_Tessin_Jobs2share_2021_IT.pdf\" target=\"_blank\">qui</a>.<br>\nDiversi datori di lavori iscritti su Jobs2share offrono corsi di lingua che vengono tenuti nella propria struttura oppure on-line. Rivolgetevi a tale riguardo direttamente al vostro datore di lavoro."
                },
                "progressoCourses": {
                    "label": "Corsi Progresso (settore alberghiero / della ristorazione)",
                    "text": "Anche quest’anno, durante la stagione intermedia, Hotel & Gastro formazione Svizzera offre un corso di formazione Progresso a Coira (GR) e a Losone (TI). Il corso di formazione Progresso è proposto per i settori professionali Servizio, Cucina ed Economia domestica. I corsi di 5 settimane si svolgeranno in primavera e in autunno 2021. I corsi vengono finanziati attraverso il Contratto collettivo nazionale di lavoro (CCNL). Fino alla fine di agosto i corsi sono completamente <a href=\"https://formazione-inclusa.ch/\" target=\"_blank\">gratuiti</a>. Inoltre, saranno coperti i costi del materiale didattico, i pasti, l'eventuale pernottamento dei partecipanti al corso e una generosa quota di sostituzione del salario. Dati e informazioni dettagliate trovate <a href=\"/static/documents/progresso/Progresso_Jobs2share_AN_2021_IT.pdf\" target=\"_blank\">qui</a>.<br>\nHotel & Gastro formation offre corsi di cucina, servizio ed economia domestica Progresso per lavoratrici e lavoratori che iniziano a svolgere questa attività o che provengono da un’attività parallela. I corsi vengono finanziati attraverso il Contratto collettivo nazionale di lavoro (CCNL). Fino al 31.12.2021 i corsi sono completamente gratuiti. Inoltre, saranno coperti i costi del materiale didattico, i pasti, l'eventuale pernottamento dei partecipanti al corso e una generosa quota di sostituzione del salario. Le date e maggiori informazioni sono consultabili <a href=\"https://il-mio-progresso.ch/\" target=\"_blank\">qui.</a>"
                }
            },
            "howItWorksEmployee": {
                "label": "Come funziona",
                "text1": "Combinare impieghi stagionali a proprio piacimento, ad esempio in base allo slogan «Montagne e lago, lavoro e svago». Oppure: in estate in città, in inverno in montagna? In inverno in un rifugio alpino, in estate in un hotel a 5 stelle? In estate barista, in inverno maestro di sci?",
                "text2": "Con jobs2share è semplicissimo. La ricerca di un impiego da sogno è solo il primo passo. Vi aiutiamo a combinare interessanti pacchetti di impiego estate/inverno, in base alle vostre specifiche esigenze. Su jobs2share avete accesso ad alcuni dei migliori datori di lavoro in Svizzera che vi offrono prospettive lavorative sull’intero arco dell’anno."
            },
            "howItWorksEmployer": {
                "fillOpenJobs": {
                    "label": "State cercando una lavoratrice / un lavoratore per un posto vacante?",
                    "text1": "Annunci di lavoro<br>Inserite quante offerte di impieghi stagionali volete – grazie alla nostra tariffa flat, il singolo annuncio non vi costa nulla.",
                    "text2": "Gestione candidature<br>Ricevete e gestite le candidature direttamente su jobs2share.",
                    "text3": "Contratto di collaborazione<br>Se una lavoratrice o un lavoratore alla ricerca di un impiego trova due impieghi stagionali (pacchetto di impiego estate/inverno) presso due datori di lavoro registrati sulla piattaforma, e se questo pacchetto viene confermato on-line da voi e dal secondo datore di lavoro, ciò viene indicato nel profilo jobs2share della lavoratrice o del lavoratore, e viene generato automaticamente un contratto di collaborazione con i due datori di lavoro in questione.",
                    "text4": "Pianificazione della carriera<br>Ora potete mettervi in contatto con l’impresa partner e, insieme, potete pianificare individualmente la carriera della vostra collaboratrice o del vostro collaboratore.",
                    "text5": "Riacquisizione personale specializzato<br>jobs2share vi aiuta a riacquisire il personale per la stagione successiva."
                },
                "label": "Come funziona",
                "offerPerspective": {
                    "label": "Desiderate offrire interessanti prospettive professionali alle vostre collaboratrici e ai vostri collaboratori stagionali?",
                    "text1": "Facilitate alle vostre collaboratrici e ai vostri collaboratori, grazie a jobs2share, la ricerca di un impiego stagionale integrativo presso un datore di lavoro che offra prospettive allettanti. Per il vostro personale, l’utilizzo della piattaforma jobs2share è gratuita.",
                    "text2": "Usufruendo del servizio jobs2share offrite alle vostre collaboratrici e ai vostri collaboratori interessanti prospettive lavorative sull’intero arco dell’anno e la possibilità di beneficiare di numerosi vantaggi supplementari. In tal modo aumentate, inoltre, le probabilità che le vostre collaboratrici e i vostri collaboratori ritornino anche nella stessa stagione nell’anno successivo."
                }
            },
            "impress": {
                "contact": "Contatti",
                "contactDetails": "Verein Mitarbeiter-Sharing<br>presso la Fachhochschule Graubünden<br>Comercialstrasse 22<br>7000 Chur",
                "emailAddress": "info@jobs2share.ch",
                "implementation": {
                    "label": "Realizzazione"
                },
                "label": "Informazione legale",
                "offer": "Jobs2share.ch è un'offerta del Verein Mitarbeiter-Sharing",
                "responsible": "Responsabile",
                "responsiblePerson": "Katrin Schillo"
            },
            "jobAdvertisement": {
                "label": "Inserisci impiego"
            },
            "jobFind": {
                "label": "Trova impiego"
            },
            "jobStatus": [],
            "jobs": {
                "label": "Jobs"
            },
            "jobs2share": {
                "label": "jobs2share"
            },
            "media": {
                "downloadMediaKit": "Download ZIP (70 MB)",
                "downloadPressRelease": "Download «Comunicato per i media»",
                "label": "Media",
                "mediaKit": "«Kit per i media»",
                "mediaReports": "Ecco cosa i media scrivono di noi",
                "mediaReportsList": "<ul>\n  <li><a href=\"https://8094bd36e89df1af34bd54d1c93ce32f.ds11s3ns.swisscom.com/jobs2share/static/it/media-reports/HGZ_05_18.pdf\" target=\"_blank\">HGZ - Maggio 2018</a></li>\n  <li><a href=\"https://www.rsi.ch/play/tv/popupvideoplayer?id=10400849&startTime=11.231\" target=\"_blank\">RSI - Aprile 2018</a></li>\n  <li><a href=\"https://www.rts.ch/play/tv/19h30/video/une-plateforme-online-met-en-reseau-des-etablissements-touristiques?id=8373604&station=a9e7621504c6959e35c3ecbe7f6bed0446cdf8da\" target=\"_blank\">RTS - Febbraio 2017</a></li>\n  <li><a href=\"https://8094bd36e89df1af34bd54d1c93ce32f.ds11s3ns.swisscom.com/jobs2share/static/it/media-reports/RSO_1_01_17.MP3\" target=\"_blank\">RSO 1 -\tGennaio 2017</a></li>\n  <li><a href=\"https://8094bd36e89df1af34bd54d1c93ce32f.ds11s3ns.swisscom.com/jobs2share/static/it/media-reports/RSO_2_01_17.MP3\" target=\"_blank\">RSO 2 - Gennaio 2017</a></li>\n  <li><a href=\"https://www.srf.ch/play/tv/popupvideoplayer?id=4f6da375-554b-4a54-a247-d5ef3ee8b8ab\" target=\"_blank\">10vor10 - Gennaio 2017</a></li>\n  <li><a href=\"https://www.rsi.ch/la1/programmi/informazione/tempi-moderni/in-prima/L%E2%80%99unione-fa-la-forza-8276689.html\" target=\"_blank\">RSI - Novembre 2016</a></li>\n  <li><a href=\"https://www.tio.ch/ticino/attualita/1053382/-io--stagionale-degli-alberghi--ora-ho-una-possibilita-in-piu-\" target=\"_blank\">20minuti - Ottobre 2015</a></li>\n  <li><a href=\"https://www.srf.ch/sendungen/10vor10/todesfalle-mekka-mitarbeiter-sharing-des-dichters-tochter\" target=\"_blank\">10vor10 - Settembre 2015</a></li>\n  <li><a href=\"https://www.rsi.ch/la1/programmi/informazione/il-quotidiano/Il-Quotidiano-6032758.html\" target=\"_blank\">RSI - Settembre 2015</a></li>\n</ul>",
                "mediaRepresentative": "Siete degli operatori mediatici?",
                "pressRelease": "Comunicati per i media",
                "pressReleaseDe": "Communicati per i media tedesco",
                "pressReleaseIt": "Communicati per i media italiano"
            },
            "newsletter": {
                "label": "Newsletter",
                "text": "Desiderate maggiori informazioni? Abbonatevi qui alla nostra Newsletter per rimanere aggiornati."
            },
            "offerEmployers": {
                "label": "Offerta",
                "sizes": {
                    "employeesPeakSeason": "numero di collaboratrici/collaboratori (assunti, non equivalenti a tempo pieno) in alta stagione",
                    "large": "Grande",
                    "largeSubtitle": "a partire da 81 persone*",
                    "largeText": "<ul><li>Pubblicazione di un numero illimitato di annunci di lavoro per tutto l'anno</li><li>Gestione semplice e professionale di candidature ricevute</li><li>Collaborazione con altre imprese nel campo delle risorse umane</li><li>Prospettive lavorative sull’intero arco dell’anno per il vostro personale stagionale</li><li>Assistenza tramite e-mail</li><li>Profilo individuale per rafforzare il vostro marchio come datore di lavoro</li><li>Gestione di ulteriori aziende attraverso lo stesso account cliente al prezzo </li><li>speciale di CHF 24.90 al mese per ogni impresa aggiuntiva</li></ul>",
                    "medium": "Media",
                    "mediumSubtitle": "31-80 persone*",
                    "micro": "Micro",
                    "microSubtitle": "fino a 10 persone*",
                    "priceText": "CHF al mese",
                    "small": "Piccola",
                    "smallSubtitle": "11-30 persone*",
                    "text": "<ul><li>Pubblicazione di un numero illimitato di annunci di lavoro per tutto l'anno</li><li>Gestione semplice e professionale di candidature ricevute</li><li>Collaborazione con altre imprese nel campo delle risorse umane</li><li>Prospettive lavorative sull’intero arco dell’anno per il vostro personale stagionale</li><li>Gestione di più imprese attraverso un unico account cliente (possibile solo in combinazione con la categoria «Grande»)</li><li>Assistenza tramite e-mail</li><li>Profilo individuale per rafforzare il vostro marchio come datore di lavoro</li><li>Opzione: gestione di più </li></ul>"
                },
                "text": "Già con un costo mensile a partire da CHF 49.90 potete inserire un numero illimitato di offerte di lavoro e collaborare con altre imprese del settore per offrire, insieme, interessanti prospettive lavorative sull’intero arco dell’anno a lavoratrici e lavoratori in cerca di impiego. La piattaforma jobs2share viene utilizzata dai migliori datori di lavoro operanti nel settore alberghiero, della ristorazione, degli impianti di risalita, delle scuole di sci e da altre imprese che sono soggette a fluttuazioni stagionali.",
                "whatSize": "Quanto è grande la vostra impresa?"
            },
            "partner": {
                "label": "Partner",
                "ourMembers": "I nostri membri",
                "ourPartners": "I nostri partner"
            },
            "privacyPolicy": {
                "label": "Protezione dei dati"
            },
            "rulesOfTheGame": {
                "cooperation": {
                    "label": "Collaborazione, fair play e nessuna «sottrazione» di personale",
                    "text": "<p>Per raggiungere tutti questi obiettivi, gli utenti si impegnano ad adottare sempre un comportamento corretto e leale tra di loro, contribuendo a instaurare una collaborazione di lunga durata e vantaggiosa per tutte le parti interessate.</p><p>Fair play significa contribuire a creare un’atmosfera positiva all’interno della piattaforma jobs2share, adottando un comportamento corretto e leale in riferimento allo sharing di dipendenti. Ogni singolo utente dà l’esempio attraverso il proprio comportamento sulla piattaforma. Ciò significa, ad esempio, che gli utenti si impegnano a non «sottrarre» intenzionalmente lavoratrici o lavoratori ad altre imprese per offrire loro un impiego annuale, sebbene sia previsto un ritorno a un’impresa registrata sulla piattaforma (membro, utente) nella stagione successiva. Al tempo stesso, gli utenti accettano che le lavoratrici e i lavoratori sfruttino le opportunità che si presentano loro per crescere personalmente e professionalmente, concedendo loro questa libertà. Ove possibile, le imprese si accordano relativamente alle date di passaggio di collaboratrici e collaboratori da un’impresa all’altra.</p><p>Inoltre, gli utenti della piattaforma jobs2share registrati come datori di lavoro si impegnano nei confronti degli utenti registrati come lavoratrici e lavoratori ad attenersi alle vigenti disposizioni e leggi per quanto riguarda il Contratto collettivo di lavoro (CCL). </p>"
                },
                "label": "«Fair Play»",
                "mission": {
                    "label": "Obiettivi",
                    "text": "L’obiettivo primario perseguito dall’Associazione Mitarbeiter-Sharing è quello di introdurre un nuovo modello di lavoro, ovvero lo sharing dei dipendenti. L’idea di fondo è quella di combinare impieghi stagionali estivi e impieghi stagionali invernali, offrendo in tal senso prospettive lavorative sull’intero arco dell’anno. In questo modo nonché attraverso l’incentivazione del personale, ad esempio per mezzo di specifiche offerte di corsi di perfezionamento professionale si mira ad aumentare l’attrattività di impieghi stagionali per lavoratrici e lavoratori, soddisfacendo la loro esigenza di svolgere un’attività lavorativa variegata in combinazione con interessanti prospettive lavorative."
                },
                "purposeAndScope": {
                    "label": "Scopo e ambito d’applicazione",
                    "text": "Gli utenti della piattaforma jobs2share si impegnano ad assumere un comportamento corretto e leale tra di loro ai sensi di una collaborazione proficua fra tutte le parti coinvolte."
                }
            },
            "secoEmployee": {
                "conditions": {
                    "label": "Condizioni principali:",
                    "list": "<ul><li>Risiedete in Ticino o nei Grigioni.</li><li>Per poter approfittare della soluzione speciale dell’assicurazione contro la disoccupazione, in veste di lavoratrici/lavoratori dovete iscrivervi, insieme ai vostri datori di lavoro, sulla piattaforma <a href=\"/\">www.jobs2share.ch</a> e inserire nel vostro profilo impieghi attuali e futuri. Se trovate degli impieghi idonei direttamente su <a href=\"/\">www.jobs2share.ch</a>, questi vengono inseriti automaticamente nel vostro profilo.</li><li>Siete liberi di combinare impieghi stagionali idonei formando un pacchetto di impiego estate/inverno. Ricercate su <a href=\"/\">www.jobs2share.ch</a> impieghi interessanti e candidatevi direttamente on-line.</li><li>Se quindi accettate e inserite due impieghi stagionali nel corso dello stesso anno (pacchetto di impiego estate/inverno), su <a href=\"/\">www.jobs2share.ch</a> viene generato un «contratto di collaborazione» che può essere scaricato. </li><li>Se inviate tale conferma all’Ufficio regionale di collocamento (URC) competente, durante la stagione intermedia in questione (massimo 6 settimane all'anno) siete del tutto esentati dall’obbligo di comprovare il vostro impegno nella ricerca di un impiego.</li></ul>",
                    "listlink": "www.jobs2share.ch"
                },
                "label": "Indennità di disoccupazione durante le stagioni intermedie – Progetto pilota autorizzato della SECO",
                "moreInformation": "Ulteriori informazioni sono reperibili <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-it-20190701.pdf\" target=\"_blank\">qui.</a>",
                "text": "<p>I dipendenti stagionali che lavorano nell’ambito del modello «Mitarbeiter-Sharing» possono ora colmare stagioni intermedie in maniera semplice e snella percependo un’indennità di disoccupazione – in base allo slogan «Montagne e lago, lavoro e svago».</p><p>Nel quadro del progetto pilota autorizzato dalla Segreteria di Stato dell’economia (SECO) sussiste la possibilità di usufruire in modo agevolato, per un periodo massimo di sei settimane all’anno, di prestazioni concesse dalla Cassa di disoccupazione, senza l’obbligo di comprovare l’impegno nella ricerca di un impiego. Di questa interessante soluzione possono approfittare, a partire dal 1° gennaio 2019, le lavoratrici e i lavoratori residenti in Ticino e nei Grigioni.\n</p>"
            },
            "secoEmployer": {
                "label": "Progetto pilota autorizzato dalla SECO",
                "moreInformation": "Ulteriori informazioni sono reperibili <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-it-20190701.pdf\" target=\"_blank\">qui.</a>",
                "moreInformationEmployee": "Ulteriori informazioni per vostro personale sono reperibili <a href=\"/static/documents/seco-pilot/jobs2share-ma-factsheet-seco-pilot-it-20190701.pdf\" target=\"_blank\">qui.</a>",
                "moreInformationEmployer": "Ulteriori informazioni per datori di lavoro sono reperibili <a href=\"/static/documents/seco-pilot/jobs2share-ag-factsheet-seco-pilot-it-20190701.pdf\" target=\"_blank\">qui.</a>",
                "text1": "Grazie a un nuovo progetto pilota autorizzato dalla Segreteria di Stato dell’economia (SECO), iscrivendovi sul sito {0} potete offrire alle vostre collaboratrici e ai vostri collaboratori residenti in Ticino e nei Grigioni un plusvalore durante le stagioni intermedie, «legandoli» così a voi in maniera vantaggiosa per entrambi.",
                "text1link": "www.jobs2share.ch",
                "text2": "Nell’ambito del progetto pilota autorizzato dalla SECO, le lavoratrici e i lavoratori stagionali con due impieghi stagionali (estate/inverno) hanno la possibilità di usufruire in modo agevolato, per un periodo massimo di sei settimane all’anno, di prestazioni concesse dalla Cassa di disoccupazione, senza l’obbligo di comprovare il loro impegno nella ricerca di un impiego (soluzione speciale dell’assicurazione contro la disoccupazione). Ciò consente loro di colmare in maniera snella ed efficace eventuali periodi senza guadagno durante le stagioni intermedie.",
                "text3": "Di questa interessante soluzione possono approfittare, per ora per tre anni a partire dal 1° gennaio 2019, le lavoratrici e i lavoratori residenti in Ticino e nei Grigioni. Nel caso in cui il progetto pilota dovesse riscuotere successo, questa regolamentazione potrebbe essere estesa, addirittura con conseguente modifica della legge in questione. In tal senso, la vostra partecipazione e iscrizione su {0} sono quanto mai preziose.",
                "text3link": "www.jobs2share.ch",
                "text4": "Se una lavoratrice o un lavoratore alla ricerca di un impiego trova su {action} un pacchetto di impiego estate/inverno e se questo pacchetto è stato confermato on-line da voi e dal secondo datore di lavoro, ciò viene indicato nel profilo della lavoratrice o del lavoratore, e viene generato automaticamente un contratto di collaborazione con i due datori di lavoro.{linebreak}{linebreak} La lavoratrice o il lavoratore deve unicamente scaricare il contratto di collaborazione e inviarlo tempestivamente (possibilmente tre mesi prima) all’Ufficio regionale di collocamento (URC) competente insieme ai due contratti di lavoro per poter usufruire della soluzione speciale dell’assicurazione contro la disoccupazione.",
                "text4link": "www.jobs2share.ch"
            },
            "show": "Visualizzare",
            "sponsorship": {
                "label": "Organo promotore",
                "text": "jobs2share è una piattaforma promossa dall’associazione indipendente e senza scopo di lucro Mitarbeiter-Sharing, il cui operato è incentrato sulle esigenze dei propri membri e utenti, rappresentati da un lato dalle lavoratrici e dai lavoratori che desiderano dedicarsi a un’attività lavorativa variegata, dall’altro dalle imprese che offrono impieghi stagionali. L’associazione è stata fondata nel 2016 dalla scuola universitaria Fachhochschule Graubünden (precedentemente Hochschule für Technik und Wirtschaft HTW Chur) insieme a oltre 20 imprese affiliate. La maggior parte degli oltre 50 stabilimenti d’impresa delle aziende affiliate si trova nei Grigioni e in Ticino."
            },
            "tac": {
                "label": "Termini e condizioni"
            }
        },
        "validation": {
            "accepted": "{attribute} deve essere accettato.",
            "active_url": "{attribute} non è un URL valido.",
            "after": "{attribute} deve essere una data successiva al {date}.",
            "after_or_equal": "{attribute} deve essere una data successiva o uguale al {date}.",
            "alpha": "{attribute} può contenere solo lettere.",
            "alpha_dash": "{attribute} può contenere solo lettere, numeri e trattini.",
            "alpha_num": "{attribute} può contenere solo lettere e numeri.",
            "array": "{attribute} deve essere un array.",
            "before": "{attribute} deve essere una data precedente al {date}.",
            "before_or_equal": "{attribute} deve essere una data precedente o uguale al {date}.",
            "between": {
                "numeric": "{attribute} deve trovarsi tra {min} - {max}.",
                "file": "{attribute} deve trovarsi tra {min} - {max} kilobytes.",
                "string": "{attribute} deve trovarsi tra {min} - {max} caratteri.",
                "array": "{attribute} deve avere tra {min} - {max} elementi."
            },
            "boolean": "Il campo {attribute} deve essere vero o falso.",
            "confirmed": "Il campo di conferma per {attribute} non coincide.",
            "date": "{attribute} non è una data valida.",
            "date_format": "{attribute} non coincide con il formato {format}.",
            "different": "{attribute} e {other} devono essere differenti.",
            "digits": "{attribute} deve essere di {digits} cifre.",
            "digits_between": "{attribute} deve essere tra {min} e {max} cifre.",
            "dimensions": "Le dimensioni dell'immagine di {attribute} non sono valide.",
            "distinct": "{attribute} contiene un valore duplicato.",
            "email": "{attribute} non è valido.",
            "ends_with": "Il campo {attribute} deve terminare con uno dei seguenti valori: {values}",
            "exists": "{attribute} selezionato non è valido.",
            "file": "{attribute} deve essere un file.",
            "filled": "Il campo {attribute} deve contenere un valore.",
            "image": "{attribute} deve essere un'immagine.",
            "in": "{attribute} selezionato non è valido.",
            "in_array": "Il valore del campo {attribute} non esiste in {other}.",
            "integer": "{attribute} deve essere un numero intero.",
            "ip": "{attribute} deve essere un indirizzo IP valido.",
            "ipv4": "{attribute} deve essere un indirizzo IPv4 valido.",
            "ipv6": "{attribute} deve essere un indirizzo IPv6 valido.",
            "json": "{attribute} deve essere una stringa JSON valida.",
            "max": {
                "numeric": "{attribute} non può essere superiore a {max}.",
                "file": "{attribute} non può essere superiore a {max} kilobytes.",
                "string": "{attribute} non può contenere più di {max} caratteri.",
                "array": "{attribute} non può avere più di {max} elementi."
            },
            "mimes": "{attribute} deve essere del tipo: {values}.",
            "mimetypes": "{attribute} deve essere del tipo: {values}.",
            "min": {
                "numeric": "{attribute} deve essere almeno {min}.",
                "file": "{attribute} deve essere almeno di {min} kilobytes.",
                "string": "{attribute} deve contenere almeno {min} caratteri.",
                "array": "{attribute} deve avere almeno {min} elementi."
            },
            "not_in": "Il valore selezionato per {attribute} non è valido.",
            "numeric": "{attribute} deve essere un numero.",
            "phone": "Il campo {attributo} contiene un numero non valido.",
            "present": "Il campo {attribute} deve essere presente.",
            "regex": "Il formato del campo {attribute} non è valido.",
            "required": "Il campo {attribute} è richiesto.",
            "required_if": "Il campo {attribute} è richiesto quando {other} è {value}.",
            "required_unless": "Il campo {attribute} è richiesto a meno che {other} sia in {values}.",
            "required_with": "Il campo {attribute} è richiesto quando {values} è presente.",
            "required_with_all": "Il campo {attribute} è richiesto quando {values} è presente.",
            "required_without": "Il campo {attribute} è richiesto quando {values} non è presente.",
            "required_without_all": "Il campo {attribute} è richiesto quando nessuno di {values} è presente.",
            "same": "{attribute} e {other} devono coincidere.",
            "size": {
                "numeric": "{attribute} deve essere {size}.",
                "file": "{attribute} deve essere {size} kilobytes.",
                "string": "{attribute} deve contenere {size} caratteri.",
                "array": "{attribute} deve contenere {size} elementi."
            },
            "string": "{attribute} deve essere una stringa.",
            "timezone": "{attribute} deve essere una zona valida.",
            "unique": "{attribute} è stato già utilizzato.",
            "uploaded": "{attribute} non è stato caricato.",
            "url": "Il formato del campo {attribute} non è valido.",
            "password_strength": "La password non è abbastanza forte. Utilizzare almeno: 1 lettera maiuscola, 1 lettera minuscola, 1 numero e 1 carattere speciale (es. , . _ & ? etc).",
            "password": "La password non è corretta.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "nome",
                "username": "nome utente",
                "first_name": "nome",
                "last_name": "cognome",
                "password_confirmation": "conferma password",
                "city": "città",
                "country": "paese",
                "address": "indirizzo",
                "phone": "telefono",
                "mobile": "cellulare",
                "age": "età",
                "sex": "sesso",
                "gender": "genere",
                "day": "giorno",
                "month": "mese",
                "year": "anno",
                "hour": "ora",
                "minute": "minuto",
                "second": "secondo",
                "title": "titolo",
                "content": "contenuto",
                "description": "descrizione",
                "excerpt": "estratto",
                "date": "data",
                "time": "ora",
                "available": "disponibile",
                "size": "dimensione"
            }
        },
        "texts": {
            "DataPermanentlyLost": "I suoi dati andranno persi per sempre",
            "abort": "Interrompere",
            "about": "Chi siamo",
            "acceptAGB": "Ho letto le condizioni di jobs2share e le accetto.",
            "acceptAGBandPrivacyPolicy": "Ho letto e accettato le <a href=\"/it/terms-and-conditions\" target=\"_blank\">condizioni generali  e le disposizioni in materia di protezione dei dati</a>",
            "acceptAdvertising": "Desidero ricevere le newsletter da parte di jobs2share",
            "acceptPrivacyPolicy": "Ho letto la dichiarazione per la protezione dati di jobs2share e l'accetto.",
            "acceptRules": "Ho letto la dichiarazione per la <a href=\"/it/employer/rules-of-the-game\" target=\"_blank\">«Fair Play»</a>",
            "actionCannotBeUndone": "Questa azione non può essere annullata",
            "actions": "Azioni",
            "active": "Attivo",
            "activeApplicationsTablePlaceholder": "Qui le applicazioni appariranno nelle tue inserzioni",
            "add": "Aggiungere",
            "addAddon": "Aggiungi ulteriore abbonamento",
            "addCertificate": "Aggiungere altro",
            "addCompany": "Aggiungere azienda",
            "addDocuments": "Aggiunga credenziali, certificati, premi o altri documenti",
            "addEducation": "Aggiungere formazione",
            "addExperience": "Aggiungere esperienza di lavoro",
            "addFavoriteSuccessful": "L'annuncio è stato aggiunto come favorito con successo",
            "addJob": "Inserire un annuncio di lavoro",
            "addLanguage": "Aggiungere lingua",
            "addNewFiles": "Aggiungere nuovo file",
            "addOtherDocument": "Aggiungi altro",
            "addSubscription": "Aggiungi abbonamento principale",
            "addedOn": "Aggiunto il",
            "additionalCompanies": "Ulteriori ditte",
            "additionalDocuments": "Allegati",
            "additionalTextSumbitApplication": "Una volta inviata, la candidatura non può più essere modificata",
            "addon": "Abbonamento aggiuntivo",
            "address": "Indirizzo",
            "administrateCompanies": "Gestisti le imprese",
            "administration": "Amministrazione",
            "alert": {
                "acceptEmployeeError": "Impiego non confermato",
                "acceptEmployeeSuccessful": "Impiego confermato con successo",
                "addAddonError": "L'abbonamento aggiuntivo non é stato inserito",
                "addAddonSuccessful": "L'abbonamento aggiuntivo é stato inserito",
                "addCompanyError": "Non è stato possibile aggiungere l’azienda",
                "addCompanySuccessful": "L’azienda è stata aggiunta",
                "addContactPersonError": "Non è stato possibile aggiungere la persona di contatto",
                "addContactPersonSuccessful": "La persona di contatto è stata aggiunta",
                "addFavoriteError": "L'annuncio non può venir impostato tra i favoriti",
                "addJobApplicationError": "Non è stato possibile salvare la candidatura",
                "addJobApplicationSuccessful": "La candidatura è stata salvata",
                "addJobError": "Non è stato possibile aggiungere l’annuncio di lavoro",
                "addJobSuccessful": "L’annuncio di lavoro è stato aggiunto",
                "addResumeCertificationsError": "Non è stato possibile aggiungere la voce",
                "addResumeCertificationsSuccessful": "La voce è stata aggiunta",
                "addResumeEducationsError": "Non è stato possibile aggiungere la formazione",
                "addResumeEducationsSuccessful": "La formazione è stata aggiunta",
                "addResumeJobsError": "Non è stato possibile aggiungere l’esperienza di lavoro",
                "addResumeJobsSuccessful": "L’esperienza di lavoro è stata aggiunta",
                "addResumeLanguagesError": "Non è stato possibile aggiungere la lingua",
                "addResumeLanguagesSuccessful": "La lingua è stata aggiunta",
                "addResumeOtherDocumentsError": "Non è stato possibile aggiungere la voce",
                "addResumeOtherDocumentsSuccessful": "La voce è stata aggiunta",
                "addSubscrptionError": "Non è stato possibile aggiungere l'abbonamento",
                "addSubscrptionSuccessful": "L'abbonamento é stato aggiunto con successo",
                "cancelSubscriptionError": "L'abbonamento non può essere annullato",
                "cancelSubscriptionSuccessful": "L'abbonamento è stato annullato con successo",
                "changeBillingCycleSuccessful": "Grazie, il vostro abbonamento su jobs2share è stato esteso. Il nuovo abbonamento termina il {0}.",
                "changeCreditCardError": "Carta di credito non aggiornabile",
                "changeCreditCardSuccessful": "Carta di credito aggiornata con successo",
                "couponCodeInvalid": "Numero buono non valido",
                "couponCodeValid": "Numero buono valido",
                "creditCardError": "La sua carta di credito non è stato accettata",
                "declineEmployeeError": "Stato dell'applicazione non aggiornato",
                "declineEmployeeSuccessful": "Stato dell'applicazione aggiornato",
                "declineRenewEmployeeError": "Rientro è stato rifiutato",
                "declineRenewEmployeeSuccessful": "Rientro non è stato rifiutato",
                "deleteAddonError": "Non è stato possibile cancellare l'abbonamento aggiuntivo",
                "deleteAddonSuccessful": "Abbonamento aggiuntivo cancellato",
                "deleteCompanyError": "Non è stato possibile cancellare la ditta",
                "deleteCompanySuccessful": "Ditta cancellata con successo",
                "deleteJobApplicationError": "Non è stato possibile eliminare la candidatura",
                "deleteJobApplicationSuccessful": "La candidatura è stata eliminata",
                "deleteJobError": "Non è stato possibile eliminare l’annuncio di lavoro",
                "deleteJobSuccessful": "L’annuncio di lavoro è stato eliminato",
                "deleteProfilePictureError": "Non è stato possibile eliminare l’immagine del profilo",
                "deleteProfilePictureSuccessful": "L’immagine del profilo è stata eliminata",
                "deleteResumeCertificationsError": "Non è stato possibile eliminare la voce",
                "deleteResumeCertificationsSuccessful": "La voce è stata eliminata",
                "deleteResumeEducationsError": "Non è stato possibile eliminare la formazione",
                "deleteResumeEducationsSuccessful": "La formazione è stata eliminata",
                "deleteResumeJobsError": "Non è stato possibile eliminare l’esperienza di lavoro",
                "deleteResumeJobsSuccessful": "L’esperienza di lavoro è stata eliminata",
                "deleteResumeLanguagesError": "Non è stato possibile eliminare la lingua",
                "deleteResumeLanguagesSuccessful": "La lingua è stata eliminata",
                "deleteResumeOtherDocumentsError": "Non è stato possibile eliminare la voce",
                "deleteResumeOtherDocumentsSuccessful": "La voce è stata eliminata",
                "deleteSubscriptionError": "Non si è potuto cancellare l'abbonamento",
                "deleteSubscriptionSuccessful": "Abbonamento cancellato con successo",
                "endOfWorkError": "Fine impiego deve essere successiva a inizio impiego",
                "formRequiredFieldsError": "La preghiamo di riempire tutti gli spazi in rosso",
                "jobContainsEmailError": "Gli annunci di lavoro non possono contenere indirizzi e-mail. Le candidature devono essere presentate tramite lo strumento di candidatura di jobs2share. I documenti dei candidati possono essere scaricati in formato PDF.",
                "registerNewsletterError": "Non è stato possibile registrare alla newsletter",
                "registerNewsletterSuccessful": "Registrazione alla newsletter con successo",
                "removeFavoriteError": "Non si è potuto togliere l'annuncio di lavoro dai favoriti",
                "renewEmployeeError": "Il rientro non è stato aggiunto",
                "renewEmployeeSuccessful": "Il rientro è stato aggiunto con successo",
                "reportErrorError": "Non è stato possibile inviare la sua richiesta",
                "reportErrorSuccessful": "La sua richiesta è stata inviata con successo",
                "sendContactError": "Non è stato possibile inviare la sua richiesta",
                "sendContactSuccessful": "La sua richiesta è stata inviata",
                "storeAdditionalCompanyError": "Non è stato possibile aggiungere un'altra azienda",
                "storeAdditionalCompanySuccessful": "Ulteriore azienda è stata aggiunta con successo",
                "storeSubscriptionCouponError": "Non è stato possibile aggiungere il codice del voucher",
                "storeSubscriptionCouponSuccessful": "Il codice del voucher è stato aggiunto con successo",
                "storeSubscriptionError": "Non è stato possibile aggiungere l'abbonamento",
                "storeSubscriptionSuccessful": "L'abbonamento è stato aggiunto con successo",
                "subscriptionRequired": {
                    "updateEmployee": "I rapporti di lavoro possono essere gestiti solo con un abbonamento valido"
                },
                "updateAddonError": "L'abbonamento aggiuntivo non ha potuto essere aggiornato",
                "updateAddonSuccessful": "L'abbonamento aggiuntivo è stato aggiornato con successo",
                "updateAllNotificationsError": "Non è stato possibile contrassegnare le notifiche come lette",
                "updateAllNotificationsSuccessful": "Le notifiche sono state aggiornate con successo",
                "updateCompanyProfileError": "Non è stato possibile aggiornare il profilo aziendale",
                "updateCompanyProfileSuccessful": "Il profilo aziendale è stato aggiornato",
                "updateContactPersonError": "Non è stato possibile modificare la persona di contatto",
                "updateContactPersonSuccessful": "La persona di contatto è stata modificata",
                "updateEntryError": "La voce non può essere aggiornata",
                "updateEntrySuccessful": "La voce è stata aggiornata con successo",
                "updateJobApplicationError": "Non è stato possibile aggiornare la candidatura",
                "updateJobApplicationStatusError": "Lo status della candidatura non ha potuto essere aggiornato",
                "updateJobApplicationStatusSuccessful": "Status della candidatura aggiornato con successo",
                "updateJobApplicationSuccessful": "La candidatura è stata aggiornata",
                "updateJobError": "Non è stato possibile modificare l’annuncio di lavoro",
                "updateJobSuccessful": "L’annuncio di lavoro è stato modificato",
                "updateLocationError": "Non è stato possibile modificare il luogo",
                "updateLocationSuccessful": "Il luogo è stato modificato",
                "updateProfilePictureError": "Non è stato possibile modificare l’immagine del profilo",
                "updateProfilePictureSuccessful": "L’immagine del profilo è stata modificata",
                "updateResumeCertificationsError": "Non è stato possibile aggiornare la voce",
                "updateResumeCertificationsSuccessful": "La voce è stata aggiornata",
                "updateResumeEducationsError": "Non è stato possibile aggiornare la formazione",
                "updateResumeEducationsSuccessful": "La formazione è stata aggiornata",
                "updateResumeJobsError": "Non è stato possibile aggiornare l’esperienza di lavoro",
                "updateResumeJobsSuccessful": "L’esperienza di lavoro è stata aggiornata",
                "updateResumeLanguagesError": "Non è stato possibile aggiornare la lingua",
                "updateResumeLanguagesSuccessful": "La lingua è stata aggiornata",
                "updateSubscriptionError": "L'abbonamento non ha potuto essere aggiornato",
                "updateSubscriptionSuccessful": "Abbonamento aggiornato con successo",
                "updateUserProfileError": "Profilo non può essere aggiornata",
                "updateUserProfileSuccessful": "Profilo aggiornata con successo"
            },
            "all": "Tutti",
            "allNotificationsRead": "Mostra tutto come letto",
            "amount": "Cifra",
            "and": "e",
            "applicants": "Candidato",
            "application": {
                "completed": "Candidature terminate",
                "completedInfo": "Si prega di inserire il testo qui",
                "label": "Candidature",
                "noEntries": "Le sue candidature sono disponibili qui",
                "ongoing": "Candidature aperte",
                "ongoingInfo": "Si prega di inserire il testo qui"
            },
            "applicationAs": "Candidatura per",
            "applicationDetails": "Dettagli della candidatura",
            "applicationDocuments": "Documentazione di candidatura",
            "applicationDocumentsSubtitle": "Curriculum vitae, lingue, certificati",
            "applicationLetter": "Lettera di candidatura",
            "applicationStatus": {
                "CONTRACTSENT": "Contratto di lavoro inviato",
                "CONTRACTSIGNED": "Confermare",
                "DRAFT": "Bozza",
                "INTERVIEW": "Invitare a colloquio di lavoro",
                "READ": "Letto",
                "REFUSAL": "Cancellazione",
                "REFUSALEMPLOYEE": "Cancellazione da parte dei candidati",
                "SENT": "Candidatura presentata",
                "change": "Cambiare lo status della candidatura"
            },
            "applications": "Candidature",
            "appliedForOn": "Candidatura del",
            "apply": "Càndidati",
            "april": "Aprile",
            "archived": "Archiviato",
            "association": "L'associazione Mitarbeiter-Sharing",
            "attachedFiles": "File allegati",
            "attentionNoCurrentJob": "Non dimenticarsi di inserire il lavoro corrente, potrebbe portare a un pacchetto di lavoro estivo-invernale.",
            "attentionNoLetter": "Attenzione: non avete inserito nessuna lettera di candidatura.",
            "attentionShortLetter": "Attenzione: la vostra lettera di candidatura è molto corta, molto datori preferiscono sia più lunga.",
            "august": "Agosto",
            "automaticallyAddedOnReceiptOfJob": "Questa voce è stata aggiunta automaticamente perché il datore di lavoro l'ha confermata.",
            "avamCodeHelp": {
                "description": "Jobs2share richiede l'esatta assegnazione del lavoro dell'annuncio di lavoro. Alcune professioni sono soggette a registrazione e devono essere segnalate agli Uffici regionali di collocamento (URC) prima della pubblicazione.",
                "moreInformation": "Ulteriori informazioni sulle attività e le competenze si trovano nel",
                "ricac": "Referenziale intercantonale romando sulle attività e le competenze.",
                "title": "Aiuto Titolo di lavoro"
            },
            "back": "indietro",
            "backtoOverview": "Indietro alla panoramica",
            "billingCycle": "Ciclo di fatturazione",
            "birthday": "Compleanno",
            "buySubscription": "Acquista abbonamento",
            "callOff": "Lettera di rifiuto",
            "cancel": "Interrompere",
            "cancelSubmitApplication": "Indietro",
            "cancelSubscription": "Annulla",
            "category": "Categoria",
            "certificate": "Altro",
            "changeCreditCard": "Cambia carta di credito",
            "changeSubscription": "Cambiare abbonamento",
            "chargesUp": "In caricamento",
            "choose": "Scegliere",
            "chooseAddon": "Scegliere abbonamento aggiuntivo",
            "chooseCompany": "Scegliere una ditta",
            "chooseReason": "La preghiamo di scegliere un motivo:",
            "chooseSubscription": "Scegliere la categoria dell'abbonamento",
            "closure": "Chiusura",
            "comletedApplicationsTablePlaceholder": "Qui appariranno le candidature completate",
            "company": {
                "image": "Foto significativa della vostra azienda",
                "label": "Azienda",
                "maps": "Posizione Google Maps",
                "profile": {
                    "general": "Profilo aziendale",
                    "general-info": "Sede, slogan e descrizione",
                    "images": "Logo e foto",
                    "images-info": "Completi il suo profilo con logo e foto",
                    "images-size-info": "Dimensione raccomandata: larghezza 800px e altezza 230px",
                    "images-type-info": "Tipi di file permessi: JPG, PNG, GIF",
                    "settings": "Impostazioni"
                },
                "sizes": {
                    "big": "> 81 dipendenti",
                    "medium": "31 - 80 dipendenti (numero massimo durante l'alta stagione)",
                    "micro": "Fino a 10 dipendenti (numero massimo durante l'alta stagione)",
                    "small": "11 - 30 dipendenti (numero massimo durante l'alta stagione)"
                },
                "uploadLogo": "Clicchi qui per caricare un altro logo"
            },
            "companyAlreadyExists": "Questa azienda è già stata registrata.",
            "completeCompanyProfile": "Si prega di completare il profilo della sua ditta:",
            "completeEmployeeProfile": "Le voci relative all'esperienza professionale possono essere aggiunte solo con un profilo completo.",
            "completeProfile": "Completare il profilo",
            "completed": "Completato",
            "confirm": "Confermare",
            "confirmDeleteJobApplication": "Sì, desidero eliminare la candidatura",
            "confirmMessage": "Vuole davvero eseguire questa azione?",
            "confirmSubmitApplication": "Invia applicazione",
            "confirmSubscriptionSelection": "Confermo che la ditta selezionata non supererà il numero massimo di dipendenti ammessi nell'abbonamento durante l'alta stagione.",
            "contact": "Contatto",
            "contactDetails": "Dati di contatto",
            "contactPerson": "Persona di contatto",
            "cook": "Cuoco/cuoca",
            "cooperation": "Cooperazione / cooperazioni",
            "cooperationAgreement": "Accordo di cooperazione |Accordi di cooperazioni",
            "cooperationAgreementInvalid": "Accordo di cooperazione nullo",
            "cooperationAgreementPdf": {
                "at": "a",
                "currentWorkingPermit": "Permesso di lavoro attuale",
                "duration": "Tempi dei contratti stagionali",
                "end": "Fine",
                "information": "i collaboratori con domicilio o residenza settimanale nei cantoni Grigioni e Ticino possono presentare al URC responsabile il contratto di cooperazione e il contratto di lavoro stagionale per la stagione successiva come prova per beneficiare delle disposizioni speciali dell'URC secondo il progetto pilota \"Mitarbeiter-Sharing\" della SECO. Esso viene creato automaticamente tramite la piattaforma di condivisione dei dipendenti e mantiene la sua validità, dove i due datori di lavoro lo rilasciano. è la responsabilità del dipendente consegnare il documento al URC responsabile prematura.",
                "integratedPart": "Il presente accordo di cooperzazione è parte integrante suppletiva dei singoli contratti di lavoro stipulati tra",
                "intentionText": "L’accordo di cooperazione palesa l’intenzione delle tre parti coinvolte di proseguire la collaborazione oltre la stagione attuale. I due datori di lavoro confermano l’intenzione di sostenere insieme, nei limiti delle loro possibilità, durante e oltre la singola stagione la collaboratrice / il collaboratore nella sua personale crescita professionale. L’accordo di cooperazione si basa su due contratti di lavoro validi: contratto di lavoro stagionale attualmente in corso e contratto di lavoro stagionale per la stagione successiva.",
                "mainResidence": "Domicilio",
                "onlineVerification": "Verifica online",
                "position": "Mansione/Impiego",
                "scanInfo": "Per verificare la validità di questo accordo di cooperazione, si prega di scansionare il seguente codice QR.",
                "start": "Inizio"
            },
            "cooperationAgreementValid": "Accordo di cooperazione in vigore",
            "copy": "Copiare",
            "corona": {
                "alertText": "Notizie sulla situazione attuale",
                "bag": "Ufficio federale della sanità pubblica UFSP",
                "hotelleriesuisseGrisons": "Hotelleriesuisse Graubünden",
                "hotelleriesuisseTicino": "Hotelleriesuisse Ticino",
                "text": "<p>A causa della situazione attuale, in molte delle nostre aziende partner si riscontrano ritardi nella pianificazione. Le nostre aziende fanno ogni sforzo per aggiornare costantemente le loro posti vacanti.</p><p>Grazie mille per la vostra pazienza, presto potrete candidarvi per interessanti lavori stagionali!</p><p>Auguriamo a tutti i dipendenti stagionali e alle aziende una buona salute.</p><p>Il vostro team di Jobs2share.ch e l'associazione Mitarbeiter-Sharing.</p>",
                "usefulInformation": "Qui potete trovare informazioni utili:"
            },
            "correctDeclinedJobEntry": "Verifica l'iscrizione e fallo confermare dal tuo datore di lavoro. L'occupazione confermata porta a pacchetti di lavoro e si beneficia di molti vantaggi.",
            "count": "Numero",
            "country": "Nazione",
            "coupon": "Buono",
            "couponCode": "Numero di buono",
            "create": "Crea",
            "createdOn": "Creato il",
            "creditCard": "Carta di credito",
            "creditCardEndsWith": "La carta di credito finisce con",
            "creditcardInvalid": "Si prega di aggiungere una carta di credito valida.",
            "currentJob": "Impiego attuale",
            "dashboard": {
                "applicationDescription": "Domande di lavoro aperte: Si prega di accettare o rifiutare!",
                "assignmentDescription": "Queste persone attualmente lavorano per Voi o lavoreranno per Voi in futuro? Si prega di confermare.",
                "jobsDescription": "Panoramica dei suoi annunci di lavoro attive",
                "label": "Dashboard",
                "reenterDescription": "Quali dei suoi dipendenti ritorneranno? Aggiorni lo stato e aiuti i suoi dipendenti a riunire i loro lavori estivi/invernali in anticipo!"
            },
            "date": "Data",
            "day": "Giorno|Giorni",
            "december": "Dicembre",
            "decline": "Rifiutare",
            "declineEmployeeTypes": {
                "DATE": "Il periodo è sbagliato",
                "OTHER": "Altre motivazioni",
                "TITLE": "La descrizione del posto di lavoro non è corretta",
                "UNKNOWN": "Non conosciamo il nome"
            },
            "declineRequest": "Rifiutare richiesta",
            "delete": "Cancellare",
            "deleteCompany": "Cancellare la ditta",
            "deleteCompanyQuestion": "Desidera veramente cancellare questa ditta?",
            "deleteDefinitely": "Elimina definitivamente",
            "deleteEntry": "Elimina la voce",
            "deleteEntryInfo": "Questo lavoro fa parte di un pacchetto di lavori e di un contratto di cooperazione e non può essere modificato o cancellato. È stato confermato dal datore di lavoro. Con il pulsante \"Segnala errore\" potete informarci se qualcosa non è corretto.",
            "deleteEntryQuestion": "Vuole veramente cancellare questa voce?",
            "deleteJob": "Elimina annuncio di lavoro",
            "deleteJobApplication": "Cancellare la domanda di lavoro",
            "deleteJobApplicationSuccessful": "L'applicazione è stata eliminata con successo.",
            "deleteJobQuestion": "Desidera veramente eliminare definitivamente questo annuncio?",
            "deletePermanently": "Elimina definitivamente",
            "deleteProfile": "Eliminia profilo",
            "deleteProfilePicture": "Eliminare foto di profilo",
            "deleteProfileQuestion": "Desidera veramente cancellare il suo profilo?",
            "description": "Descrizione",
            "details": "Dettagli",
            "directCall": "Numero diretto",
            "displayContract": "Mostra contratto",
            "domesticEconomy": "Economia domestica",
            "draft": "Bozza",
            "duration": "Durata",
            "duringPeakSeason": "Durante la stagione principale",
            "edit": "Modificare",
            "editAddon": "Modificare abbonamento aggiuntivo",
            "editCertificate": "Modificare voce",
            "editEducation": "Modifica formazione",
            "editExperience": "Modifica esperienza di lavoro",
            "editJob": "Modifica annuncio di lavoro",
            "editLanguage": "Modifica lingua",
            "editOtherDocument": "Elaborare documento",
            "editSubscription": "Cambiare abbonamento",
            "editorPlaceholder": "Inserisca il testo qui",
            "education": "Formazione",
            "email": "E-mail",
            "employee": {
                "all": "Tutti dipendenti",
                "assignment": "Confermare rapporto di lavoro",
                "assignmentInfo": "Si prega di inserire il testo qui",
                "edit": "Modificare rapporto di lavoro",
                "employed": "Attualmente impiegato",
                "employedInfo": "Si prega di inserire il testo qui",
                "employmentChange": "Cambiare lavoro",
                "employmentDidNotTakeUp": "Il dipendente non ha iniziato il lavoro",
                "employmentTerminated": "L'occupazione è stata eliminata",
                "employmentWillNotTakeUp": "Il dipendente non inizierà il lavoro",
                "former": "Ex dipendenti",
                "formerInfo": "Si prega di inserire il testo qui",
                "future": "Assunto in futuro",
                "futureInfo": "Si prega di inserire il testo qui",
                "label": "Dipendenti",
                "noEntries": "Nessun dipendente trovato"
            },
            "employeeInfo": "Attualmente possono registrarsi solo le aziende",
            "employeeReEnter": {
                "APPROVE": "Il dipendente ritorneranno da noi",
                "DECLINE": "Il dipendente non ritorneranno da noi",
                "label": "Rientro"
            },
            "employeeTitle": "Collaboratore|Collaboratrice",
            "employees": "Dipendente",
            "emptyJobs": "Non è stato inserito ancora alcun annuncio",
            "end": "Fine",
            "endMonth": "Mese finale",
            "endOfTraining": "Fine formazione",
            "endOfWork": "Fine impiego",
            "english": "English",
            "enterDateOfBirth": "Inserire la data di nascita",
            "entriesPerPage": "Voci per pagina",
            "error": "Errore",
            "errorMessage": "Si è verificato un errore. La preghiamo di segnalarci tale errore utilizzando il pulsante «Segnala errore»",
            "favorites": "Preferiti",
            "february": "Febbraio",
            "feedback": "Feedback",
            "filename": "Nome file",
            "filter": "Filtro",
            "finishRegistration": "Concludi registrazione",
            "firstName": "Nome",
            "forgotPassword": "Password dimenticata",
            "french": "Francese",
            "fullTime": "A tempo pieno",
            "functionNotAvailable": "Questa funzione non è ancora disponibile",
            "functionOnlyLoggedInAvailable": "Questa funzione è disponibile solo da iscritti",
            "garden": "Giardino",
            "german": "Tedesco",
            "help": "Aiuto",
            "home": "Home",
            "hotelCategory": "Categoria di hotel",
            "imageUploadInfo": "Carica immagine (memorizzata automaticamente)",
            "impress": "Informazione legale",
            "info": {
                "label": "Informazione",
                "noFavorites": "Non ha selezionato alcun annuncio di lavoro come preferiti."
            },
            "insertJobtitle": "Denominazione impiego",
            "insertPassword": "Inserire la password",
            "interruption": "Interruzione",
            "introduction": "Introduzione",
            "invalidCredentials": "Ente emittente",
            "invoice": {
                "address": "Destinatario",
                "after": "dopo il",
                "alreadyPaid": "Il pagamento è stato caricato sulla carta di credito.",
                "date": "Data della fattura",
                "footer": "Associazione Mitarbeiter-Sharing, c/o Fachhochschule Graubünden, Comercialstrasse 22, 7000 Chur",
                "info": {
                    "monthly": "La fatturazione avviene mensilmente. È possibile cancellare l'abbonamento annuale nell'ultimo mese del periodo.",
                    "yearly": "La fatturazione avviene annualmente. È possibile cancellare l'abbonamento annuale nell'ultimo mese del periodo."
                },
                "number": "Numero della fattura",
                "offcoupon": "sconto con buono",
                "on": "in abbonamento",
                "remainingTime": "Tempo rimanente",
                "title": "Fattura",
                "unitPrice": "Prezzo al pezzo",
                "unusedTime": "Tempo non utilizzato"
            },
            "issuingAuthority": "Autorità emittente",
            "italian": "Italiano",
            "janitor": "Servizio di casa",
            "january": "Gennaio",
            "job": "Annuncio di lavoro",
            "jobActive": "L'annuncio di lavoro è attivo",
            "jobAdvertisementsOnlyWithValidSubscription": "Gli annunci di lavoro per un'azienda sono attivi solo con un abbonamento corrente.",
            "jobApproved": "Confermato dalla ditta {company}",
            "jobCategory": {
                "1": "Cucina",
                "2": "Servizio",
                "3": "Reception e amministrazione",
                "4": "Economia domestica",
                "5": "Benessere, bellezza, salute, sport",
                "6": "Tecnica, manutenzione, giardino",
                "7": "Altro",
                "label": "Categoria"
            },
            "jobDeclined": "Da {company} annullato",
            "jobEntryDate": "Inizio impiego",
            "jobExitDate": "Fine impiego",
            "jobLanguage": "Lingua dell'annuncio di lavoro",
            "jobNotifiedApproved": "Lavoro già segnalato e rilasciato",
            "jobOverPlatform": "Trova un lavoro tramite jobs2share",
            "jobPosition": {
                "1": "Formazione",
                "2": "Tirocinio",
                "3": "Addestrato/a",
                "4": "Specialista",
                "5": "Dirigente",
                "label": "Posizione"
            },
            "jobRoomWaitingActivation": "L'annuncio di lavoro è in attesa di attivazione da parte del Jobroom.",
            "jobSearch": "Ricerca di lavoro",
            "jobStatus": {
                "CANCELLED": "Cancellato",
                "INSPECTING": "In revisione",
                "PUBLISHED_PUBLIC": "Pubblicato",
                "PUBLISHED_RESTRICTED": "Periodo di restrizione",
                "REJECTED": "Respinto",
                "UNSYNCRONIZED": "Non sincronizzato"
            },
            "jobTitle": "Annunci di lavoro",
            "jobTitleAvam": "Professione (Avam)",
            "jobroomConfirmationPending": "Conferma del Jobroom in attesa",
            "jobs": "Annunci di lavoro",
            "jobsTableNoEntries": "Nessun annuncio di lavoro registrato",
            "jobsTablePlaceholder": "Qui appaiono i suoi annunci di lavoro",
            "july": "Luglio",
            "june": "Giugno",
            "kitchen": "Cucina",
            "label": "Denominazione",
            "language": {
                "ar": "Arabo",
                "cs": "Ceco",
                "da": "Danese",
                "de": "Tedesco",
                "el": "Greco",
                "en": "Inglese",
                "es": "Spagnolo",
                "fi": "Finlandese",
                "fr": "Francese",
                "he": "Ebraico",
                "hu": "Ungherese",
                "it": "Italiano",
                "ja": "Giapponese",
                "ko": "Coreano",
                "label": "Lingua|Lingue",
                "nl": "Olandese",
                "no": "Norvegese",
                "pl": "Polacco",
                "pt": "Portoghese",
                "ro": "Rumeno",
                "ru": "Russo",
                "sv": "Svedese",
                "sì": "Singhalesi",
                "tr": "Turco",
                "yes": "Armeno",
                "zh": "Cinese"
            },
            "lastActivity": "Ultima attività",
            "lastName": "Cognome",
            "line": "Riga|Righe",
            "locality": "Località",
            "lodging": "Alloggi disponibili",
            "login": "Login",
            "logo": "Logo",
            "logout": "Logout",
            "mainScubscription": "Abbonamento principale",
            "mainSubscriptionShort": "Abbonamento principale",
            "maintenanceText": "Jobs2share.ch è attualmente disponibile solo in misura limitata",
            "manager": "Dirigente",
            "march": "Marzo",
            "maxDurationSeasonJobInfo": "È possibile inserire solo lavori stagionali. La durata massima d'un impiego stagionale è di 9 mesi",
            "maximalDurationExceeded": "La durata massima di 9 mesi è stata superata",
            "may": "Maggio",
            "message": "Messaggio",
            "months": {
                "1": "Gennaio",
                "10": "Ottobre",
                "11": "Novembre",
                "12": "Dicembre",
                "2": "Febbraio",
                "3": "Marzo",
                "4": "Aprile",
                "5": "Maggio",
                "6": "Giugno",
                "7": "Luglio",
                "8": "Agosto",
                "9": "Settembre",
                "label": "Mese|Mesi"
            },
            "moreInformation": "Ulteriori informazioni",
            "moreInformations": "Maggiori Informazioni",
            "motto": "Slogan",
            "mustBeInFuture": "La data non deve essere passata",
            "myJobs": "I miei lavori",
            "myJobsIntro": "Qui è possibile inserire le tappe più importanti della sua carriera attuale e futura. <br>Le posizioni attuali sono particolarmente importanti perché sono confermate dal datore di lavoro e possono portare a un pacchetto di lavoro estivo/invernale.",
            "name": "Nome",
            "nameOfCertificate": "Titolo",
            "nameOfCompany": "Nome dell’azienda",
            "nameOfDocument": "Titolo",
            "nationality": "Nazionalità",
            "neither": "Nessuno",
            "newJob": "Nuovo annuncio",
            "newNotifications": "Nuove notifiche",
            "news": "Notizie",
            "next": "avanti",
            "nextCharge": "Prossimo carico",
            "no": "No",
            "noAccountYet": "Non c'è ancora un account?",
            "noActiveApplications": "Nessuna candidatura aperta",
            "noCompaniesAddedYet": "Non è stata ancora aggiunta alcuna azienda",
            "noCompanyWithoutSubscription": "Nessuna azienda senza abbonamento disponibile",
            "noCompletedApplications": "Nessuna candidatura completata",
            "noCooperationAgreements": "Qui saranno presentati gli accordi di cooperazione dei loro dipendenti",
            "noCooperationIdenticalCompany": "Attenzione: {company} è già registrata nel tuo profilo come tuo precedente datore di lavoro. La tua candidatura non costituirà un pacchetto di lavoro.",
            "noEndDate": "Nessuna data di scadenza",
            "noExpirationDate": "Nessuna data di terminazione",
            "noNotifications": "Nessuna notifica",
            "noResults": "Non sono stati trovati annunci confacenti",
            "noSearchEntries": "Nessun risultato alla sua ricerca",
            "noSubjectToRegistration": "Nessun obbligo di notifica",
            "notifications": {
                "applicationOpenReminder": {
                    "message": "Lei ha impiegato {first_name} {last_name}? Si prega di aggiornare lo stato delle domande ricevute"
                },
                "applicationOpenReminderPart1": "Lei ha",
                "applicationOpenReminderPart2": "Impiegato? Si prega di aggiornare lo stato delle domande ricevute",
                "applicationReceived": {
                    "message": "Nuova candidatura"
                },
                "companyLinkedToResumeJob": {
                    "message": "{first_name} {last_name} ha registrato la sua azienda nel suo curriculum vitae. Controllare la voce."
                },
                "cooperationAgreementChanged": {
                    "message": "Sono state apportate modifiche all'accordo di cooperazione con {company1} e {company2}"
                },
                "resumeJobEntryChanged": {
                    "message": "Sono state apportate modifiche al sua posizione come {job_title} presso {company}"
                }
            },
            "november": "Novembre",
            "numberOfEmployees": "Numero d'impiegati",
            "numberOfJobs": "Numero di posti vacanti",
            "october": "Ottobre",
            "of": "dal",
            "oldNotifications": "Notifiche precedenti",
            "onlyForEmployees": "Solo per dipendenti",
            "onlyForEmployeesText": "Questa funzione è disponibile solo per gli impiegati.",
            "open": "Aperto",
            "openAccount": "Crea account",
            "other": "Altro",
            "otherDocuments": "Altri documenti",
            "password": "Password",
            "passwordConfirmation": "Ripetere la password",
            "passwordResetFailed": "Non è stato possibile reimpostare la password",
            "passwordResetInfo": "Riceva un'e-mail per reimpostare la password",
            "passwordResetSuccessful": "La password è stata resettata",
            "paymentPeriod": "Ciclo di pagamento",
            "perMonth": "Per mese",
            "perYear": "Per anno",
            "percent": "Percentuale",
            "percentMax": "Percentuale massima",
            "percentMin": "Percentuale minima",
            "personalResponsibility": "Responsabile del personale",
            "phone": "Numero di telefono",
            "place": "Luogo",
            "platformName": "jobs2share",
            "pleaseLogIn": "Prego si iscriva",
            "preview": "Anteprima",
            "price": "Prezzo",
            "pricePerMonth": "Prezzo mensile",
            "pricePerYear": "Prezzo annuale",
            "product": "Prodotto",
            "proficiency": {
                "1": "Conoscenze di base",
                "2": "Buona conoscenza",
                "3": "Ottima conoscenza",
                "4": "Madrelingua",
                "label": "Padronanza della lingua"
            },
            "profile": "Profilo",
            "profilePicture": "Foto del profilo",
            "profilePicture-size-info": "Dimensione raccomandata: larghezza 500px e altezza 500px",
            "publishedOm": "Pubblicato il",
            "questionDeleteJobApplication": "Desidera eliminare definitivamente la candidatura?",
            "questionSubmitApplication": "Desidera inviare ufficialmente la candidatura?",
            "questionsToCompany": "In caso di domande, si prega di contattare direttamente la ditta di cooperazione",
            "reason": "Motivazione",
            "reasonDetail": "Motivazione dettagliata",
            "receipt": "Ricevuta",
            "reception": "Reception",
            "redeemCoupon": "Riscatta il buono",
            "redeemCouponDescription": "Riscatta il codice del buono per l'abbonamento selezionato",
            "refreshlocation": "Aggiornare la posizione",
            "register": "Registrarsi",
            "registerNow": "registrarsi ora",
            "registration": "Registrazione",
            "rejectDeleteJobApplication": "No, desidero conservare la candidatura",
            "removeCompany": "Cancellare impresa",
            "removeCompanyText": "Sei sicuro di voler rimuovere la società \"{companyName}\"? Tutte le offerte di lavoro pubblicate da questa azienda saranno disabilitate durante questo processo",
            "removeFavoriteSuccessful": "L'annuncio è stato cancellato come favorito con successo",
            "renewJobs": "Aggiornare gli annunci",
            "reportError": "Annunciare errore",
            "reportProblem": "Annunciare problema",
            "resetFilter": "Reset filtro",
            "resetPassword": "Reset password",
            "residencePermit": {
                "B": "B: permesso di soggiorno",
                "C": "C: permesso di dimora",
                "G": "G: pendolari transfrontalieri",
                "L": "L: permesso di soggiorno di breve durata",
                "label": "Permessi di soggiorno"
            },
            "results": "Risultati",
            "resume": "Curriculum vitae",
            "rowsPerPage": "Linee per pagina",
            "salutation": "Appellativo",
            "salutationMr": "Signor",
            "salutationMrText": "Egregio Signor",
            "salutationMrs": "Signora",
            "salutationMrsText": "Gentile Signora",
            "salutationText": "Buongiorno",
            "save": "Salva",
            "saveAsDraft": "Salva come bozza",
            "saveChanges": "Salva le modifiche",
            "search": "Ricerca",
            "searchCompany": "Cercare la propria azienda",
            "searchResults": "Risultati della ricerca",
            "season": "Stagione",
            "seasonalJob": "Impiego stagionale",
            "seasonalJobEndDateAfter": "Impiego stagionale con fine dopo il {date}",
            "seasonalJobEndDateBefore": "Impiego stagionale con fine prima del {date}",
            "selectBillingCycle": "Selezionare il ciclo di fatturazione per prolungare automaticamente l'abbonamento.<br>\nGrazie mille per la vostra fiducia!",
            "selectFile": "Seleziona file",
            "semiskilled": "Addestrato/a",
            "send": "Inviare",
            "sent": "Inviata",
            "september": "Settembre",
            "service": "Servizio",
            "shortDescription": "Descrizione breve",
            "show": "Visualizzare",
            "showAll": "Mostrare tutto",
            "showAllNotifications": "Mostrare tutte le notifiche",
            "showAndEdit": "Display e modificare",
            "showApplication": "Visualizzare l'applicazione",
            "skilledEmployee": "Specialista",
            "slogan": "Jobs2share<br>Lavori stagionali con una prospettiva per tutto l'anno",
            "star": "Stelle|Stella",
            "start": "Inizio",
            "startMonth": "Mese iniziale",
            "startOfTraining": "Inizio formazione",
            "startOfWork": "Inizio impiego",
            "status": "Stato",
            "street": "Via",
            "streetNumber": "N° civico",
            "subject": "Oggetto",
            "subjectToRegistration": "soggetto a registrazione",
            "submitApplication": "Invia candidatura",
            "submitApplicationSuccessful": "Candidatura inviata correttamente con sucesso",
            "subscription": "Abbonamento",
            "subscriptionFreeExtension": "(Prolungamento gratuito dell'abbonamento per {0} giorni)",
            "subscriptionInfoDialog": {
                "label": "Informazioni dell'abbonamento",
                "link": "qui.",
                "text": "È possibile gestire molteplici aziende nel proprio account. Sceglie \"Aggiungi abbonamento principale\" e acquista un abbonamento aggiuntivo al prezzo normale. In caso di abbonamenti principali nella categoria \"Grande\", potete acquistare un abbonamento a un prezzo speciale di soli CHF 24.90 / mese per ogni altra azienda del vostro conto. Se desiderate approfittare di questa interessante offerta, selezionate \"Aggiungi ulteriore abbonamento\". Ulteriori informazioni sugli abbonamenti sono disponibili {0}"
            },
            "subscriptionInformation": "Informazioni dell'abbonamento",
            "subscriptionPeriod": "Periodo di sottoscrizione",
            "subscriptionRenewOn": "L'abbonamento è esteso il",
            "subscriptionRenewOnInfoText": "Avete cambiato l'abbonamento il {0} ed esteso il vostro abbonamento.",
            "subscriptionRequiredText": "Gli annunci saranno pubblicati solo con un abbonamento valido",
            "subscriptionShort": "Abbonamento",
            "subscriptionTerminateDialog": {
                "hasActiveAdditionalCompanies": "Questo abbonamento ha ulteriori aziende attive e non può essere annullato.<br>Si prega di annullare prima le aziende aggiuntive.",
                "info": "Dopo la cancellazione, le seguenti opzioni non saranno più disponibili dopo il {0}.",
                "intro": "Vuole cancellare l'abbonamento per la seguente azienda?",
                "options": "<ul>\n<li>Pubblicare annunci di lavoro</li>\n<li>Ricevere candidature</li>\n<li>Accettare dipendenti</li>\n</ul>"
            },
            "subscriptionTerminatedOn": "L'abbonamento verrà cancellato per",
            "subscriptions": {
                "additional": "Abbonamento aggiuntivo",
                "base": "Categoria abbonamento principale",
                "large": "Grande",
                "largeText": "Per le aziende con più di 81 dipendenti",
                "micro": "Micro",
                "microText": "Per le aziende fino a un massimo di 10 dipendenti",
                "middle": "Medio",
                "middleText": "Per le aziende con tra 31-80 dipendenti",
                "small": "Piccolo",
                "smallText": "Per le aziende con tra 11 e 30 dipendenti"
            },
            "successful": "con successo",
            "summary": "Riassunto",
            "summer": "Estate",
            "survey": "Panoramica",
            "tableNoEntries": "No voci",
            "technique": "Tecnica e manutenzione",
            "temporary": "Ausiliario/a",
            "terminate": "Terminare",
            "terminated": "Cancellato",
            "testing": "Verifica",
            "title": "Titolo",
            "titleJob": "Titolo dell'annuncio di lavoro",
            "to": "al",
            "toJob": "Vai all’ annuncio",
            "toTheActiveApplications": "Vai alle candidature attive",
            "today": "Oggi",
            "training": "Tirocinio",
            "trainingFacility": "Centro di formazione",
            "type": "Tipo",
            "typeCompany": "Sono un’azienda",
            "typeEmployee": "Sono un privato",
            "typeQuestion": "Desidera registrarsi come privato o come azienda?",
            "typeYourPassword": "Imettere password",
            "understood": "Capito",
            "unlimitedPosition": "Lavoro indeterminato",
            "updateApplication": "Aggiornare status",
            "updateCreditCard": "Aggiornate la carta di credito",
            "updateDraft": "Aggiorna bozza",
            "uploadProfilePicture": "Aggiungi immagine del profilo da caricare<br>(Max 5 MB)",
            "uploading": "Caricare",
            "url": "URL",
            "userData": "Dati utente",
            "username": "Nome utente",
            "validityOf": "Validità da",
            "validityUntil": "Validità fino a",
            "value": "Valore",
            "website": "Sito web",
            "wellness": "Benessere, bellezza, salute",
            "what": "Di che cosa si tratta",
            "whatToChange": "Cosa desidera cambiare?",
            "winter": "Inverno",
            "withoutJobAdvertisement": "Senza annuncio di lavoro",
            "workExperience": "Esperienza di lavoro",
            "workload": "Carico di lavoro (%)",
            "workplace": "Impiego",
            "year": "Anno",
            "yes": "Si",
            "yourConcern": "Vostro messaggio",
            "zip": "CAP"
        }
    }
}
